/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ 272: /***/ (
      __unused_webpack_module,
      __webpack_exports__,
      __webpack_require__
    ) => {
      "use strict";

      // EXPORTS
      __webpack_require__.d(__webpack_exports__, {
        gM: () => /* binding */ MinimogLibs,
        LE: () => /* binding */ MinimogTheme,
      }); // CONCATENATED MODULE: ./src/js/utilities/events.js

      // UNUSED EXPORTS: MinimogEvents, MinimogSettings, MinimogStrings

      class Event {
        constructor() {
          this.events = {};
        }
        get evts() {
          return Object.keys(this.events);
        }
        subscribe(event, handler) {
          this.events[event] = this.events[event] || [];
          this.events[event].push(handler);
          return () => this.unSubscribe(event, handler);
        }
        unSubscribe(event, handler) {
          const handlers = this.events[event];
          if (handlers && Array.isArray(handlers)) {
            for (let i = 0; i < handlers.length; i++) {
              if (handlers[i] === handler) {
                handlers.splice(i, 1);
                break;
              }
            }
          }
        }
        emit(event, ...args) {
          console.groupCollapsed(`Event emitted: ${event}`);
          console.trace();
          console.groupEnd();
          (this.events[event] || []).forEach((handler) => {
            handler(...args);
          });
        }
      }
      // EXTERNAL MODULE: ./src/js/libs/loadjs.js
      var loadjs = __webpack_require__(280); // CONCATENATED MODULE: ./src/js/global.js
      window.MinimogEvents = window.MinimogEvents || new Event();
      window._ThemeEvent = window.MinimogEvents;
      window.MinimogLibs.loadjs = __loadjs;
      const MinimogEvents = window.MinimogEvents;
      const MinimogTheme = window.MinimogTheme || {};
      const MinimogSettings = window.MinimogSettings || {};
      const MinimogStrings = window.MinimogStrings || {};
      const MinimogLibs = window.MinimogLibs || {};

      /***/
    },

    /***/ 280: /***/ () => {
      __loadjs = (function () {
        var h = function () { },
          c = {},
          u = {},
          f = {};
        function o(e, n) {
          if (e) {
            var r = f[e];
            if (((u[e] = n), r)) for (; r.length;) r[0](e, n), r.splice(0, 1);
          }
        }
        function l(e, n) {
          e.call &&
            (e = {
              success: e,
            }),
            n.length ? (e.error || h)(n) : (e.success || h)(e);
        }
        function d(r, t, s, i) {
          var c,
            o,
            e = document,
            n = s.async,
            u = (s.numRetries || 0) + 1,
            f = s.before || h,
            l = r.replace(/[\?|#].*$/, ""),
            a = r.replace(/^(css|img)!/, "");
          (i = i || 0),
            /(^css!|\.css$)/.test(l)
              ? (((o = e.createElement("link")).rel = "stylesheet"),
                (o.href = a),
                (c = "hideFocus" in o) &&
                o.relList &&
                ((c = 0), (o.rel = "preload"), (o.as = "style")))
              : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(l)
                ? ((o = e.createElement("img")).src = a)
                : (((o = e.createElement("script")).src = r),
                  (o.async = void 0 === n || n)),
            !(o.onload =
              o.onerror =
              o.onbeforeload =
              function (e) {
                var n = e.type[0];
                if (c)
                  try {
                    o.sheet.cssText.length || (n = "e");
                  } catch (e) {
                    18 != e.code && (n = "e");
                  }
                if ("e" == n) {
                  if ((i += 1) < u) return d(r, t, s, i);
                } else if ("preload" == o.rel && "style" == o.as)
                  return (o.rel = "stylesheet");
                t(r, n, e.defaultPrevented);
              }) !== f(r, o) && e.head.appendChild(o);
        }
        function r(e, n, r) {
          var t, s;
          if ((n && n.trim && (t = n), (s = (t ? r : n) || {}), t)) {
            if (t in c) throw "LoadJS";
            c[t] = !0;
          }
          function i(n, r) {
            !(function (e, t, n) {
              var r,
                s,
                i = (e = e.push ? e : [e]).length,
                c = i,
                o = [];
              for (
                r = function (e, n, r) {
                  if (("e" == n && o.push(e), "b" == n)) {
                    if (!r) return;
                    o.push(e);
                  }
                  --i || t(o);
                },
                s = 0;
                s < c;
                s++
              )
                d(e[s], r, n);
            })(
              e,
              function (e) {
                l(s, e),
                  n &&
                  l(
                    {
                      success: n,
                      error: r,
                    },
                    e
                  ),
                  o(t, e);
              },
              s
            );
          }
          if (s.returnPromise) return new Promise(i);
          i();
        }
        return (
          (r.ready = function (e, n) {
            return (
              (function (e, r) {
                e = e.push ? e : [e];
                var n,
                  t,
                  s,
                  i = [],
                  c = e.length,
                  o = c;
                for (
                  n = function (e, n) {
                    n.length && i.push(e), --o || r(i);
                  };
                  c--;

                )
                  (t = e[c]),
                    (s = u[t]) ? n(t, s) : (f[t] = f[t] || []).push(n);
              })(e, function (e) {
                l(n, e);
              }),
              r
            );
          }),
          (r.done = function (e) {
            o(e, []);
          }),
          (r.reset = function () {
            (c = {}), (u = {}), (f = {});
          }),
          (r.isDefined = function (e) {
            return e in c;
          }),
          r
        );
      })();

      /***/
    },

    /***/ 295: /***/ (
      __unused_webpack_module,
      __webpack_exports__,
      __webpack_require__
    ) => {
      "use strict";
      /* harmony export */ __webpack_require__.d(__webpack_exports__, {
        /* harmony export */ Z: () => __WEBPACK_DEFAULT_EXPORT__,
        /* harmony export */
      });
      /* harmony import */ var mdn_polyfills_Node_prototype_append_js__WEBPACK_IMPORTED_MODULE_0__ =
        __webpack_require__(422);
      /* harmony import */ var mdn_polyfills_Node_prototype_append_js__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/ __webpack_require__.n(
          mdn_polyfills_Node_prototype_append_js__WEBPACK_IMPORTED_MODULE_0__
        );

      class JSX {
        constructor() {
          this.component = this.component.bind(this);
          return this.component;
        }
        component(tagName, attrs, ...children) {
          if (typeof tagName === "function") {
            // Override children
            return tagName({
              ...attrs,
              children,
            });
          }
          if (children) {
            children = children.filter((val) => val !== null);
          }
          if (attrs) {
            if (attrs.class) {
              attrs.className = attrs.class;
            }
            delete attrs.children;
          }

          // Normal DOM node tagName
          function createWithAttrs(tagName, attrs) {
            attrs = attrs || {};
            let elem = document.createElement(tagName);
            try {
              elem = Object.assign(elem, attrs);
            } catch {
              const attrKeys = Object.keys(attrs);
              for (let i = 0; i < attrKeys.length; i++) {
                if (attrs[i] !== "dataSet") {
                  elem.setAttribute(attrKeys[i], attrs[attrKeys[i]]);
                }
              }
            }
            return elem;
          }
          let elem =
            tagName !== "fragment"
              ? createWithAttrs(tagName, attrs)
              : document.createDocumentFragment();
          // Evaluate SVG DOM node tagName

          // All svg inner tags: https://developer.mozilla.org/en-US/docs/Web/SVG/Element
          const svgInnerTags = ["svg", "path", "rect", "text", "circle", "g"];
          if (svgInnerTags.indexOf(tagName) !== -1) {
            elem = document.createElementNS(
              "http://www.w3.org/2000/svg",
              tagName
            );
            for (const key in attrs) {
              const attrName = key === "className" ? "class" : key;
              elem.setAttribute(attrName, attrs[key]);
            }
          }

          // Populate children to created DOM Node
          for (const child of children) {
            if (Array.isArray(child)) {
              elem.append(...child);
            } else {
              elem.append(child);
            }
          }

          // After elements are created
          if (attrs !== null && attrs !== void 0 && attrs.dataSet) {
            for (const key in attrs.dataSet) {
              if (Object.prototype.hasOwnProperty.call(attrs.dataSet, key)) {
                elem.dataset[key] = attrs.dataSet[key];
              }
            }
          }
          if (attrs && !window.__aleartedJSXData) {
            if (Object.keys(attrs).find((key) => key.match(/^data-/))) {
              console.trace(
                `Your "${tagName}" component uses a data-* attribute! Use dataSet instead!!`
              );
              alert(
                "Do not use data-* in your JSX component! Use dataSet instead!! - Check the console.trace for more info"
              );
              window.__aleartedJSXData = true;
            }
          }
          if (attrs !== null && attrs !== void 0 && attrs.ref) {
            // Create a custom reference to DOM node
            if (typeof attrs.ref === "function") {
              attrs.ref(elem);
            } else {
              attrs.ref = elem;
            }
          }
          if (attrs !== null && attrs !== void 0 && attrs.on) {
            Object.entries(attrs.on).forEach(([event, handler]) => {
              elem.addEventListener(event, handler);
            });
          }

          // Append style attributes to created DOM node
          if (attrs !== null && attrs !== void 0 && attrs.style) {
            Object.entries(attrs.style).forEach(([property, value]) => {
              elem.style.setProperty(property, value);
            });
            // Object.assign(elem.style, attrs.style);
          }

          return elem;
        }
      }
      /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = new JSX();

      /***/
    },

    /***/ 367: /***/ function (module) {
      !(function (t, e) {
        true ? (module.exports = e()) : 0;
      })(this, function () {
        return (() => {
          "use strict";

          var t = {
            d: (e, o) => {
              for (var a in o)
                t.o(o, a) &&
                  !t.o(e, a) &&
                  Object.defineProperty(e, a, {
                    enumerable: !0,
                    get: o[a],
                  });
            },
            o: (t, e) => Object.prototype.hasOwnProperty.call(t, e),
            r: (t) => {
              "undefined" != typeof Symbol &&
                Symbol.toStringTag &&
                Object.defineProperty(t, Symbol.toStringTag, {
                  value: "Module",
                }),
                Object.defineProperty(t, "__esModule", {
                  value: !0,
                });
            },
          },
            e = {};
          function o(t, e) {
            for (var o = 0; o < e.length; o++) {
              var a = e[o];
              (a.enumerable = a.enumerable || !1),
                (a.configurable = !0),
                "value" in a && (a.writable = !0),
                Object.defineProperty(t, a.key, a);
            }
          }
          function a(t, e, a) {
            return (
              e && o(t.prototype, e),
              a && o(t, a),
              Object.defineProperty(t, "prototype", {
                writable: !1,
              }),
              t
            );
          }
          function n(t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          }
          function r(t, e, o) {
            return (
              e in t
                ? Object.defineProperty(t, e, {
                  value: o,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
                : (t[e] = o),
              t
            );
          }
          t.r(e),
            t.d(e, {
              default: () => s,
            });
          var i = {
            overlay: null,
            thickness: "3px",
            color: "gray",
            startDuration: 1e3,
            finishDuration: 300,
          },
            s = a(function t() {
              var e = this,
                o =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : document.body,
                a =
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
              n(this, t),
                r(this, "setLoadingData", function () {
                  var t = e.target,
                    o = e.options,
                    a = o.startDuration,
                    n = o.finishDuration,
                    r = o.thickness,
                    i = o.color;
                  t.style.setProperty("--al-thickness", " ".concat(r)),
                    t.style.setProperty("--al-color", " ".concat(i)),
                    t.style.setProperty(
                      "--al-start-duration",
                      " ".concat(a, "ms")
                    ),
                    t.style.setProperty(
                      "--al-finish-duration",
                      " ".concat(n, "ms")
                    );
                }),
                r(this, "start", function () {
                  e.target.classList.add("al-loading-bar", "start", "loading"),
                    e.overlay &&
                    e.overlay.classList.add(
                      "al-loading-overlay",
                      "overlay-show"
                    );
                }),
                r(this, "finish", function () {
                  var t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : function () { },
                    o = e.target,
                    a = e.overlay,
                    n = e.cleanUp,
                    r = e.options.finishDuration,
                    i = window.getComputedStyle(o, ":before").width;
                  o.style.setProperty("--al-end-width", i),
                    o.classList.add("loaded"),
                    o.classList.remove("loading"),
                    window.requestAnimationFrame(function () {
                      o.classList.add("finished"),
                        e.overlay && a.classList.remove("overlay-show");
                    }),
                    setTimeout(n, 2 * r),
                    setTimeout(t, r);
                }),
                r(this, "cleanUp", function () {
                  e.target.classList.remove(
                    "al-loading-bar",
                    "start",
                    "loaded",
                    "finished"
                  ),
                    e.overlay &&
                    e.overlay.classList.remove("al-loading-overlay");
                }),
                (this.options = Object.assign({}, i, a)),
                (this.target = o),
                (this.overlay = this.options.overlay),
                this.setLoadingData();
            });
          return e;
        })();
      });

      /***/
    },

    /***/ 422: /***/ () => {
      !(function () {
        function t() {
          var e = Array.prototype.slice.call(arguments),
            n = document.createDocumentFragment();
          e.forEach(function (e) {
            var t = e instanceof Node;
            n.appendChild(t ? e : document.createTextNode(String(e)));
          }),
            this.appendChild(n);
        }
        [
          Element.prototype,
          Document.prototype,
          DocumentFragment.prototype,
        ].forEach(function (e) {
          e.hasOwnProperty("append") ||
            Object.defineProperty(e, "append", {
              configurable: !0,
              enumerable: !0,
              writable: !0,
              value: t,
            });
        });
      })();

      /***/
    },

    /***/ 643: /***/ (module) => {
      var COMPLETE = "complete",
        CANCELED = "canceled";
      function raf(task) {
        if ("requestAnimationFrame" in window) {
          return window.requestAnimationFrame(task);
        }
        setTimeout(task, 16);
      }
      function setElementScroll(element, x, y) {
        Math.max(0, x);
        Math.max(0, y);
        if (element.self === element) {
          element.scrollTo(x, y);
        } else {
          element.scrollLeft = x;
          element.scrollTop = y;
        }
      }
      function getTargetScrollLocation(scrollSettings, parent) {
        var align = scrollSettings.align,
          target = scrollSettings.target,
          targetPosition = target.getBoundingClientRect(),
          parentPosition,
          x,
          y,
          differenceX,
          differenceY,
          targetWidth,
          targetHeight,
          leftAlign = align && align.left != null ? align.left : 0.5,
          topAlign = align && align.top != null ? align.top : 0.5,
          leftOffset = align && align.leftOffset != null ? align.leftOffset : 0,
          topOffset = align && align.topOffset != null ? align.topOffset : 0,
          leftScalar = leftAlign,
          topScalar = topAlign;
        if (scrollSettings.isWindow(parent)) {
          targetWidth = Math.min(targetPosition.width, parent.innerWidth);
          targetHeight = Math.min(targetPosition.height, parent.innerHeight);
          x =
            targetPosition.left +
            parent.pageXOffset -
            parent.innerWidth * leftScalar +
            targetWidth * leftScalar;
          y =
            targetPosition.top +
            parent.pageYOffset -
            parent.innerHeight * topScalar +
            targetHeight * topScalar;
          x -= leftOffset;
          y -= topOffset;
          x = scrollSettings.align.lockX ? parent.pageXOffset : x;
          y = scrollSettings.align.lockY ? parent.pageYOffset : y;
          differenceX = x - parent.pageXOffset;
          differenceY = y - parent.pageYOffset;
        } else {
          targetWidth = targetPosition.width;
          targetHeight = targetPosition.height;
          parentPosition = parent.getBoundingClientRect();
          var offsetLeft =
            targetPosition.left - (parentPosition.left - parent.scrollLeft);
          var offsetTop =
            targetPosition.top - (parentPosition.top - parent.scrollTop);
          x =
            offsetLeft +
            targetWidth * leftScalar -
            parent.clientWidth * leftScalar;
          y =
            offsetTop +
            targetHeight * topScalar -
            parent.clientHeight * topScalar;
          x -= leftOffset;
          y -= topOffset;
          x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0);
          y = Math.max(
            Math.min(y, parent.scrollHeight - parent.clientHeight),
            0
          );
          x = scrollSettings.align.lockX ? parent.scrollLeft : x;
          y = scrollSettings.align.lockY ? parent.scrollTop : y;
          differenceX = x - parent.scrollLeft;
          differenceY = y - parent.scrollTop;
        }
        return {
          x: x,
          y: y,
          differenceX: differenceX,
          differenceY: differenceY,
        };
      }
      function animate(parent) {
        var scrollSettings = parent._scrollSettings;
        if (!scrollSettings) {
          return;
        }
        var maxSynchronousAlignments = scrollSettings.maxSynchronousAlignments;
        var location = getTargetScrollLocation(scrollSettings, parent),
          time = Date.now() - scrollSettings.startTime,
          timeValue = Math.min((1 / scrollSettings.time) * time, 1);
        if (scrollSettings.endIterations >= maxSynchronousAlignments) {
          setElementScroll(parent, location.x, location.y);
          parent._scrollSettings = null;
          return scrollSettings.end(COMPLETE);
        }
        var easeValue = 1 - scrollSettings.ease(timeValue);
        setElementScroll(
          parent,
          location.x - location.differenceX * easeValue,
          location.y - location.differenceY * easeValue
        );
        if (time >= scrollSettings.time) {
          scrollSettings.endIterations++;
          // Align ancestor synchronously
          scrollSettings.scrollAncestor &&
            animate(scrollSettings.scrollAncestor);
          animate(parent);
          return;
        }
        raf(animate.bind(null, parent));
      }
      function defaultIsWindow(target) {
        return target.self === target;
      }
      function transitionScrollTo(
        target,
        parent,
        settings,
        scrollAncestor,
        callback
      ) {
        var idle = !parent._scrollSettings,
          lastSettings = parent._scrollSettings,
          now = Date.now(),
          cancelHandler,
          passiveOptions = {
            passive: true,
          };
        if (lastSettings) {
          lastSettings.end(CANCELED);
        }
        function end(endType) {
          parent._scrollSettings = null;
          if (parent.parentElement && parent.parentElement._scrollSettings) {
            parent.parentElement._scrollSettings.end(endType);
          }
          if (settings.debug) {
            console.log("Scrolling ended with type", endType, "for", parent);
          }
          callback(endType);
          if (cancelHandler) {
            parent.removeEventListener(
              "touchstart",
              cancelHandler,
              passiveOptions
            );
            parent.removeEventListener("wheel", cancelHandler, passiveOptions);
          }
        }
        var maxSynchronousAlignments = settings.maxSynchronousAlignments;
        if (maxSynchronousAlignments == null) {
          maxSynchronousAlignments = 3;
        }
        parent._scrollSettings = {
          startTime: now,
          endIterations: 0,
          target: target,
          time: settings.time,
          ease: settings.ease,
          align: settings.align,
          isWindow: settings.isWindow || defaultIsWindow,
          maxSynchronousAlignments: maxSynchronousAlignments,
          end: end,
          scrollAncestor,
        };
        if (!("cancellable" in settings) || settings.cancellable) {
          cancelHandler = end.bind(null, CANCELED);
          parent.addEventListener("touchstart", cancelHandler, passiveOptions);
          parent.addEventListener("wheel", cancelHandler, passiveOptions);
        }
        if (idle) {
          animate(parent);
        }
        return cancelHandler;
      }
      function defaultIsScrollable(element) {
        return (
          "pageXOffset" in element ||
          ((element.scrollHeight !== element.clientHeight ||
            element.scrollWidth !== element.clientWidth) &&
            getComputedStyle(element).overflow !== "hidden")
        );
      }
      function defaultValidTarget() {
        return true;
      }
      function findParentElement(el) {
        if (el.assignedSlot) {
          return findParentElement(el.assignedSlot);
        }
        if (el.parentElement) {
          if (el.parentElement.tagName.toLowerCase() === "body") {
            return (
              el.parentElement.ownerDocument.defaultView ||
              el.parentElement.ownerDocument.ownerWindow
            );
          }
          return el.parentElement;
        }
        if (el.getRootNode) {
          var parent = el.getRootNode();
          if (parent.nodeType === 11) {
            return parent.host;
          }
        }
      }
      module.exports = function (target, settings, callback) {
        if (!target) {
          return;
        }
        if (typeof settings === "function") {
          callback = settings;
          settings = null;
        }
        if (!settings) {
          settings = {};
        }
        settings.time = isNaN(settings.time) ? 1000 : settings.time;
        settings.ease =
          settings.ease ||
          function (v) {
            return 1 - Math.pow(1 - v, v / 2);
          };
        settings.align = settings.align || {};
        var parent = findParentElement(target),
          parents = 1;
        function done(endType) {
          parents--;
          if (!parents) {
            callback && callback(endType);
          }
        }
        var validTarget = settings.validTarget || defaultValidTarget;
        var isScrollable = settings.isScrollable;
        if (settings.debug) {
          console.log("About to scroll to", target);
          if (!parent) {
            console.error(
              "Target did not have a parent, is it mounted in the DOM?"
            );
          }
        }
        var scrollingElements = [];
        while (parent) {
          if (settings.debug) {
            console.log("Scrolling parent node", parent);
          }
          if (
            validTarget(parent, parents) &&
            (isScrollable
              ? isScrollable(parent, defaultIsScrollable)
              : defaultIsScrollable(parent))
          ) {
            parents++;
            scrollingElements.push(parent);
          }
          parent = findParentElement(parent);
          if (!parent) {
            done(COMPLETE);
            break;
          }
        }
        return scrollingElements.reduce(
          (cancel, parent, index) =>
            transitionScrollTo(
              target,
              parent,
              settings,
              scrollingElements[index + 1],
              done
            ),
          null
        );
      };

      /***/
    },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/compat get default export */
  /******/ (() => {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = (module) => {
      /******/ var getter =
        module && module.__esModule
          ? /******/ () => module["default"]
          : /******/ () => module;
      /******/ __webpack_require__.d(getter, { a: getter });
      /******/ return getter;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (
          __webpack_require__.o(definition, key) &&
          !__webpack_require__.o(exports, key)
        ) {
          /******/ Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key],
        });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) =>
      Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /************************************************************************/
  var __webpack_exports__ = {};
  // This entry need to be wrapped in an IIFE because it need to be in strict mode.
  (() => {
    "use strict"; // CONCATENATED MODULE: ./node_modules/ssr-window/ssr-window.esm.js

    /**
     * SSR Window 4.0.2
     * Better handling for window object in SSR environment
     * https://github.com/nolimits4web/ssr-window
     *
     * Copyright 2021, Vladimir Kharlampidi
     *
     * Licensed under MIT
     *
     * Released on: December 13, 2021
     */
    /* eslint-disable no-param-reassign */
    function isObject(obj) {
      return (
        obj !== null &&
        typeof obj === "object" &&
        "constructor" in obj &&
        obj.constructor === Object
      );
    }
    function extend(target = {}, src = {}) {
      Object.keys(src).forEach((key) => {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if (
          isObject(src[key]) &&
          isObject(target[key]) &&
          Object.keys(src[key]).length > 0
        ) {
          extend(target[key], src[key]);
        }
      });
    }
    const ssrDocument = {
      body: {},
      addEventListener() { },
      removeEventListener() { },
      activeElement: {
        blur() { },
        nodeName: "",
      },
      querySelector() {
        return null;
      },
      querySelectorAll() {
        return [];
      },
      getElementById() {
        return null;
      },
      createEvent() {
        return {
          initEvent() { },
        };
      },
      createElement() {
        return {
          children: [],
          childNodes: [],
          style: {},
          setAttribute() { },
          getElementsByTagName() {
            return [];
          },
        };
      },
      createElementNS() {
        return {};
      },
      importNode() {
        return null;
      },
      location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: "",
      },
    };
    function ssr_window_esm_getDocument() {
      const doc = typeof document !== "undefined" ? document : {};
      extend(doc, ssrDocument);
      return doc;
    }
    const ssrWindow = {
      document: ssrDocument,
      navigator: {
        userAgent: "",
      },
      location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: "",
      },
      history: {
        replaceState() { },
        pushState() { },
        go() { },
        back() { },
      },
      CustomEvent: function CustomEvent() {
        return this;
      },
      addEventListener() { },
      removeEventListener() { },
      getComputedStyle() {
        return {
          getPropertyValue() {
            return "";
          },
        };
      },
      Image() { },
      Date() { },
      screen: {},
      setTimeout() { },
      clearTimeout() { },
      matchMedia() {
        return {};
      },
      requestAnimationFrame(callback) {
        if (typeof setTimeout === "undefined") {
          callback();
          return null;
        }
        return setTimeout(callback, 0);
      },
      cancelAnimationFrame(id) {
        if (typeof setTimeout === "undefined") {
          return;
        }
        clearTimeout(id);
      },
    };
    function ssr_window_esm_getWindow() {
      const win = typeof window !== "undefined" ? window : {};
      extend(win, ssrWindow);
      return win;
    } // CONCATENATED MODULE: ./node_modules/dom7/dom7.esm.js

    /**
     * Dom7 4.0.6
     * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
     * https://framework7.io/docs/dom7.html
     *
     * Copyright 2023, Vladimir Kharlampidi
     *
     * Licensed under MIT
     *
     * Released on: February 2, 2023
     */

    /* eslint-disable no-proto */
    function makeReactive(obj) {
      const proto = obj.__proto__;
      Object.defineProperty(obj, "__proto__", {
        get() {
          return proto;
        },
        set(value) {
          proto.__proto__ = value;
        },
      });
    }
    class Dom7 extends Array {
      constructor(items) {
        if (typeof items === "number") {
          super(items);
        } else {
          super(...(items || []));
          makeReactive(this);
        }
      }
    }
    function arrayFlat(arr = []) {
      const res = [];
      arr.forEach((el) => {
        if (Array.isArray(el)) {
          res.push(...arrayFlat(el));
        } else {
          res.push(el);
        }
      });
      return res;
    }
    function arrayFilter(arr, callback) {
      return Array.prototype.filter.call(arr, callback);
    }
    function arrayUnique(arr) {
      const uniqueArray = [];
      for (let i = 0; i < arr.length; i += 1) {
        if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
      }
      return uniqueArray;
    }
    function toCamelCase(string) {
      return string
        .toLowerCase()
        .replace(/-(.)/g, (match, group) => group.toUpperCase());
    }

    // eslint-disable-next-line

    function qsa(selector, context) {
      if (typeof selector !== "string") {
        return [selector];
      }
      const a = [];
      const res = context.querySelectorAll(selector);
      for (let i = 0; i < res.length; i += 1) {
        a.push(res[i]);
      }
      return a;
    }
    function dom7_esm_$(selector, context) {
      const window = ssr_window_esm_getWindow();
      const document = ssr_window_esm_getDocument();
      let arr = [];
      if (!context && selector instanceof Dom7) {
        return selector;
      }
      if (!selector) {
        return new Dom7(arr);
      }
      if (typeof selector === "string") {
        const html = selector.trim();
        if (html.indexOf("<") >= 0 && html.indexOf(">") >= 0) {
          let toCreate = "div";
          if (html.indexOf("<li") === 0) toCreate = "ul";
          if (html.indexOf("<tr") === 0) toCreate = "tbody";
          if (html.indexOf("<td") === 0 || html.indexOf("<th") === 0)
            toCreate = "tr";
          if (html.indexOf("<tbody") === 0) toCreate = "table";
          if (html.indexOf("<option") === 0) toCreate = "select";
          const tempParent = document.createElement(toCreate);
          tempParent.innerHTML = html;
          for (let i = 0; i < tempParent.childNodes.length; i += 1) {
            arr.push(tempParent.childNodes[i]);
          }
        } else {
          arr = qsa(selector.trim(), context || document);
        } // arr = qsa(selector, document);
      } else if (
        selector.nodeType ||
        selector === window ||
        selector === document
      ) {
        arr.push(selector);
      } else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
      }
      return new Dom7(arrayUnique(arr));
    }
    dom7_esm_$.fn = Dom7.prototype;

    // eslint-disable-next-line

    function addClass(...classes) {
      const classNames = arrayFlat(classes.map((c) => c.split(" ")));
      this.forEach((el) => {
        el.classList.add(...classNames);
      });
      return this;
    }
    function removeClass(...classes) {
      const classNames = arrayFlat(classes.map((c) => c.split(" ")));
      this.forEach((el) => {
        el.classList.remove(...classNames);
      });
      return this;
    }
    function toggleClass(...classes) {
      const classNames = arrayFlat(classes.map((c) => c.split(" ")));
      this.forEach((el) => {
        classNames.forEach((className) => {
          el.classList.toggle(className);
        });
      });
    }
    function hasClass(...classes) {
      const classNames = arrayFlat(classes.map((c) => c.split(" ")));
      return (
        arrayFilter(this, (el) => {
          return (
            classNames.filter((className) => el.classList.contains(className))
              .length > 0
          );
        }).length > 0
      );
    }
    function attr(attrs, value) {
      if (arguments.length === 1 && typeof attrs === "string") {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
      } // Set attrs

      for (let i = 0; i < this.length; i += 1) {
        if (arguments.length === 2) {
          // String
          this[i].setAttribute(attrs, value);
        } else {
          // Object
          for (const attrName in attrs) {
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
          }
        }
      }
      return this;
    }
    function removeAttr(attr) {
      for (let i = 0; i < this.length; i += 1) {
        this[i].removeAttribute(attr);
      }
      return this;
    }
    function prop(props, value) {
      if (arguments.length === 1 && typeof props === "string") {
        // Get prop
        if (this[0]) return this[0][props];
      } else {
        // Set props
        for (let i = 0; i < this.length; i += 1) {
          if (arguments.length === 2) {
            // String
            this[i][props] = value;
          } else {
            // Object
            for (const propName in props) {
              this[i][propName] = props[propName];
            }
          }
        }
        return this;
      }
      return this;
    }
    function data(key, value) {
      let el;
      if (typeof value === "undefined") {
        el = this[0];
        if (!el) return undefined; // Get value

        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
          return el.dom7ElementDataStorage[key];
        }
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) {
          return dataKey;
        }
        return undefined;
      } // Set value

      for (let i = 0; i < this.length; i += 1) {
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
      }
      return this;
    }
    function removeData(key) {
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
          el.dom7ElementDataStorage[key] = null;
          delete el.dom7ElementDataStorage[key];
        }
      }
    }
    function dataset() {
      const el = this[0];
      if (!el) return undefined;
      const dataset = {}; // eslint-disable-line

      if (el.dataset) {
        for (const dataKey in el.dataset) {
          dataset[dataKey] = el.dataset[dataKey];
        }
      } else {
        for (let i = 0; i < el.attributes.length; i += 1) {
          const attr = el.attributes[i];
          if (attr.name.indexOf("data-") >= 0) {
            dataset[toCamelCase(attr.name.split("data-")[1])] = attr.value;
          }
        }
      }
      for (const key in dataset) {
        if (dataset[key] === "false") dataset[key] = false;
        else if (dataset[key] === "true") dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1)
          dataset[key] *= 1;
      }
      return dataset;
    }
    function val(value) {
      if (typeof value === "undefined") {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === "select") {
          const values = [];
          for (let i = 0; i < el.selectedOptions.length; i += 1) {
            values.push(el.selectedOptions[i].value);
          }
          return values;
        }
        return el.value;
      } // set value

      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (
          Array.isArray(value) &&
          el.multiple &&
          el.nodeName.toLowerCase() === "select"
        ) {
          for (let j = 0; j < el.options.length; j += 1) {
            el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
          }
        } else {
          el.value = value;
        }
      }
      return this;
    }
    function value(value) {
      return this.val(value);
    }
    function transform(transform) {
      for (let i = 0; i < this.length; i += 1) {
        this[i].style.transform = transform;
      }
      return this;
    }
    function transition(duration) {
      for (let i = 0; i < this.length; i += 1) {
        this[i].style.transitionDuration =
          typeof duration !== "string" ? `${duration}ms` : duration;
      }
      return this;
    }
    function on(...args) {
      let [eventType, targetSelector, listener, capture] = args;
      if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
      }
      if (!capture) capture = false;
      function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
        if (dom7_esm_$(target).is(targetSelector))
          listener.apply(target, eventData);
        else {
          const parents = dom7_esm_$(target).parents(); // eslint-disable-line

          for (let k = 0; k < parents.length; k += 1) {
            if (dom7_esm_$(parents[k]).is(targetSelector))
              listener.apply(parents[k], eventData);
          }
        }
      }
      function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
        listener.apply(this, eventData);
      }
      const events = eventType.split(" ");
      let j;
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (!targetSelector) {
          for (j = 0; j < events.length; j += 1) {
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
              listener,
              proxyListener: handleEvent,
            });
            el.addEventListener(event, handleEvent, capture);
          }
        } else {
          // Live events
          for (j = 0; j < events.length; j += 1) {
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
              listener,
              proxyListener: handleLiveEvent,
            });
            el.addEventListener(event, handleLiveEvent, capture);
          }
        }
      }
      return this;
    }
    function off(...args) {
      let [eventType, targetSelector, listener, capture] = args;
      if (typeof args[1] === "function") {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
      }
      if (!capture) capture = false;
      const events = eventType.split(" ");
      for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        for (let j = 0; j < this.length; j += 1) {
          const el = this[j];
          let handlers;
          if (!targetSelector && el.dom7Listeners) {
            handlers = el.dom7Listeners[event];
          } else if (targetSelector && el.dom7LiveListeners) {
            handlers = el.dom7LiveListeners[event];
          }
          if (handlers && handlers.length) {
            for (let k = handlers.length - 1; k >= 0; k -= 1) {
              const handler = handlers[k];
              if (listener && handler.listener === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (
                listener &&
                handler.listener &&
                handler.listener.dom7proxy &&
                handler.listener.dom7proxy === listener
              ) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (!listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              }
            }
          }
        }
      }
      return this;
    }
    function once(...args) {
      const dom = this;
      let [eventName, targetSelector, listener, capture] = args;
      if (typeof args[1] === "function") {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
      }
      function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) {
          delete onceHandler.dom7proxy;
        }
      }
      onceHandler.dom7proxy = listener;
      return dom.on(eventName, targetSelector, onceHandler, capture);
    }
    function trigger(...args) {
      const window = ssr_window_esm_getWindow();
      const events = args[0].split(" ");
      const eventData = args[1];
      for (let i = 0; i < events.length; i += 1) {
        const event = events[i];
        for (let j = 0; j < this.length; j += 1) {
          const el = this[j];
          if (window.CustomEvent) {
            const evt = new window.CustomEvent(event, {
              detail: eventData,
              bubbles: true,
              cancelable: true,
            });
            el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
            el.dispatchEvent(evt);
            el.dom7EventData = [];
            delete el.dom7EventData;
          }
        }
      }
      return this;
    }
    function transitionStart(callback) {
      const dom = this;
      function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionstart", fireCallBack);
      }
      if (callback) {
        dom.on("transitionstart", fireCallBack);
      }
      return this;
    }
    function transitionEnd(callback) {
      const dom = this;
      function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("transitionend", fireCallBack);
      }
      if (callback) {
        dom.on("transitionend", fireCallBack);
      }
      return this;
    }
    function animationEnd(callback) {
      const dom = this;
      function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off("animationend", fireCallBack);
      }
      if (callback) {
        dom.on("animationend", fireCallBack);
      }
      return this;
    }
    function width() {
      const window = getWindow();
      if (this[0] === window) {
        return window.innerWidth;
      }
      if (this.length > 0) {
        return parseFloat(this.css("width"));
      }
      return null;
    }
    function dom7_esm_outerWidth(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          const styles = this.styles();
          return (
            this[0].offsetWidth +
            parseFloat(styles.getPropertyValue("margin-right")) +
            parseFloat(styles.getPropertyValue("margin-left"))
          );
        }
        return this[0].offsetWidth;
      }
      return null;
    }
    function height() {
      const window = getWindow();
      if (this[0] === window) {
        return window.innerHeight;
      }
      if (this.length > 0) {
        return parseFloat(this.css("height"));
      }
      return null;
    }
    function dom7_esm_outerHeight(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          const styles = this.styles();
          return (
            this[0].offsetHeight +
            parseFloat(styles.getPropertyValue("margin-top")) +
            parseFloat(styles.getPropertyValue("margin-bottom"))
          );
        }
        return this[0].offsetHeight;
      }
      return null;
    }
    function offset() {
      if (this.length > 0) {
        const window = ssr_window_esm_getWindow();
        const document = ssr_window_esm_getDocument();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
          top: box.top + scrollTop - clientTop,
          left: box.left + scrollLeft - clientLeft,
        };
      }
      return null;
    }
    function hide() {
      for (let i = 0; i < this.length; i += 1) {
        this[i].style.display = "none";
      }
      return this;
    }
    function show() {
      const window = getWindow();
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (el.style.display === "none") {
          el.style.display = "";
        }
        if (
          window.getComputedStyle(el, null).getPropertyValue("display") ===
          "none"
        ) {
          // Still not visible
          el.style.display = "block";
        }
      }
      return this;
    }
    function styles() {
      const window = ssr_window_esm_getWindow();
      if (this[0]) return window.getComputedStyle(this[0], null);
      return {};
    }
    function css(props, value) {
      const window = ssr_window_esm_getWindow();
      let i;
      if (arguments.length === 1) {
        if (typeof props === "string") {
          // .css('width')
          if (this[0])
            return window
              .getComputedStyle(this[0], null)
              .getPropertyValue(props);
        } else {
          // .css({ width: '100px' })
          for (i = 0; i < this.length; i += 1) {
            for (const prop in props) {
              this[i].style[prop] = props[prop];
            }
          }
          return this;
        }
      }
      if (arguments.length === 2 && typeof props === "string") {
        // .css('width', '100px')
        for (i = 0; i < this.length; i += 1) {
          this[i].style[props] = value;
        }
        return this;
      }
      return this;
    }
    function each(callback) {
      if (!callback) return this;
      this.forEach((el, index) => {
        callback.apply(el, [el, index]);
      });
      return this;
    }
    function filter(callback) {
      const result = arrayFilter(this, callback);
      return dom7_esm_$(result);
    }
    function html(html) {
      if (typeof html === "undefined") {
        return this[0] ? this[0].innerHTML : null;
      }
      for (let i = 0; i < this.length; i += 1) {
        this[i].innerHTML = html;
      }
      return this;
    }
    function dom7_esm_text(text) {
      if (typeof text === "undefined") {
        return this[0] ? this[0].textContent.trim() : null;
      }
      for (let i = 0; i < this.length; i += 1) {
        this[i].textContent = text;
      }
      return this;
    }
    function is(selector) {
      const window = ssr_window_esm_getWindow();
      const document = ssr_window_esm_getDocument();
      const el = this[0];
      let compareWith;
      let i;
      if (!el || typeof selector === "undefined") return false;
      if (typeof selector === "string") {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = dom7_esm_$(selector);
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) return true;
        }
        return false;
      }
      if (selector === document) {
        return el === document;
      }
      if (selector === window) {
        return el === window;
      }
      if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [selector] : selector;
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) return true;
        }
        return false;
      }
      return false;
    }
    function index() {
      let child = this[0];
      let i;
      if (child) {
        i = 0; // eslint-disable-next-line

        while ((child = child.previousSibling) !== null) {
          if (child.nodeType === 1) i += 1;
        }
        return i;
      }
      return undefined;
    }
    function eq(index) {
      if (typeof index === "undefined") return this;
      const length = this.length;
      if (index > length - 1) {
        return dom7_esm_$([]);
      }
      if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return dom7_esm_$([]);
        return dom7_esm_$([this[returnIndex]]);
      }
      return dom7_esm_$([this[index]]);
    }
    function append(...els) {
      let newChild;
      const document = ssr_window_esm_getDocument();
      for (let k = 0; k < els.length; k += 1) {
        newChild = els[k];
        for (let i = 0; i < this.length; i += 1) {
          if (typeof newChild === "string") {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = newChild;
            while (tempDiv.firstChild) {
              this[i].appendChild(tempDiv.firstChild);
            }
          } else if (newChild instanceof Dom7) {
            for (let j = 0; j < newChild.length; j += 1) {
              this[i].appendChild(newChild[j]);
            }
          } else {
            this[i].appendChild(newChild);
          }
        }
      }
      return this;
    }
    function appendTo(parent) {
      dom7_esm_$(parent).append(this);
      return this;
    }
    function prepend(newChild) {
      const document = ssr_window_esm_getDocument();
      let i;
      let j;
      for (i = 0; i < this.length; i += 1) {
        if (typeof newChild === "string") {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = newChild;
          for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
          }
        } else if (newChild instanceof Dom7) {
          for (j = 0; j < newChild.length; j += 1) {
            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
          }
        } else {
          this[i].insertBefore(newChild, this[i].childNodes[0]);
        }
      }
      return this;
    }
    function prependTo(parent) {
      dom7_esm_$(parent).prepend(this);
      return this;
    }
    function insertBefore(selector) {
      const before = dom7_esm_$(selector);
      for (let i = 0; i < this.length; i += 1) {
        if (before.length === 1) {
          before[0].parentNode.insertBefore(this[i], before[0]);
        } else if (before.length > 1) {
          for (let j = 0; j < before.length; j += 1) {
            before[j].parentNode.insertBefore(
              this[i].cloneNode(true),
              before[j]
            );
          }
        }
      }
    }
    function insertAfter(selector) {
      const after = dom7_esm_$(selector);
      for (let i = 0; i < this.length; i += 1) {
        if (after.length === 1) {
          after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        } else if (after.length > 1) {
          for (let j = 0; j < after.length; j += 1) {
            after[j].parentNode.insertBefore(
              this[i].cloneNode(true),
              after[j].nextSibling
            );
          }
        }
      }
    }
    function next(selector) {
      if (this.length > 0) {
        if (selector) {
          if (
            this[0].nextElementSibling &&
            dom7_esm_$(this[0].nextElementSibling).is(selector)
          ) {
            return dom7_esm_$([this[0].nextElementSibling]);
          }
          return dom7_esm_$([]);
        }
        if (this[0].nextElementSibling)
          return dom7_esm_$([this[0].nextElementSibling]);
        return dom7_esm_$([]);
      }
      return dom7_esm_$([]);
    }
    function nextAll(selector) {
      const nextEls = [];
      let el = this[0];
      if (!el) return dom7_esm_$([]);
      while (el.nextElementSibling) {
        const next = el.nextElementSibling; // eslint-disable-line

        if (selector) {
          if (dom7_esm_$(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
      }
      return dom7_esm_$(nextEls);
    }
    function prev(selector) {
      if (this.length > 0) {
        const el = this[0];
        if (selector) {
          if (
            el.previousElementSibling &&
            dom7_esm_$(el.previousElementSibling).is(selector)
          ) {
            return dom7_esm_$([el.previousElementSibling]);
          }
          return dom7_esm_$([]);
        }
        if (el.previousElementSibling)
          return dom7_esm_$([el.previousElementSibling]);
        return dom7_esm_$([]);
      }
      return dom7_esm_$([]);
    }
    function prevAll(selector) {
      const prevEls = [];
      let el = this[0];
      if (!el) return dom7_esm_$([]);
      while (el.previousElementSibling) {
        const prev = el.previousElementSibling; // eslint-disable-line

        if (selector) {
          if (dom7_esm_$(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
      }
      return dom7_esm_$(prevEls);
    }
    function siblings(selector) {
      return this.nextAll(selector).add(this.prevAll(selector));
    }
    function dom7_esm_parent(selector) {
      const parents = []; // eslint-disable-line

      for (let i = 0; i < this.length; i += 1) {
        if (this[i].parentNode !== null) {
          if (selector) {
            if (dom7_esm_$(this[i].parentNode).is(selector))
              parents.push(this[i].parentNode);
          } else {
            parents.push(this[i].parentNode);
          }
        }
      }
      return dom7_esm_$(parents);
    }
    function parents(selector) {
      const parents = []; // eslint-disable-line

      for (let i = 0; i < this.length; i += 1) {
        let parent = this[i].parentNode; // eslint-disable-line

        while (parent) {
          if (selector) {
            if (dom7_esm_$(parent).is(selector)) parents.push(parent);
          } else {
            parents.push(parent);
          }
          parent = parent.parentNode;
        }
      }
      return dom7_esm_$(parents);
    }
    function closest(selector) {
      let closest = this; // eslint-disable-line

      if (typeof selector === "undefined") {
        return dom7_esm_$([]);
      }
      if (!closest.is(selector)) {
        closest = closest.parents(selector).eq(0);
      }
      return closest;
    }
    function find(selector) {
      const foundElements = [];
      for (let i = 0; i < this.length; i += 1) {
        const found = this[i].querySelectorAll(selector);
        for (let j = 0; j < found.length; j += 1) {
          foundElements.push(found[j]);
        }
      }
      return dom7_esm_$(foundElements);
    }
    function children(selector) {
      const children = []; // eslint-disable-line

      for (let i = 0; i < this.length; i += 1) {
        const childNodes = this[i].children;
        for (let j = 0; j < childNodes.length; j += 1) {
          if (!selector || dom7_esm_$(childNodes[j]).is(selector)) {
            children.push(childNodes[j]);
          }
        }
      }
      return dom7_esm_$(children);
    }
    function remove() {
      for (let i = 0; i < this.length; i += 1) {
        if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
      }
      return this;
    }
    function detach() {
      return this.remove();
    }
    function add(...els) {
      const dom = this;
      let i;
      let j;
      for (i = 0; i < els.length; i += 1) {
        const toAdd = dom7_esm_$(els[i]);
        for (j = 0; j < toAdd.length; j += 1) {
          dom.push(toAdd[j]);
        }
      }
      return dom;
    }
    function empty() {
      for (let i = 0; i < this.length; i += 1) {
        const el = this[i];
        if (el.nodeType === 1) {
          for (let j = 0; j < el.childNodes.length; j += 1) {
            if (el.childNodes[j].parentNode) {
              el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            }
          }
          el.textContent = "";
        }
      }
      return this;
    }

    // eslint-disable-next-line

    function scrollTo(...args) {
      const window = getWindow();
      let [left, top, duration, easing, callback] = args;
      if (args.length === 4 && typeof easing === "function") {
        callback = easing;
        [left, top, duration, callback, easing] = args;
      }
      if (typeof easing === "undefined") easing = "swing";
      return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line

        let scrollLeft; // eslint-disable-line

        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === "undefined") {
          easing = "swing";
        }
        if (animateTop) {
          currentTop = el.scrollTop;
          if (!duration) {
            el.scrollTop = top;
          }
        }
        if (animateLeft) {
          currentLeft = el.scrollLeft;
          if (!duration) {
            el.scrollLeft = left;
          }
        }
        if (!duration) return;
        if (animateTop) {
          maxTop = el.scrollHeight - el.offsetHeight;
          newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
          maxLeft = el.scrollWidth - el.offsetWidth;
          newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
          if (startTime === null) {
            startTime = time;
          }
          const progress = Math.max(
            Math.min((time - startTime) / duration, 1),
            0
          );
          const easeProgress =
            easing === "linear"
              ? progress
              : 0.5 - Math.cos(progress * Math.PI) / 2;
          let done;
          if (animateTop)
            scrollTop = currentTop + easeProgress * (newTop - currentTop);
          if (animateLeft)
            scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
          if (animateTop && newTop > currentTop && scrollTop >= newTop) {
            el.scrollTop = newTop;
            done = true;
          }
          if (animateTop && newTop < currentTop && scrollTop <= newTop) {
            el.scrollTop = newTop;
            done = true;
          }
          if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
            el.scrollLeft = newLeft;
            done = true;
          }
          if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
            el.scrollLeft = newLeft;
            done = true;
          }
          if (done) {
            if (callback) callback();
            return;
          }
          if (animateTop) el.scrollTop = scrollTop;
          if (animateLeft) el.scrollLeft = scrollLeft;
          window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
      });
    } // scrollTop(top, duration, easing, callback) {

    function scrollTop(...args) {
      let [top, duration, easing, callback] = args;
      if (args.length === 3 && typeof easing === "function") {
        [top, duration, callback, easing] = args;
      }
      const dom = this;
      if (typeof top === "undefined") {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
      }
      return dom.scrollTo(undefined, top, duration, easing, callback);
    }
    function scrollLeft(...args) {
      let [left, duration, easing, callback] = args;
      if (args.length === 3 && typeof easing === "function") {
        [left, duration, callback, easing] = args;
      }
      const dom = this;
      if (typeof left === "undefined") {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
      }
      return dom.scrollTo(left, undefined, duration, easing, callback);
    }

    // eslint-disable-next-line

    function animate(initialProps, initialParams) {
      const window = getWindow();
      const els = this;
      const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign(
          {
            duration: 300,
            easing: "swing", // or 'linear'

            /* Callbacks
          begin(elements)
          complete(elements)
          progress(elements, complete, remaining, start, tweenValue)
          */
          },
          initialParams
        ),
        elements: els,
        animating: false,
        que: [],
        easingProgress(easing, progress) {
          if (easing === "swing") {
            return 0.5 - Math.cos(progress * Math.PI) / 2;
          }
          if (typeof easing === "function") {
            return easing(progress);
          }
          return progress;
        },
        stop() {
          if (a.frameId) {
            window.cancelAnimationFrame(a.frameId);
          }
          a.animating = false;
          a.elements.each((el) => {
            const element = el;
            delete element.dom7AnimateInstance;
          });
          a.que = [];
        },
        done(complete) {
          a.animating = false;
          a.elements.each((el) => {
            const element = el;
            delete element.dom7AnimateInstance;
          });
          if (complete) complete(els);
          if (a.que.length > 0) {
            const que = a.que.shift();
            a.animate(que[0], que[1]);
          }
        },
        animate(props, params) {
          if (a.animating) {
            a.que.push([props, params]);
            return a;
          }
          const elements = []; // Define & Cache Initials & Units

          a.elements.each((el, index) => {
            let initialFullValue;
            let initialValue;
            let unit;
            let finalValue;
            let finalFullValue;
            if (!el.dom7AnimateInstance)
              a.elements[index].dom7AnimateInstance = a;
            elements[index] = {
              container: el,
            };
            Object.keys(props).forEach((prop) => {
              initialFullValue = window
                .getComputedStyle(el, null)
                .getPropertyValue(prop)
                .replace(",", ".");
              initialValue = parseFloat(initialFullValue);
              unit = initialFullValue.replace(initialValue, "");
              finalValue = parseFloat(props[prop]);
              finalFullValue = props[prop] + unit;
              elements[index][prop] = {
                initialFullValue,
                initialValue,
                unit,
                finalValue,
                finalFullValue,
                currentValue: initialValue,
              };
            });
          });
          let startTime = null;
          let time;
          let elementsDone = 0;
          let propsDone = 0;
          let done;
          let began = false;
          a.animating = true;
          function render() {
            time = new Date().getTime();
            let progress;
            let easeProgress; // let el;

            if (!began) {
              began = true;
              if (params.begin) params.begin(els);
            }
            if (startTime === null) {
              startTime = time;
            }
            if (params.progress) {
              // eslint-disable-next-line
              params.progress(
                els,
                Math.max(Math.min((time - startTime) / params.duration, 1), 0),
                startTime + params.duration - time < 0
                  ? 0
                  : startTime + params.duration - time,
                startTime
              );
            }
            elements.forEach((element) => {
              const el = element;
              if (done || el.done) return;
              Object.keys(props).forEach((prop) => {
                if (done || el.done) return;
                progress = Math.max(
                  Math.min((time - startTime) / params.duration, 1),
                  0
                );
                easeProgress = a.easingProgress(params.easing, progress);
                const { initialValue, finalValue, unit } = el[prop];
                el[prop].currentValue =
                  initialValue + easeProgress * (finalValue - initialValue);
                const currentValue = el[prop].currentValue;
                if (
                  (finalValue > initialValue && currentValue >= finalValue) ||
                  (finalValue < initialValue && currentValue <= finalValue)
                ) {
                  el.container.style[prop] = finalValue + unit;
                  propsDone += 1;
                  if (propsDone === Object.keys(props).length) {
                    el.done = true;
                    elementsDone += 1;
                  }
                  if (elementsDone === elements.length) {
                    done = true;
                  }
                }
                if (done) {
                  a.done(params.complete);
                  return;
                }
                el.container.style[prop] = currentValue + unit;
              });
            });
            if (done) return; // Then call

            a.frameId = window.requestAnimationFrame(render);
          }
          a.frameId = window.requestAnimationFrame(render);
          return a;
        },
      };
      if (a.elements.length === 0) {
        return els;
      }
      let animateInstance;
      for (let i = 0; i < a.elements.length; i += 1) {
        if (a.elements[i].dom7AnimateInstance) {
          animateInstance = a.elements[i].dom7AnimateInstance;
        } else a.elements[i].dom7AnimateInstance = a;
      }
      if (!animateInstance) {
        animateInstance = a;
      }
      if (initialProps === "stop") {
        animateInstance.stop();
      } else {
        animateInstance.animate(a.props, a.params);
      }
      return els;
    }
    function stop() {
      const els = this;
      for (let i = 0; i < els.length; i += 1) {
        if (els[i].dom7AnimateInstance) {
          els[i].dom7AnimateInstance.stop();
        }
      }
    }
    const noTrigger = "resize scroll".split(" ");
    function shortcut(name) {
      function eventHandler(...args) {
        if (typeof args[0] === "undefined") {
          for (let i = 0; i < this.length; i += 1) {
            if (noTrigger.indexOf(name) < 0) {
              if (name in this[i]) this[i][name]();
              else {
                dom7_esm_$(this[i]).trigger(name);
              }
            }
          }
          return this;
        }
        return this.on(name, ...args);
      }
      return eventHandler;
    }
    const click = shortcut("click");
    const dom7_esm_blur = shortcut("blur");
    const dom7_esm_focus = shortcut("focus");
    const focusin = shortcut("focusin");
    const focusout = shortcut("focusout");
    const keyup = shortcut("keyup");
    const keydown = shortcut("keydown");
    const keypress = shortcut("keypress");
    const dom7_esm_submit = shortcut("submit");
    const change = shortcut("change");
    const mousedown = shortcut("mousedown");
    const mousemove = shortcut("mousemove");
    const mouseup = shortcut("mouseup");
    const mouseenter = shortcut("mouseenter");
    const mouseleave = shortcut("mouseleave");
    const mouseout = shortcut("mouseout");
    const mouseover = shortcut("mouseover");
    const touchstart = shortcut("touchstart");
    const touchend = shortcut("touchend");
    const touchmove = shortcut("touchmove");
    const resize = shortcut("resize");
    const dom7_esm_scroll = shortcut("scroll");
    /* harmony default export */ const dom7_esm =
      /* unused pure expression or super */ null && dom7_esm_$; // CONCATENATED MODULE: ./node_modules/swiper/shared/dom.js

    const Methods = {
      addClass: addClass,
      removeClass: removeClass,
      hasClass: hasClass,
      toggleClass: toggleClass,
      attr: attr,
      removeAttr: removeAttr,
      transform: transform,
      transition: transition,
      on: on,
      off: off,
      trigger: trigger,
      transitionEnd: transitionEnd,
      outerWidth: dom7_esm_outerWidth,
      outerHeight: dom7_esm_outerHeight,
      styles: styles,
      offset: offset,
      css: css,
      each: each,
      html: html,
      text: dom7_esm_text,
      is: is,
      index: index,
      eq: eq,
      append: append,
      prepend: prepend,
      next: next,
      nextAll: nextAll,
      prev: prev,
      prevAll: prevAll,
      parent: dom7_esm_parent,
      parents: parents,
      closest: closest,
      find: find,
      children: children,
      filter: filter,
      remove: remove,
    };
    Object.keys(Methods).forEach((methodName) => {
      Object.defineProperty(dom7_esm_$.fn, methodName, {
        value: Methods[methodName],
        writable: true,
      });
    });
    /* harmony default export */ const dom = dom7_esm_$; // CONCATENATED MODULE: ./node_modules/swiper/shared/utils.js
    function deleteProps(obj) {
      const object = obj;
      Object.keys(object).forEach((key) => {
        try {
          object[key] = null;
        } catch (e) {
          // no getter for object
        }
        try {
          delete object[key];
        } catch (e) {
          // something got wrong
        }
      });
    }
    function utils_nextTick(callback, delay = 0) {
      return setTimeout(callback, delay);
    }
    function utils_now() {
      return Date.now();
    }
    function utils_getComputedStyle(el) {
      const window = ssr_window_esm_getWindow();
      let style;
      if (window.getComputedStyle) {
        style = window.getComputedStyle(el, null);
      }
      if (!style && el.currentStyle) {
        style = el.currentStyle;
      }
      if (!style) {
        style = el.style;
      }
      return style;
    }
    function utils_getTranslate(el, axis = "x") {
      const window = ssr_window_esm_getWindow();
      let matrix;
      let curTransform;
      let transformMatrix;
      const curStyle = utils_getComputedStyle(el, null);
      if (window.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) {
          curTransform = curTransform
            .split(", ")
            .map((a) => a.replace(",", "."))
            .join(", ");
        } // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case

        transformMatrix = new window.WebKitCSSMatrix(
          curTransform === "none" ? "" : curTransform
        );
      } else {
        transformMatrix =
          curStyle.MozTransform ||
          curStyle.OTransform ||
          curStyle.MsTransform ||
          curStyle.msTransform ||
          curStyle.transform ||
          curStyle
            .getPropertyValue("transform")
            .replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
      }
      if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window.WebKitCSSMatrix)
          curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16)
          curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
      }
      if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window.WebKitCSSMatrix)
          curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16)
          curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
      }
      return curTransform || 0;
    }
    function utils_isObject(o) {
      return (
        typeof o === "object" &&
        o !== null &&
        o.constructor &&
        Object.prototype.toString.call(o).slice(8, -1) === "Object"
      );
    }
    function isNode(node) {
      // eslint-disable-next-line
      if (
        typeof window !== "undefined" &&
        typeof window.HTMLElement !== "undefined"
      ) {
        return node instanceof HTMLElement;
      }
      return node && (node.nodeType === 1 || node.nodeType === 11);
    }
    function utils_extend(...args) {
      const to = Object(args[0]);
      const noExtend = ["__proto__", "constructor", "prototype"];
      for (let i = 1; i < args.length; i += 1) {
        const nextSource = args[i];
        if (
          nextSource !== undefined &&
          nextSource !== null &&
          !isNode(nextSource)
        ) {
          const keysArray = Object.keys(Object(nextSource)).filter(
            (key) => noExtend.indexOf(key) < 0
          );
          for (
            let nextIndex = 0, len = keysArray.length;
            nextIndex < len;
            nextIndex += 1
          ) {
            const nextKey = keysArray[nextIndex];
            const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              if (
                utils_isObject(to[nextKey]) &&
                utils_isObject(nextSource[nextKey])
              ) {
                if (nextSource[nextKey].__swiper__) {
                  to[nextKey] = nextSource[nextKey];
                } else {
                  utils_extend(to[nextKey], nextSource[nextKey]);
                }
              } else if (
                !utils_isObject(to[nextKey]) &&
                utils_isObject(nextSource[nextKey])
              ) {
                to[nextKey] = {};
                if (nextSource[nextKey].__swiper__) {
                  to[nextKey] = nextSource[nextKey];
                } else {
                  utils_extend(to[nextKey], nextSource[nextKey]);
                }
              } else {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
      }
      return to;
    }
    function utils_setCSSProperty(el, varName, varValue) {
      el.style.setProperty(varName, varValue);
    }
    function animateCSSModeScroll({ swiper, targetPosition, side }) {
      const window = ssr_window_esm_getWindow();
      const startPosition = -swiper.translate;
      let startTime = null;
      let time;
      const duration = swiper.params.speed;
      swiper.wrapperEl.style.scrollSnapType = "none";
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      const dir = targetPosition > startPosition ? "next" : "prev";
      const isOutOfBound = (current, target) => {
        return (
          (dir === "next" && current >= target) ||
          (dir === "prev" && current <= target)
        );
      };
      const animate = () => {
        time = new Date().getTime();
        if (startTime === null) {
          startTime = time;
        }
        const progress = Math.max(
          Math.min((time - startTime) / duration, 1),
          0
        );
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition =
          startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) {
          currentPosition = targetPosition;
        }
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition,
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
          swiper.wrapperEl.style.overflow = "hidden";
          swiper.wrapperEl.style.scrollSnapType = "";
          setTimeout(() => {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.scrollTo({
              [side]: currentPosition,
            });
          });
          window.cancelAnimationFrame(swiper.cssModeFrameID);
          return;
        }
        swiper.cssModeFrameID = window.requestAnimationFrame(animate);
      };
      animate();
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/get-support.js

    let support;
    function calcSupport() {
      const window = ssr_window_esm_getWindow();
      const document = ssr_window_esm_getDocument();
      return {
        smoothScroll:
          document.documentElement &&
          "scrollBehavior" in document.documentElement.style,
        touch: !!(
          "ontouchstart" in window ||
          (window.DocumentTouch && document instanceof window.DocumentTouch)
        ),
        passiveListener: (function checkPassiveListener() {
          let supportsPassive = false;
          try {
            const opts = Object.defineProperty({}, "passive", {
              // eslint-disable-next-line
              get() {
                supportsPassive = true;
              },
            });
            window.addEventListener("testPassiveListener", null, opts);
          } catch (e) {
            // No support
          }
          return supportsPassive;
        })(),
        gestures: (function checkGestures() {
          return "ongesturestart" in window;
        })(),
      };
    }
    function getSupport() {
      if (!support) {
        support = calcSupport();
      }
      return support;
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/get-device.js

    let deviceCached;
    function calcDevice({ userAgent } = {}) {
      const support = getSupport();
      const window = ssr_window_esm_getWindow();
      const platform = window.navigator.platform;
      const ua = userAgent || window.navigator.userAgent;
      const device = {
        ios: false,
        android: false,
      };
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

      let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
      const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
      const windows = platform === "Win32";
      let macos = platform === "MacIntel"; // iPadOs 13 fix

      const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810",
      ];
      if (
        !ipad &&
        macos &&
        support.touch &&
        iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0
      ) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [0, 1, "13_0_0"];
        macos = false;
      } // Android

      if (android && !windows) {
        device.os = "android";
        device.android = true;
      }
      if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
      } // Export object

      return device;
    }
    function getDevice(overrides = {}) {
      if (!deviceCached) {
        deviceCached = calcDevice(overrides);
      }
      return deviceCached;
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/get-browser.js

    let browser;
    function calcBrowser() {
      const window = ssr_window_esm_getWindow();
      function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return (
          ua.indexOf("safari") >= 0 &&
          ua.indexOf("chrome") < 0 &&
          ua.indexOf("android") < 0
        );
      }
      return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
          window.navigator.userAgent
        ),
      };
    }
    function getBrowser() {
      if (!browser) {
        browser = calcBrowser();
      }
      return browser;
    } // CONCATENATED MODULE: ./node_modules/swiper/core/modules/resize/resize.js

    function Resize({ swiper, on, emit }) {
      const window = ssr_window_esm_getWindow();
      let observer = null;
      let animationFrame = null;
      const resizeHandler = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
      };
      const createObserver = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries) => {
          animationFrame = window.requestAnimationFrame(() => {
            const { width, height } = swiper;
            let newWidth = width;
            let newHeight = height;
            entries.forEach(({ contentBoxSize, contentRect, target }) => {
              if (target && target !== swiper.el) return;
              newWidth = contentRect
                ? contentRect.width
                : (contentBoxSize[0] || contentBoxSize).inlineSize;
              newHeight = contentRect
                ? contentRect.height
                : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) {
              resizeHandler();
            }
          });
        });
        observer.observe(swiper.el);
      };
      const removeObserver = () => {
        if (animationFrame) {
          window.cancelAnimationFrame(animationFrame);
        }
        if (observer && observer.unobserve && swiper.el) {
          observer.unobserve(swiper.el);
          observer = null;
        }
      };
      const orientationChangeHandler = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
      };
      on("init", () => {
        if (
          swiper.params.resizeObserver &&
          typeof window.ResizeObserver !== "undefined"
        ) {
          createObserver();
          return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
      });
      on("destroy", () => {
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener(
          "orientationchange",
          orientationChangeHandler
        );
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/core/modules/observer/observer.js
    function Observer({ swiper, extendParams, on, emit }) {
      const observers = [];
      const window = ssr_window_esm_getWindow();
      const attach = (target, options = {}) => {
        const ObserverFunc =
          window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations) => {
          // The observerUpdate event should only be triggered
          // once despite the number of mutations.  Additional
          // triggers are redundant and are very costly
          if (mutations.length === 1) {
            emit("observerUpdate", mutations[0]);
            return;
          }
          const observerUpdate = function observerUpdate() {
            emit("observerUpdate", mutations[0]);
          };
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(observerUpdate);
          } else {
            window.setTimeout(observerUpdate, 0);
          }
        });
        observer.observe(target, {
          attributes:
            typeof options.attributes === "undefined"
              ? true
              : options.attributes,
          childList:
            typeof options.childList === "undefined" ? true : options.childList,
          characterData:
            typeof options.characterData === "undefined"
              ? true
              : options.characterData,
        });
        observers.push(observer);
      };
      const init = () => {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
          const containerParents = swiper.$el.parents();
          for (let i = 0; i < containerParents.length; i += 1) {
            attach(containerParents[i]);
          }
        } // Observe container

        attach(swiper.$el[0], {
          childList: swiper.params.observeSlideChildren,
        }); // Observe wrapper

        attach(swiper.$wrapperEl[0], {
          attributes: false,
        });
      };
      const destroy = () => {
        observers.forEach((observer) => {
          observer.disconnect();
        });
        observers.splice(0, observers.length);
      };
      extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false,
      });
      on("init", init);
      on("destroy", destroy);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/events-emitter.js
    /* eslint-disable no-underscore-dangle */
    /* harmony default export */ const events_emitter = {
      on(events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event) => {
          if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
          self.eventsListeners[event][method](handler);
        });
        return self;
      },
      once(events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler(...args) {
          self.off(events, onceHandler);
          if (onceHandler.__emitterProxy) {
            delete onceHandler.__emitterProxy;
          }
          handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
      },
      onAny(handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) {
          self.eventsAnyListeners[method](handler);
        }
        return self;
      },
      offAny(handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) {
          self.eventsAnyListeners.splice(index, 1);
        }
        return self;
      },
      off(events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event) => {
          if (typeof handler === "undefined") {
            self.eventsListeners[event] = [];
          } else if (self.eventsListeners[event]) {
            self.eventsListeners[event].forEach((eventHandler, index) => {
              if (
                eventHandler === handler ||
                (eventHandler.__emitterProxy &&
                  eventHandler.__emitterProxy === handler)
              ) {
                self.eventsListeners[event].splice(index, 1);
              }
            });
          }
        });
        return self;
      },
      emit(...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
          events = args[0];
          data = args.slice(1, args.length);
          context = self;
        } else {
          events = args[0].events;
          data = args[0].data;
          context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event) => {
          if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
            self.eventsAnyListeners.forEach((eventHandler) => {
              eventHandler.apply(context, [event, ...data]);
            });
          }
          if (self.eventsListeners && self.eventsListeners[event]) {
            self.eventsListeners[event].forEach((eventHandler) => {
              eventHandler.apply(context, data);
            });
          }
        });
        return self;
      },
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSize.js
    function updateSize() {
      const swiper = this;
      let width;
      let height;
      const $el = swiper.$el;
      if (
        typeof swiper.params.width !== "undefined" &&
        swiper.params.width !== null
      ) {
        width = swiper.params.width;
      } else {
        width = $el[0].clientWidth;
      }
      if (
        typeof swiper.params.height !== "undefined" &&
        swiper.params.height !== null
      ) {
        height = swiper.params.height;
      } else {
        height = $el[0].clientHeight;
      }
      if (
        (width === 0 && swiper.isHorizontal()) ||
        (height === 0 && swiper.isVertical())
      ) {
        return;
      } // Subtract paddings

      width =
        width -
        parseInt($el.css("padding-left") || 0, 10) -
        parseInt($el.css("padding-right") || 0, 10);
      height =
        height -
        parseInt($el.css("padding-top") || 0, 10) -
        parseInt($el.css("padding-bottom") || 0, 10);
      if (Number.isNaN(width)) width = 0;
      if (Number.isNaN(height)) height = 0;
      Object.assign(swiper, {
        width,
        height,
        size: swiper.isHorizontal() ? width : height,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlides.js
    function updateSlides() {
      const swiper = this;
      function getDirectionLabel(property) {
        if (swiper.isHorizontal()) {
          return property;
        } // prettier-ignore

        return {
          width: "height",
          "margin-top": "margin-left",
          "margin-bottom ": "margin-right",
          "margin-left": "margin-top",
          "margin-right": "margin-bottom",
          "padding-left": "padding-top",
          "padding-right": "padding-bottom",
          marginRight: "marginBottom",
        }[property];
      }
      function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
      }
      const params = swiper.params;
      const {
        $wrapperEl,
        size: swiperSize,
        rtlTranslate: rtl,
        wrongRTL,
      } = swiper;
      const isVirtual = swiper.virtual && params.virtual.enabled;
      const previousSlidesLength = isVirtual
        ? swiper.virtual.slides.length
        : swiper.slides.length;
      const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
      const slidesLength = isVirtual
        ? swiper.virtual.slides.length
        : slides.length;
      let snapGrid = [];
      const slidesGrid = [];
      const slidesSizesGrid = [];
      let offsetBefore = params.slidesOffsetBefore;
      if (typeof offsetBefore === "function") {
        offsetBefore = params.slidesOffsetBefore.call(swiper);
      }
      let offsetAfter = params.slidesOffsetAfter;
      if (typeof offsetAfter === "function") {
        offsetAfter = params.slidesOffsetAfter.call(swiper);
      }
      const previousSnapGridLength = swiper.snapGrid.length;
      const previousSlidesGridLength = swiper.slidesGrid.length;
      let spaceBetween = params.spaceBetween;
      let slidePosition = -offsetBefore;
      let prevSlideSize = 0;
      let index = 0;
      if (typeof swiperSize === "undefined") {
        return;
      }
      if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) {
        spaceBetween =
          (parseFloat(spaceBetween.replace("%", "")) / 100) * swiperSize;
      }
      swiper.virtualSize = -spaceBetween; // reset margins

      if (rtl)
        slides.css({
          marginLeft: "",
          marginBottom: "",
          marginTop: "",
        });
      else
        slides.css({
          marginRight: "",
          marginBottom: "",
          marginTop: "",
        }); // reset cssMode offsets

      if (params.centeredSlides && params.cssMode) {
        utils_setCSSProperty(
          swiper.wrapperEl,
          "--swiper-centered-offset-before",
          ""
        );
        utils_setCSSProperty(
          swiper.wrapperEl,
          "--swiper-centered-offset-after",
          ""
        );
      }
      const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
      if (gridEnabled) {
        swiper.grid.initSlides(slidesLength);
      } // Calc slides

      let slideSize;
      const shouldResetSlideSize =
        params.slidesPerView === "auto" &&
        params.breakpoints &&
        Object.keys(params.breakpoints).filter((key) => {
          return typeof params.breakpoints[key].slidesPerView !== "undefined";
        }).length > 0;
      for (let i = 0; i < slidesLength; i += 1) {
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) {
          swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        }
        if (slide.css("display") === "none") continue; // eslint-disable-line

        if (params.slidesPerView === "auto") {
          if (shouldResetSlideSize) {
            slides[i].style[getDirectionLabel("width")] = ``;
          }
          const slideStyles = getComputedStyle(slide[0]);
          const currentTransform = slide[0].style.transform;
          const currentWebKitTransform = slide[0].style.webkitTransform;
          if (currentTransform) {
            slide[0].style.transform = "none";
          }
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = "none";
          }
          if (params.roundLengths) {
            slideSize = swiper.isHorizontal()
              ? slide.outerWidth(true)
              : slide.outerHeight(true);
          } else {
            // eslint-disable-next-line
            const width = getDirectionPropertyValue(slideStyles, "width");
            const paddingLeft = getDirectionPropertyValue(
              slideStyles,
              "padding-left"
            );
            const paddingRight = getDirectionPropertyValue(
              slideStyles,
              "padding-right"
            );
            const marginLeft = getDirectionPropertyValue(
              slideStyles,
              "margin-left"
            );
            const marginRight = getDirectionPropertyValue(
              slideStyles,
              "margin-right"
            );
            const boxSizing = slideStyles.getPropertyValue("box-sizing");
            if (boxSizing && boxSizing === "border-box") {
              slideSize = width + marginLeft + marginRight;
            } else {
              const { clientWidth, offsetWidth } = slide[0];
              slideSize =
                width +
                paddingLeft +
                paddingRight +
                marginLeft +
                marginRight +
                (offsetWidth - clientWidth);
            }
          }
          if (currentTransform) {
            slide[0].style.transform = currentTransform;
          }
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = currentWebKitTransform;
          }
          if (params.roundLengths) {
            slideSize = Math.floor(slideSize);
          }
        } else {
          slideSize =
            (swiperSize - (params.slidesPerView - 1) * spaceBetween) /
            params.slidesPerView;
          // console.log("swiper",slideSize,swiperSize,params.slidesPerView,spaceBetween,params.slidesPerView)
          if (params.roundLengths) {
            slideSize = Math.floor(slideSize);
          }
          if (slides[i]) {
            slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
          }
        }
        if (slides[i]) {
          slides[i].swiperSlideSize = slideSize;
        }
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
          slidePosition =
            slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
          if (prevSlideSize === 0 && i !== 0)
            slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (i === 0)
            slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
        } else {
          if (params.roundLengths) slidePosition = Math.floor(slidePosition);
          if (
            (index - Math.min(swiper.params.slidesPerGroupSkip, index)) %
            swiper.params.slidesPerGroup ===
            0
          )
            snapGrid.push(slidePosition);
          slidesGrid.push(slidePosition);
          slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
      }
      swiper.virtualSize =
        Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
      if (
        rtl &&
        wrongRTL &&
        (params.effect === "slide" || params.effect === "coverflow")
      ) {
        $wrapperEl.css({
          width: `${swiper.virtualSize + params.spaceBetween}px`,
        });
      }
      if (params.setWrapperSize) {
        $wrapperEl.css({
          [getDirectionLabel("width")]: `${swiper.virtualSize + params.spaceBetween
            }px`,
        });
      }
      if (gridEnabled) {
        swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
      } // Remove last grid elements depending on width

      if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for (let i = 0; i < snapGrid.length; i += 1) {
          let slidesGridItem = snapGrid[i];
          if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
          if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
            newSlidesGrid.push(slidesGridItem);
          }
        }
        snapGrid = newSlidesGrid;
        if (
          Math.floor(swiper.virtualSize - swiperSize) -
          Math.floor(snapGrid[snapGrid.length - 1]) >
          1
        ) {
          snapGrid.push(swiper.virtualSize - swiperSize);
        }
      }
      if (snapGrid.length === 0) snapGrid = [0];
      if (params.spaceBetween !== 0) {
        const key =
          swiper.isHorizontal() && rtl
            ? "marginLeft"
            : getDirectionLabel("marginRight");
        slides
          .filter((_, slideIndex) => {
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) {
              return false;
            }
            return true;
          })
          .css({
            [key]: `${spaceBetween}px`,
          });
      }
      if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue) => {
          allSlidesSize +=
            slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap) => {
          if (snap < 0) return -offsetBefore;
          if (snap > maxSnap) return maxSnap + offsetAfter;
          return snap;
        });
      }
      if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue) => {
          allSlidesSize +=
            slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
          const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
          snapGrid.forEach((snap, snapIndex) => {
            snapGrid[snapIndex] = snap - allSlidesOffset;
          });
          slidesGrid.forEach((snap, snapIndex) => {
            slidesGrid[snapIndex] = snap + allSlidesOffset;
          });
        }
      }
      Object.assign(swiper, {
        slides,
        snapGrid,
        slidesGrid,
        slidesSizesGrid,
      });
      if (
        params.centeredSlides &&
        params.cssMode &&
        !params.centeredSlidesBounds
      ) {
        utils_setCSSProperty(
          swiper.wrapperEl,
          "--swiper-centered-offset-before",
          `${-snapGrid[0]}px`
        );
        utils_setCSSProperty(
          swiper.wrapperEl,
          "--swiper-centered-offset-after",
          `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2
          }px`
        );
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
      }
      if (slidesLength !== previousSlidesLength) {
        swiper.emit("slidesLengthChange");
      }
      if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
      }
      if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit("slidesGridLengthChange");
      }
      if (params.watchSlidesProgress) {
        swiper.updateSlidesOffset();
      }
      if (
        !isVirtual &&
        !params.cssMode &&
        (params.effect === "slide" || params.effect === "fade")
      ) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded =
          swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
          if (!hasClassBackfaceClassAdded)
            swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) {
          swiper.$el.removeClass(backFaceHiddenClass);
        }
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateAutoHeight.js
    function updateAutoHeight(speed) {
      const swiper = this;
      const activeSlides = [];
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      let newHeight = 0;
      let i;
      if (typeof speed === "number") {
        swiper.setTransition(speed);
      } else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
      }
      const getSlideByIndex = (index) => {
        if (isVirtual) {
          return swiper.slides.filter(
            (el) =>
              parseInt(el.getAttribute("data-swiper-slide-index"), 10) === index
          )[0];
        }
        return swiper.slides.eq(index)[0];
      }; // Find slides currently in view

      if (
        swiper.params.slidesPerView !== "auto" &&
        swiper.params.slidesPerView > 1
      ) {
        if (swiper.params.centeredSlides) {
          (swiper.visibleSlides || dom([])).each((slide) => {
            activeSlides.push(slide);
          });
        } else {
          for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
          }
        }
      } else {
        activeSlides.push(getSlideByIndex(swiper.activeIndex));
      } // Find new height from highest slide in view

      for (i = 0; i < activeSlides.length; i += 1) {
        if (typeof activeSlides[i] !== "undefined") {
          const height = activeSlides[i].offsetHeight;
          newHeight = height > newHeight ? height : newHeight;
        }
      } // Update Height

      if (newHeight || newHeight === 0)
        swiper.$wrapperEl.css("height", `${newHeight}px`);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesOffset.js
    function updateSlidesOffset() {
      const swiper = this;
      const slides = swiper.slides;
      for (let i = 0; i < slides.length; i += 1) {
        slides[i].swiperSlideOffset = swiper.isHorizontal()
          ? slides[i].offsetLeft
          : slides[i].offsetTop;
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesProgress.js
    function updateSlidesProgress(translate = (this && this.translate) || 0) {
      const swiper = this;
      const params = swiper.params;
      const { slides, rtlTranslate: rtl, snapGrid } = swiper;
      if (slides.length === 0) return;
      if (typeof slides[0].swiperSlideOffset === "undefined")
        swiper.updateSlidesOffset();
      let offsetCenter = -translate;
      if (rtl) offsetCenter = translate; // Visible Slides

      slides.removeClass(params.slideVisibleClass);
      swiper.visibleSlidesIndexes = [];
      swiper.visibleSlides = [];
      for (let i = 0; i < slides.length; i += 1) {
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) {
          slideOffset -= slides[0].swiperSlideOffset;
        }
        const slideProgress =
          (offsetCenter +
            (params.centeredSlides ? swiper.minTranslate() : 0) -
            slideOffset) /
          (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress =
          (offsetCenter -
            snapGrid[0] +
            (params.centeredSlides ? swiper.minTranslate() : 0) -
            slideOffset) /
          (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible =
          (slideBefore >= 0 && slideBefore < swiper.size - 1) ||
          (slideAfter > 1 && slideAfter <= swiper.size) ||
          (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
          swiper.visibleSlides.push(slide);
          swiper.visibleSlidesIndexes.push(i);
          slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl
          ? -originalSlideProgress
          : originalSlideProgress;
      }
      swiper.visibleSlides = dom(swiper.visibleSlides);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateProgress.js
    function updateProgress(translate) {
      const swiper = this;
      if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

        translate =
          (swiper && swiper.translate && swiper.translate * multiplier) || 0;
      }
      const params = swiper.params;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      let { progress, isBeginning, isEnd } = swiper;
      const wasBeginning = isBeginning;
      const wasEnd = isEnd;
      if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
      } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
      }
      Object.assign(swiper, {
        progress,
        isBeginning,
        isEnd,
      });
      if (
        params.watchSlidesProgress ||
        (params.centeredSlides && params.autoHeight)
      )
        swiper.updateSlidesProgress(translate);
      if (isBeginning && !wasBeginning) {
        swiper.emit("reachBeginning toEdge");
      }
      if (isEnd && !wasEnd) {
        swiper.emit("reachEnd toEdge");
      }
      if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
        swiper.emit("fromEdge");
      }
      swiper.emit("progress", progress);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateSlidesClasses.js
    function updateSlidesClasses() {
      const swiper = this;
      const { slides, params, $wrapperEl, activeIndex, realIndex } = swiper;
      //更新轮播图小点状态
      const dots = swiper.$el[0].querySelectorAll(".dot");
      dots.forEach((dot, index) => {
        let activeDotIndex;
        if (activeIndex === dots.length + 1) {
          activeDotIndex = 0;
        } else if (activeIndex === 0) {
          activeDotIndex = dots.length - 1;
        } else {
          activeDotIndex = activeIndex - 1;
        }
        if (index === activeDotIndex) {
          dot.classList.add("active");
        } else {
          dot.classList.remove("active");
        }
      });
      const isVirtual = swiper.virtual && params.virtual.enabled;
      slides.removeClass(
        `${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`
      );
      let activeSlide;
      if (isVirtual) {
        activeSlide = swiper.$wrapperEl.find(
          `.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`
        );
      } else {
        activeSlide = slides.eq(activeIndex);
      } // Active classes

      activeSlide.addClass(params.slideActiveClass);
      if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl
            .children(
              `.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`
            )
            .addClass(params.slideDuplicateActiveClass);
        } else {
          $wrapperEl
            .children(
              `.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`
            )
            .addClass(params.slideDuplicateActiveClass);
        }
      } // Next Slide

      let nextSlide = activeSlide
        .nextAll(`.${params.slideClass}`)
        .eq(0)
        .addClass(params.slideNextClass);
      if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
      } // Prev Slide

      let prevSlide = activeSlide
        .prevAll(`.${params.slideClass}`)
        .eq(0)
        .addClass(params.slidePrevClass);
      if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
      }
      if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl
            .children(
              `.${params.slideClass}:not(.${params.slideDuplicateClass
              })[data-swiper-slide-index="${nextSlide.attr(
                "data-swiper-slide-index"
              )}"]`
            )
            .addClass(params.slideDuplicateNextClass);
        } else {
          $wrapperEl
            .children(
              `.${params.slideClass}.${params.slideDuplicateClass
              }[data-swiper-slide-index="${nextSlide.attr(
                "data-swiper-slide-index"
              )}"]`
            )
            .addClass(params.slideDuplicateNextClass);
        }
        if (prevSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl
            .children(
              `.${params.slideClass}:not(.${params.slideDuplicateClass
              })[data-swiper-slide-index="${prevSlide.attr(
                "data-swiper-slide-index"
              )}"]`
            )
            .addClass(params.slideDuplicatePrevClass);
        } else {
          $wrapperEl
            .children(
              `.${params.slideClass}.${params.slideDuplicateClass
              }[data-swiper-slide-index="${prevSlide.attr(
                "data-swiper-slide-index"
              )}"]`
            )
            .addClass(params.slideDuplicatePrevClass);
        }
      }
      swiper.emitSlidesClasses();
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateActiveIndex.js
    function updateActiveIndex(newActiveIndex) {
      const swiper = this;
      const translate = swiper.rtlTranslate
        ? swiper.translate
        : -swiper.translate;
      const {
        slidesGrid,
        snapGrid,
        params,
        activeIndex: previousIndex,
        realIndex: previousRealIndex,
        snapIndex: previousSnapIndex,
      } = swiper;
      let activeIndex = newActiveIndex;
      let snapIndex;
      if (typeof activeIndex === "undefined") {
        for (let i = 0; i < slidesGrid.length; i += 1) {
          if (typeof slidesGrid[i + 1] !== "undefined") {
            if (
              translate >= slidesGrid[i] &&
              translate <
              slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2
            ) {
              activeIndex = i;
            } else if (
              translate >= slidesGrid[i] &&
              translate < slidesGrid[i + 1]
            ) {
              activeIndex = i + 1;
            }
          } else if (translate >= slidesGrid[i]) {
            activeIndex = i;
          }
        } // Normalize slideIndex

        if (params.normalizeSlideIndex) {
          if (activeIndex < 0 || typeof activeIndex === "undefined")
            activeIndex = 0;
        }
      }
      if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
      } else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex =
          skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
      }
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
      if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
          swiper.snapIndex = snapIndex;
          swiper.emit("snapIndexChange");
        }
        return;
      } // Get real index

      const realIndex = parseInt(
        swiper.slides.eq(activeIndex).attr("data-swiper-slide-index") ||
        activeIndex,
        10
      );
      Object.assign(swiper, {
        snapIndex,
        realIndex,
        previousIndex,
        activeIndex,
      });
      swiper.emit("activeIndexChange");
      swiper.emit("snapIndexChange");
      if (previousRealIndex !== realIndex) {
        swiper.emit("realIndexChange");
      }
      if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        swiper.emit("slideChange");
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/updateClickedSlide.js
    function updateClickedSlide(e) {
      const swiper = this;
      const params = swiper.params;
      const slide = dom(e).closest(`.${params.slideClass}`)[0];
      let slideFound = false;
      let slideIndex;
      if (slide) {
        for (let i = 0; i < swiper.slides.length; i += 1) {
          if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
          }
        }
      }
      if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) {
          swiper.clickedIndex = parseInt(
            dom(slide).attr("data-swiper-slide-index"),
            10
          );
        } else {
          swiper.clickedIndex = slideIndex;
        }
      } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
      }
      if (
        params.slideToClickedSlide &&
        swiper.clickedIndex !== undefined &&
        swiper.clickedIndex !== swiper.activeIndex
      ) {
        swiper.slideToClickedSlide();
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/update/index.js
    /* harmony default export */ const update = {
      updateSize: updateSize,
      updateSlides: updateSlides,
      updateAutoHeight: updateAutoHeight,
      updateSlidesOffset: updateSlidesOffset,
      updateSlidesProgress: updateSlidesProgress,
      updateProgress: updateProgress,
      updateSlidesClasses: updateSlidesClasses,
      updateActiveIndex: updateActiveIndex,
      updateClickedSlide: updateClickedSlide,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/translate/getTranslate.js
    function getSwiperTranslate(axis = this.isHorizontal() ? "x" : "y") {
      const swiper = this;
      const { params, rtlTranslate: rtl, translate, $wrapperEl } = swiper;
      if (params.virtualTranslate) {
        return rtl ? -translate : translate;
      }
      if (params.cssMode) {
        return translate;
      }
      let currentTranslate = utils_getTranslate($wrapperEl[0], axis);
      if (rtl) currentTranslate = -currentTranslate;
      return currentTranslate || 0;
    } // CONCATENATED MODULE: ./node_modules/swiper/core/translate/setTranslate.js
    function setTranslate(translate, byController) {
      const swiper = this;
      const {
        rtlTranslate: rtl,
        params,
        $wrapperEl,
        wrapperEl,
        progress,
      } = swiper;
      let x = 0;
      let y = 0;
      const z = 0;
      if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
      } else {
        y = translate;
      }
      if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
      }
      if (params.cssMode) {
        wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] =
          swiper.isHorizontal() ? -x : -y;
      } else if (!params.virtualTranslate) {
        $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
      }
      swiper.previousTranslate = swiper.translate;
      swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

      let newProgress;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== progress) {
        swiper.updateProgress(translate);
      }
      swiper.emit("setTranslate", swiper.translate, byController);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/translate/minTranslate.js
    function minTranslate() {
      return -this.snapGrid[0];
    } // CONCATENATED MODULE: ./node_modules/swiper/core/translate/maxTranslate.js
    function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    } // CONCATENATED MODULE: ./node_modules/swiper/core/translate/translateTo.js
    function translateTo(
      translate = 0,
      speed = this.params.speed,
      runCallbacks = true,
      translateBounds = true,
      internal
    ) {
      const swiper = this;
      const { params, wrapperEl } = swiper;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }
      const minTranslate = swiper.minTranslate();
      const maxTranslate = swiper.maxTranslate();
      let newTranslate;
      if (translateBounds && translate > minTranslate)
        newTranslate = minTranslate;
      else if (translateBounds && translate < maxTranslate)
        newTranslate = maxTranslate;
      else newTranslate = translate; // Update progress

      swiper.updateProgress(newTranslate);
      if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) {
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        } else {
          if (!swiper.support.smoothScroll) {
            animateCSSModeScroll({
              swiper,
              targetPosition: -newTranslate,
              side: isH ? "left" : "top",
            });
            return true;
          }
          wrapperEl.scrollTo({
            [isH ? "left" : "top"]: -newTranslate,
            behavior: "smooth",
          });
        }
        return true;
      }
      if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
          swiper.emit("beforeTransitionStart", speed, internal);
          swiper.emit("transitionEnd");
        }
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
          swiper.emit("beforeTransitionStart", speed, internal);
          swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
          swiper.animating = true;
          if (!swiper.onTranslateToWrapperTransitionEnd) {
            swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(
              e
            ) {
              if (!swiper || swiper.destroyed) return;
              if (e.target !== this) return;
              swiper.$wrapperEl[0].removeEventListener(
                "transitionend",
                swiper.onTranslateToWrapperTransitionEnd
              );
              swiper.$wrapperEl[0].removeEventListener(
                "webkitTransitionEnd",
                swiper.onTranslateToWrapperTransitionEnd
              );
              swiper.onTranslateToWrapperTransitionEnd = null;
              delete swiper.onTranslateToWrapperTransitionEnd;
              if (runCallbacks) {
                swiper.emit("transitionEnd");
              }
            };
          }
          swiper.$wrapperEl[0].addEventListener(
            "transitionend",
            swiper.onTranslateToWrapperTransitionEnd
          );
          swiper.$wrapperEl[0].addEventListener(
            "webkitTransitionEnd",
            swiper.onTranslateToWrapperTransitionEnd
          );
        }
      }
      return true;
    } // CONCATENATED MODULE: ./node_modules/swiper/core/translate/index.js
    /* harmony default export */ const translate = {
      getTranslate: getSwiperTranslate,
      setTranslate: setTranslate,
      minTranslate: minTranslate,
      maxTranslate: maxTranslate,
      translateTo: translateTo,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/transition/setTransition.js
    function setTransition(duration, byController) {
      const swiper = this;
      if (!swiper.params.cssMode) {
        swiper.$wrapperEl.transition(duration);
      }
      swiper.emit("setTransition", duration, byController);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionEmit.js
    function transitionEmit({ swiper, runCallbacks, direction, step }) {
      const { activeIndex, previousIndex } = swiper;
      let dir = direction;
      if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
      }
      swiper.emit(`transition${step}`);
      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
          swiper.emit(`slideResetTransition${step}`);
          return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") {
          swiper.emit(`slideNextTransition${step}`);
        } else {
          swiper.emit(`slidePrevTransition${step}`);
        }
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionStart.js
    function transitionStart_transitionStart(runCallbacks = true, direction) {
      const swiper = this;
      const { params } = swiper;
      if (params.cssMode) return;
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: "Start",
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/core/transition/transitionEnd.js
    function transitionEnd_transitionEnd(runCallbacks = true, direction) {
      const swiper = this;
      const { params } = swiper;
      swiper.animating = false;
      if (params.cssMode) return;
      swiper.setTransition(0);
      transitionEmit({
        swiper,
        runCallbacks,
        direction,
        step: "End",
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/core/transition/index.js
    /* harmony default export */ const core_transition = {
      setTransition: setTransition,
      transitionStart: transitionStart_transitionStart,
      transitionEnd: transitionEnd_transitionEnd,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideTo.js
    function slideTo(
      index = 0,
      speed = this.params.speed,
      runCallbacks = true,
      internal,
      initial
    ) {
      if (typeof index !== "number" && typeof index !== "string") {
        throw new Error(
          `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`
        );
      }
      if (typeof index === "string") {
        /**
         * The `index` argument converted from `string` to `number`.
         * @type {number}
         */
        const indexAsNumber = parseInt(index, 10);
        /**
         * Determines whether the `index` argument is a valid `number`
         * after being converted from the `string` type.
         * @type {boolean}
         */

        const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) {
          throw new Error(
            `The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`
          );
        } // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.

        index = indexAsNumber;
      }
      const swiper = this;
      let slideIndex = index;
      if (slideIndex < 0) slideIndex = 0;
      const {
        params,
        snapGrid,
        slidesGrid,
        previousIndex,
        activeIndex,
        rtlTranslate: rtl,
        wrapperEl,
        enabled,
      } = swiper;
      if (
        (swiper.animating && params.preventInteractionOnTransition) ||
        (!enabled && !internal && !initial)
      ) {
        return false;
      }
      const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
      let snapIndex =
        skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
      if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
      const translate = -snapGrid[snapIndex]; // Normalize slideIndex

      if (params.normalizeSlideIndex) {
        for (let i = 0; i < slidesGrid.length; i += 1) {
          const normalizedTranslate = -Math.floor(translate * 100);
          const normalizedGrid = Math.floor(slidesGrid[i] * 100);
          const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
          if (typeof slidesGrid[i + 1] !== "undefined") {
            if (
              normalizedTranslate >= normalizedGrid &&
              normalizedTranslate <
              normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2
            ) {
              slideIndex = i;
            } else if (
              normalizedTranslate >= normalizedGrid &&
              normalizedTranslate < normalizedGridNext
            ) {
              slideIndex = i + 1;
            }
          } else if (normalizedTranslate >= normalizedGrid) {
            slideIndex = i;
          }
        }
      } // Directions locks

      if (swiper.initialized && slideIndex !== activeIndex) {
        if (
          !swiper.allowSlideNext &&
          translate < swiper.translate &&
          translate < swiper.minTranslate()
        ) {
          return false;
        }
        if (
          !swiper.allowSlidePrev &&
          translate > swiper.translate &&
          translate > swiper.maxTranslate()
        ) {
          if ((activeIndex || 0) !== slideIndex) return false;
        }
      }
      if (slideIndex !== (previousIndex || 0) && runCallbacks) {
        swiper.emit("beforeSlideChangeStart");
      } // Update progress

      swiper.updateProgress(translate);
      let direction;
      if (slideIndex > activeIndex) direction = "next";
      else if (slideIndex < activeIndex) direction = "prev";
      else direction = "reset"; // Update Index

      if (
        (rtl && -translate === swiper.translate) ||
        (!rtl && translate === swiper.translate)
      ) {
        swiper.updateActiveIndex(slideIndex); // Update Height

        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") {
          swiper.setTranslate(translate);
        }
        if (direction !== "reset") {
          swiper.transitionStart(runCallbacks, direction);
          swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
      }
      if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
          const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
          if (isVirtual) {
            swiper.wrapperEl.style.scrollSnapType = "none";
            swiper._immediateVirtual = true;
          }
          wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
          if (isVirtual) {
            requestAnimationFrame(() => {
              swiper.wrapperEl.style.scrollSnapType = "";
              swiper._swiperImmediateVirtual = false;
            });
          }
        } else {
          if (!swiper.support.smoothScroll) {
            animateCSSModeScroll({
              swiper,
              targetPosition: t,
              side: isH ? "left" : "top",
            });
            return true;
          }
          wrapperEl.scrollTo({
            [isH ? "left" : "top"]: t,
            behavior: "smooth",
          });
        }
        return true;
      }
      swiper.setTransition(speed);
      swiper.setTranslate(translate);
      swiper.updateActiveIndex(slideIndex);
      swiper.updateSlidesClasses();
      swiper.emit("beforeTransitionStart", speed, internal);
      swiper.transitionStart(runCallbacks, direction);
      if (speed === 0) {
        swiper.transitionEnd(runCallbacks, direction);
      } else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
          swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener(
              "transitionend",
              swiper.onSlideToWrapperTransitionEnd
            );
            swiper.$wrapperEl[0].removeEventListener(
              "webkitTransitionEnd",
              swiper.onSlideToWrapperTransitionEnd
            );
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
          };
        }
        swiper.$wrapperEl[0].addEventListener(
          "transitionend",
          swiper.onSlideToWrapperTransitionEnd
        );
        swiper.$wrapperEl[0].addEventListener(
          "webkitTransitionEnd",
          swiper.onSlideToWrapperTransitionEnd
        );
      }
      return true;
    } // CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToLoop.js
    function slideToLoop(
      index = 0,
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      if (typeof index === "string") {
        /**
         * The `index` argument converted from `string` to `number`.
         * @type {number}
         */
        const indexAsNumber = parseInt(index, 10);
        /**
         * Determines whether the `index` argument is a valid `number`
         * after being converted from the `string` type.
         * @type {boolean}
         */

        const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) {
          throw new Error(
            `The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`
          );
        } // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.

        index = indexAsNumber;
      }
      const swiper = this;
      let newIndex = index;
      if (swiper.params.loop) {
        newIndex += swiper.loopedSlides;
      }
      return swiper.slideTo(newIndex, speed, runCallbacks, internal);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideNext.js
    /* eslint no-unused-vars: "off" */
    function slideNext(
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      const swiper = this;
      const { animating, enabled, params } = swiper;
      if (!enabled) return swiper;
      let perGroup = params.slidesPerGroup;
      if (
        params.slidesPerView === "auto" &&
        params.slidesPerGroup === 1 &&
        params.slidesPerGroupAuto
      ) {
        perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
      }
      const increment =
        swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
      if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
      if (params.rewind && swiper.isEnd) {
        return swiper.slideTo(0, speed, runCallbacks, internal);
      }
      // console.log(swiper.activeIndex,increment,speed,runCallbacks,internal)
      return swiper.slideTo(
        swiper.activeIndex + increment,
        speed,
        runCallbacks,
        internal
      );
    } // CONCATENATED MODULE: ./node_modules/swiper/core/slide/slidePrev.js
    /* eslint no-unused-vars: "off" */
    function slidePrev(
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      const swiper = this;
      const { params, animating, snapGrid, slidesGrid, rtlTranslate, enabled } =
        swiper;
      if (!enabled) return swiper;
      if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
      const translate = rtlTranslate ? swiper.translate : -swiper.translate;
      function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
      }
      const normalizedTranslate = normalize(translate);
      const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
      let prevSnap =
        snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
      if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex) => {
          if (normalizedTranslate >= snap) {
            // prevSnap = snap;
            prevSnapIndex = snapIndex;
          }
        });
        if (typeof prevSnapIndex !== "undefined") {
          prevSnap =
            snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
        }
      }
      let prevIndex = 0;
      if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (
          params.slidesPerView === "auto" &&
          params.slidesPerGroup === 1 &&
          params.slidesPerGroupAuto
        ) {
          prevIndex =
            prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
          prevIndex = Math.max(prevIndex, 0);
        }
      }
      if (params.rewind && swiper.isBeginning) {
        const lastIndex =
          swiper.params.virtual &&
            swiper.params.virtual.enabled &&
            swiper.virtual
            ? swiper.virtual.slides.length - 1
            : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
      }
      // console.log(prevIndex,speed,runCallbacks,internal)
      return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideReset.js
    /* eslint no-unused-vars: "off" */
    function slideReset(
      speed = this.params.speed,
      runCallbacks = true,
      internal
    ) {
      const swiper = this;
      return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToClosest.js
    /* eslint no-unused-vars: "off" */
    function slideToClosest(
      speed = this.params.speed,
      runCallbacks = true,
      internal,
      threshold = 0.5
    ) {
      const swiper = this;
      let index = swiper.activeIndex;
      const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
      const snapIndex =
        skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
      const translate = swiper.rtlTranslate
        ? swiper.translate
        : -swiper.translate;
      if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
          index += swiper.params.slidesPerGroup;
        }
      } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
          index -= swiper.params.slidesPerGroup;
        }
      }
      index = Math.max(index, 0);
      index = Math.min(index, swiper.slidesGrid.length - 1);
      return swiper.slideTo(index, speed, runCallbacks, internal);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/slide/slideToClickedSlide.js
    function slideToClickedSlide() {
      const swiper = this;
      const { params, $wrapperEl } = swiper;
      const slidesPerView =
        params.slidesPerView === "auto"
          ? swiper.slidesPerViewDynamic()
          : params.slidesPerView;
      let slideToIndex = swiper.clickedIndex;
      let realIndex;
      if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(
          dom(swiper.clickedSlide).attr("data-swiper-slide-index"),
          10
        );
        if (params.centeredSlides) {
          if (
            slideToIndex < swiper.loopedSlides - slidesPerView / 2 ||
            slideToIndex >
            swiper.slides.length - swiper.loopedSlides + slidesPerView / 2
          ) {
            swiper.loopFix();
            slideToIndex = $wrapperEl
              .children(
                `.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`
              )
              .eq(0)
              .index();
            utils_nextTick(() => {
              swiper.slideTo(slideToIndex);
            });
          } else {
            swiper.slideTo(slideToIndex);
          }
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
          swiper.loopFix();
          slideToIndex = $wrapperEl
            .children(
              `.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`
            )
            .eq(0)
            .index();
          utils_nextTick(() => {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else {
        swiper.slideTo(slideToIndex);
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/slide/index.js
    /* harmony default export */ const slide = {
      slideTo: slideTo,
      slideToLoop: slideToLoop,
      slideNext: slideNext,
      slidePrev: slidePrev,
      slideReset: slideReset,
      slideToClosest: slideToClosest,
      slideToClickedSlide: slideToClickedSlide,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopCreate.js
    function loopCreate() {
      const swiper = this;
      const document = ssr_window_esm_getDocument();
      const { params, $wrapperEl } = swiper; // Remove duplicated slides

      const $selector =
        $wrapperEl.children().length > 0
          ? dom($wrapperEl.children()[0].parentNode)
          : $wrapperEl;
      $selector
        .children(`.${params.slideClass}.${params.slideDuplicateClass}`)
        .remove();
      let slides = $selector.children(`.${params.slideClass}`);
      if (params.loopFillGroupWithBlank) {
        const blankSlidesNum =
          params.slidesPerGroup - (slides.length % params.slidesPerGroup);
        if (blankSlidesNum !== params.slidesPerGroup) {
          for (let i = 0; i < blankSlidesNum; i += 1) {
            const blankNode = dom(document.createElement("div")).addClass(
              `${params.slideClass} ${params.slideBlankClass}`
            );
            $selector.append(blankNode);
          }
          slides = $selector.children(`.${params.slideClass}`);
        }
      }
      if (params.slidesPerView === "auto" && !params.loopedSlides)
        params.loopedSlides = slides.length;
      swiper.loopedSlides = Math.ceil(
        parseFloat(params.loopedSlides || params.slidesPerView, 10)
      );
      swiper.loopedSlides += params.loopAdditionalSlides;
      if (
        swiper.loopedSlides > slides.length &&
        swiper.params.loopedSlidesLimit
      ) {
        swiper.loopedSlides = slides.length;
      }
      const prependSlides = [];
      const appendSlides = [];
      slides.each((el, index) => {
        const slide = dom(el);
        slide.attr("data-swiper-slide-index", index);
      });
      for (let i = 0; i < swiper.loopedSlides; i += 1) {
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
      }
      for (let i = 0; i < appendSlides.length; i += 1) {
        $selector.append(
          dom(appendSlides[i].cloneNode(true)).addClass(
            params.slideDuplicateClass
          )
        );
      }
      for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
        $selector.prepend(
          dom(prependSlides[i].cloneNode(true)).addClass(
            params.slideDuplicateClass
          )
        );
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopFix.js
    function loopFix() {
      const swiper = this;
      swiper.emit("beforeLoopFix");
      const {
        activeIndex,
        slides,
        loopedSlides,
        allowSlidePrev,
        allowSlideNext,
        snapGrid,
        rtlTranslate: rtl,
      } = swiper;
      let newIndex;
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      const snapTranslate = -snapGrid[activeIndex];
      const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

      if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) {
          swiper.setTranslate(
            (rtl ? -swiper.translate : swiper.translate) - diff
          );
        }
      } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) {
          swiper.setTranslate(
            (rtl ? -swiper.translate : swiper.translate) - diff
          );
        }
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      swiper.emit("loopFix");
    } // CONCATENATED MODULE: ./node_modules/swiper/core/loop/loopDestroy.js
    function loopDestroy() {
      const swiper = this;
      const { $wrapperEl, params, slides } = swiper;
      $wrapperEl
        .children(
          `.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`
        )
        .remove();
      slides.removeAttr("data-swiper-slide-index");
    } // CONCATENATED MODULE: ./node_modules/swiper/core/loop/index.js
    /* harmony default export */ const loop = {
      loopCreate: loopCreate,
      loopFix: loopFix,
      loopDestroy: loopDestroy,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/setGrabCursor.js
    function setGrabCursor(moving) {
      const swiper = this;
      if (
        swiper.support.touch ||
        !swiper.params.simulateTouch ||
        (swiper.params.watchOverflow && swiper.isLocked) ||
        swiper.params.cssMode
      )
        return;
      const el =
        swiper.params.touchEventsTarget === "container"
          ? swiper.el
          : swiper.wrapperEl;
      el.style.cursor = "move";
      el.style.cursor = moving ? "grabbing" : "grab";
    } // CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/unsetGrabCursor.js
    function unsetGrabCursor() {
      const swiper = this;
      if (
        swiper.support.touch ||
        (swiper.params.watchOverflow && swiper.isLocked) ||
        swiper.params.cssMode
      ) {
        return;
      }
      swiper[
        swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"
      ].style.cursor = "";
    } // CONCATENATED MODULE: ./node_modules/swiper/core/grab-cursor/index.js
    /* harmony default export */ const grab_cursor = {
      setGrabCursor: setGrabCursor,
      unsetGrabCursor: unsetGrabCursor,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchStart.js
    // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

    function closestElement(selector, base = this) {
      function __closestFrom(el) {
        if (
          !el ||
          el === ssr_window_esm_getDocument() ||
          el === ssr_window_esm_getWindow()
        )
          return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) {
          return null;
        }
        return found || __closestFrom(el.getRootNode().host);
      }
      return __closestFrom(base);
    }
    function onTouchStart(event) {
      const swiper = this;
      const document = ssr_window_esm_getDocument();
      const window = ssr_window_esm_getWindow();
      const data = swiper.touchEventsData;
      const { params, touches, enabled } = swiper;
      if (!enabled) return;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return;
      }
      if (!swiper.animating && params.cssMode && params.loop) {
        swiper.loopFix();
      }
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      let $targetEl = dom(e.target);
      if (params.touchEventsTarget === "wrapper") {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
      }
      data.isTouchEvent = e.type === "touchstart";
      if (!data.isTouchEvent && "which" in e && e.which === 3) return;
      if (!data.isTouchEvent && "button" in e && e.button > 0) return;
      if (data.isTouched && data.isMoved) return; // change target el for shadow root component

      const swipingClassHasValue =
        !!params.noSwipingClass && params.noSwipingClass !== ""; // eslint-disable-next-line

      const eventPath = event.composedPath ? event.composedPath() : event.path;
      if (
        swipingClassHasValue &&
        e.target &&
        e.target.shadowRoot &&
        eventPath
      ) {
        $targetEl = dom(eventPath[0]);
      }
      const noSwipingSelector = params.noSwipingSelector
        ? params.noSwipingSelector
        : `.${params.noSwipingClass}`;
      const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

      if (
        params.noSwiping &&
        (isTargetShadow
          ? closestElement(noSwipingSelector, $targetEl[0])
          : $targetEl.closest(noSwipingSelector)[0])
      ) {
        swiper.allowClick = true;
        return;
      }
      if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
      }
      touches.currentX =
        e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
      touches.currentY =
        e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
      const startX = touches.currentX;
      const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

      const edgeSwipeDetection =
        params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
      const edgeSwipeThreshold =
        params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
      if (
        edgeSwipeDetection &&
        (startX <= edgeSwipeThreshold ||
          startX >= window.innerWidth - edgeSwipeThreshold)
      ) {
        if (edgeSwipeDetection === "prevent") {
          event.preventDefault();
        } else {
          return;
        }
      }
      Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined,
      });
      touches.startX = startX;
      touches.startY = startY;
      data.touchStartTime = utils_now();
      swiper.allowClick = true;
      swiper.updateSize();
      swiper.swipeDirection = undefined;
      if (params.threshold > 0) data.allowThresholdMove = false;
      if (e.type !== "touchstart") {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
          preventDefault = false;
          if ($targetEl[0].nodeName === "SELECT") {
            data.isTouched = false;
          }
        }
        if (
          document.activeElement &&
          dom(document.activeElement).is(data.focusableElements) &&
          document.activeElement !== $targetEl[0]
        ) {
          document.activeElement.blur();
        }
        const shouldPreventDefault =
          preventDefault &&
          swiper.allowTouchMove &&
          params.touchStartPreventDefault;
        if (
          (params.touchStartForcePreventDefault || shouldPreventDefault) &&
          !$targetEl[0].isContentEditable
        ) {
          e.preventDefault();
        }
      }
      if (
        swiper.params.freeMode &&
        swiper.params.freeMode.enabled &&
        swiper.freeMode &&
        swiper.animating &&
        !params.cssMode
      ) {
        swiper.freeMode.onTouchStart();
      }
      swiper.emit("touchStart", e);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchMove.js
    function onTouchMove(event) {
      const document = ssr_window_esm_getDocument();
      const swiper = this;
      const data = swiper.touchEventsData;
      const { params, touches, rtlTranslate: rtl, enabled } = swiper;
      if (!enabled) return;
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) {
          swiper.emit("touchMoveOpposite", e);
        }
        return;
      }
      if (data.isTouchEvent && e.type !== "touchmove") return;
      const targetTouch =
        e.type === "touchmove" &&
        e.targetTouches &&
        (e.targetTouches[0] || e.changedTouches[0]);
      const pageX = e.type === "touchmove" ? targetTouch.pageX : e.pageX;
      const pageY = e.type === "touchmove" ? targetTouch.pageY : e.pageY;
      if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
      }
      if (!swiper.allowTouchMove) {
        if (!dom(e.target).is(data.focusableElements)) {
          swiper.allowClick = false;
        }
        if (data.isTouched) {
          Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
          });
          data.touchStartTime = utils_now();
        }
        return;
      }
      if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
          // Vertical
          if (
            (pageY < touches.startY &&
              swiper.translate <= swiper.maxTranslate()) ||
            (pageY > touches.startY &&
              swiper.translate >= swiper.minTranslate())
          ) {
            data.isTouched = false;
            data.isMoved = false;
            return;
          }
        } else if (
          (pageX < touches.startX &&
            swiper.translate <= swiper.maxTranslate()) ||
          (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
        ) {
          return;
        }
      }
      if (data.isTouchEvent && document.activeElement) {
        if (
          e.target === document.activeElement &&
          dom(e.target).is(data.focusableElements)
        ) {
          data.isMoved = true;
          swiper.allowClick = false;
          return;
        }
      }
      if (data.allowTouchCallbacks) {
        swiper.emit("touchMove", e);
      }
      if (e.targetTouches && e.targetTouches.length > 1) return;
      touches.currentX = pageX;
      touches.currentY = pageY;
      const diffX = touches.currentX - touches.startX;
      const diffY = touches.currentY - touches.startY;
      if (
        swiper.params.threshold &&
        Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold
      )
        return;
      if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (
          (swiper.isHorizontal() && touches.currentY === touches.startY) ||
          (swiper.isVertical() && touches.currentX === touches.startX)
        ) {
          data.isScrolling = false;
        } else {
          // eslint-disable-next-line
          if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle =
              (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
            data.isScrolling = swiper.isHorizontal()
              ? touchAngle > params.touchAngle
              : 90 - touchAngle > params.touchAngle;
          }
        }
      }
      if (data.isScrolling) {
        swiper.emit("touchMoveOpposite", e);
      }
      if (typeof data.startMoving === "undefined") {
        if (
          touches.currentX !== touches.startX ||
          touches.currentY !== touches.startY
        ) {
          data.startMoving = true;
        }
      }
      if (data.isScrolling) {
        data.isTouched = false;
        return;
      }
      if (!data.startMoving) {
        return;
      }
      swiper.allowClick = false;
      if (!params.cssMode && e.cancelable) {
        e.preventDefault();
      }
      if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
      }
      if (!data.isMoved) {
        if (params.loop && !params.cssMode) {
          swiper.loopFix();
        }
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
          swiper.$wrapperEl.trigger("webkitTransitionEnd transitionend");
        }
        data.allowMomentumBounce = false; // Grab Cursor

        if (
          params.grabCursor &&
          (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)
        ) {
          swiper.setGrabCursor(true);
        }
        swiper.emit("sliderFirstMove", e);
      }
      swiper.emit("sliderMove", e);
      data.isMoved = true;
      let diff = swiper.isHorizontal() ? diffX : diffY;
      touches.diff = diff;
      diff *= params.touchRatio;
      if (rtl) diff = -diff;
      swiper.swipeDirection = diff > 0 ? "prev" : "next";
      data.currentTranslate = diff + data.startTranslate;
      let disableParentSwiper = true;
      let resistanceRatio = params.resistanceRatio;
      if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
      }
      if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance)
          data.currentTranslate =
            swiper.minTranslate() -
            1 +
            (-swiper.minTranslate() + data.startTranslate + diff) **
            resistanceRatio;
      } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance)
          data.currentTranslate =
            swiper.maxTranslate() +
            1 -
            (swiper.maxTranslate() - data.startTranslate - diff) **
            resistanceRatio;
      }
      if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
      } // Directions locks

      if (
        !swiper.allowSlideNext &&
        swiper.swipeDirection === "next" &&
        data.currentTranslate < data.startTranslate
      ) {
        data.currentTranslate = data.startTranslate;
      }
      if (
        !swiper.allowSlidePrev &&
        swiper.swipeDirection === "prev" &&
        data.currentTranslate > data.startTranslate
      ) {
        data.currentTranslate = data.startTranslate;
      }
      if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
        data.currentTranslate = data.startTranslate;
      } // Threshold

      if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
          if (!data.allowThresholdMove) {
            data.allowThresholdMove = true;
            touches.startX = touches.currentX;
            touches.startY = touches.currentY;
            data.currentTranslate = data.startTranslate;
            touches.diff = swiper.isHorizontal()
              ? touches.currentX - touches.startX
              : touches.currentY - touches.startY;
            return;
          }
        } else {
          data.currentTranslate = data.startTranslate;
          return;
        }
      }
      if (!params.followFinger || params.cssMode) return; // Update active index in free mode

      if (
        (params.freeMode && params.freeMode.enabled && swiper.freeMode) ||
        params.watchSlidesProgress
      ) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      if (
        swiper.params.freeMode &&
        params.freeMode.enabled &&
        swiper.freeMode
      ) {
        swiper.freeMode.onTouchMove();
      } // Update progress

      swiper.updateProgress(data.currentTranslate); // Update translate

      swiper.setTranslate(data.currentTranslate);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/events/onTouchEnd.js
    function onTouchEnd(event) {
      const swiper = this;
      const data = swiper.touchEventsData;
      const {
        params,
        touches,
        rtlTranslate: rtl,
        slidesGrid,
        enabled,
      } = swiper;
      if (!enabled) return;
      let e = event;
      if (e.originalEvent) e = e.originalEvent;
      if (data.allowTouchCallbacks) {
        swiper.emit("touchEnd", e);
      }
      data.allowTouchCallbacks = false;
      if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) {
          swiper.setGrabCursor(false);
        }
        data.isMoved = false;
        data.startMoving = false;
        return;
      } // Return Grab Cursor

      if (
        params.grabCursor &&
        data.isMoved &&
        data.isTouched &&
        (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)
      ) {
        swiper.setGrabCursor(false);
      } // Time diff

      const touchEndTime = utils_now();
      const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

      if (swiper.allowClick) {
        const pathTree = e.path || (e.composedPath && e.composedPath());
        swiper.updateClickedSlide((pathTree && pathTree[0]) || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
          swiper.emit("doubleTap doubleClick", e);
        }
      }
      data.lastClickTime = utils_now();
      utils_nextTick(() => {
        if (!swiper.destroyed) swiper.allowClick = true;
      });
      if (
        !data.isTouched ||
        !data.isMoved ||
        !swiper.swipeDirection ||
        touches.diff === 0 ||
        data.currentTranslate === data.startTranslate
      ) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      let currentPos;
      if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
      } else {
        currentPos = -data.currentTranslate;
      }
      if (params.cssMode) {
        return;
      }
      if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
          currentPos,
        });
        return;
      } // Find current slide

      let stopIndex = 0;
      let groupSize = swiper.slidesSizesGrid[0];
      for (
        let i = 0;
        i < slidesGrid.length;
        i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup
      ) {
        const increment =
          i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
          if (
            currentPos >= slidesGrid[i] &&
            currentPos < slidesGrid[i + increment]
          ) {
            stopIndex = i;
            groupSize = slidesGrid[i + increment] - slidesGrid[i];
          }
        } else if (currentPos >= slidesGrid[i]) {
          stopIndex = i;
          groupSize =
            slidesGrid[slidesGrid.length - 1] -
            slidesGrid[slidesGrid.length - 2];
        }
      }
      let rewindFirstIndex = null;
      let rewindLastIndex = null;
      if (params.rewind) {
        if (swiper.isBeginning) {
          rewindLastIndex =
            swiper.params.virtual &&
              swiper.params.virtual.enabled &&
              swiper.virtual
              ? swiper.virtual.slides.length - 1
              : swiper.slides.length - 1;
        } else if (swiper.isEnd) {
          rewindFirstIndex = 0;
        }
      } // Find current slide size

      const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
      const increment =
        stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
      if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (swiper.swipeDirection === "next") {
          if (ratio >= params.longSwipesRatio)
            swiper.slideTo(
              params.rewind && swiper.isEnd
                ? rewindFirstIndex
                : stopIndex + increment
            );
          else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
          if (ratio > 1 - params.longSwipesRatio) {
            swiper.slideTo(stopIndex + increment);
          } else if (
            rewindLastIndex !== null &&
            ratio < 0 &&
            Math.abs(ratio) > params.longSwipesRatio
          ) {
            swiper.slideTo(rewindLastIndex);
          } else {
            swiper.slideTo(stopIndex);
          }
        }
      } else {
        // Short swipes
        if (!params.shortSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        const isNavButtonTarget =
          swiper.navigation &&
          (e.target === swiper.navigation.nextEl ||
            e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
          if (swiper.swipeDirection === "next") {
            swiper.slideTo(
              rewindFirstIndex !== null
                ? rewindFirstIndex
                : stopIndex + increment
            );
          }
          if (swiper.swipeDirection === "prev") {
            swiper.slideTo(
              rewindLastIndex !== null ? rewindLastIndex : stopIndex
            );
          }
        } else if (e.target === swiper.navigation.nextEl) {
          swiper.slideTo(stopIndex + increment);
        } else {
          swiper.slideTo(stopIndex);
        }
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/events/onResize.js
    function onResize() {
      const swiper = this;
      const { params, el } = swiper;
      if (el && el.offsetWidth === 0) return; // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      } // Save locks

      const { allowSlideNext, allowSlidePrev, snapGrid } = swiper; // Disable locks on resize

      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateSlidesClasses();
      if (
        (params.slidesPerView === "auto" || params.slidesPerView > 1) &&
        swiper.isEnd &&
        !swiper.isBeginning &&
        !swiper.params.centeredSlides
      ) {
        swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (
        swiper.autoplay &&
        swiper.autoplay.running &&
        swiper.autoplay.paused
      ) {
        swiper.autoplay.run();
      } // Return locks after resize

      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/events/onClick.js
    function onClick(e) {
      const swiper = this;
      if (!swiper.enabled) return;
      if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/events/onScroll.js
    function onScroll() {
      const swiper = this;
      const { wrapperEl, rtlTranslate, enabled } = swiper;
      if (!enabled) return;
      swiper.previousTranslate = swiper.translate;
      if (swiper.isHorizontal()) {
        swiper.translate = -wrapperEl.scrollLeft;
      } else {
        swiper.translate = -wrapperEl.scrollTop;
      } // eslint-disable-next-line

      if (swiper.translate === 0) swiper.translate = 0;
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
      let newProgress;
      const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress =
          (swiper.translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== swiper.progress) {
        swiper.updateProgress(
          rtlTranslate ? -swiper.translate : swiper.translate
        );
      }
      swiper.emit("setTranslate", swiper.translate, false);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/events/index.js
    let dummyEventAttached = false;
    function dummyEventListener() { }
    const events = (swiper, method) => {
      const document = ssr_window_esm_getDocument();
      const { params, touchEvents, el, wrapperEl, device, support } = swiper;
      const capture = !!params.nested;
      const domMethod =
        method === "on" ? "addEventListener" : "removeEventListener";
      const swiperMethod = method; // Touch Events

      if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
      } else {
        const passiveListener =
          touchEvents.start === "touchstart" &&
            support.passiveListener &&
            params.passiveListeners
            ? {
              passive: true,
              capture: false,
            }
            : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](
          touchEvents.move,
          swiper.onTouchMove,
          support.passiveListener
            ? {
              passive: false,
              capture,
            }
            : capture
        );
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) {
          el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
      } // Prevent Links Clicks

      if (params.preventClicks || params.preventClicksPropagation) {
        el[domMethod]("click", swiper.onClick, true);
      }
      if (params.cssMode) {
        wrapperEl[domMethod]("scroll", swiper.onScroll);
      } // Resize handler

      if (params.updateOnWindowResize) {
        swiper[swiperMethod](
          device.ios || device.android
            ? "resize orientationchange observerUpdate"
            : "resize observerUpdate",
          onResize,
          true
        );
      } else {
        swiper[swiperMethod]("observerUpdate", onResize, true);
      }
    };
    function attachEvents() {
      const swiper = this;
      const document = ssr_window_esm_getDocument();
      const { params, support } = swiper;
      swiper.onTouchStart = onTouchStart.bind(swiper);
      swiper.onTouchMove = onTouchMove.bind(swiper);
      swiper.onTouchEnd = onTouchEnd.bind(swiper);
      if (params.cssMode) {
        swiper.onScroll = onScroll.bind(swiper);
      }
      swiper.onClick = onClick.bind(swiper);
      if (support.touch && !dummyEventAttached) {
        document.addEventListener("touchstart", dummyEventListener);
        dummyEventAttached = true;
      }
      events(swiper, "on");
    }
    function detachEvents() {
      const swiper = this;
      events(swiper, "off");
    }
    /* harmony default export */ const core_events = {
      attachEvents,
      detachEvents,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/setBreakpoint.js
    const isGridEnabled = (swiper, params) => {
      return swiper.grid && params.grid && params.grid.rows > 1;
    };
    function setBreakpoint() {
      const swiper = this;
      const {
        activeIndex,
        initialized,
        loopedSlides = 0,
        params,
        $el,
      } = swiper;
      const breakpoints = params.breakpoints;
      if (
        !breakpoints ||
        (breakpoints && Object.keys(breakpoints).length === 0)
      )
        return; // Get breakpoint for window width and update parameters

      const breakpoint = swiper.getBreakpoint(
        breakpoints,
        swiper.params.breakpointsBase,
        swiper.el
      );
      if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
      const breakpointOnlyParams =
        breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
      const breakpointParams = breakpointOnlyParams || swiper.originalParams;
      const wasMultiRow = isGridEnabled(swiper, params);
      const isMultiRow = isGridEnabled(swiper, breakpointParams);
      const wasEnabled = params.enabled;
      if (wasMultiRow && !isMultiRow) {
        $el.removeClass(
          `${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`
        );
        swiper.emitContainerClasses();
      } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (
          (breakpointParams.grid.fill &&
            breakpointParams.grid.fill === "column") ||
          (!breakpointParams.grid.fill && params.grid.fill === "column")
        ) {
          $el.addClass(`${params.containerModifierClass}grid-column`);
        }
        swiper.emitContainerClasses();
      } // Toggle navigation, pagination, scrollbar

      ["navigation", "pagination", "scrollbar"].forEach((prop) => {
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled =
          breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) {
          swiper[prop].disable();
        }
        if (!wasModuleEnabled && isModuleEnabled) {
          swiper[prop].enable();
        }
      });
      const directionChanged =
        breakpointParams.direction &&
        breakpointParams.direction !== params.direction;
      const needsReLoop =
        params.loop &&
        (breakpointParams.slidesPerView !== params.slidesPerView ||
          directionChanged);
      if (directionChanged && initialized) {
        swiper.changeDirection();
      }
      utils_extend(swiper.params, breakpointParams);
      const isEnabled = swiper.params.enabled;
      Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
      });
      if (wasEnabled && !isEnabled) {
        swiper.disable();
      } else if (!wasEnabled && isEnabled) {
        swiper.enable();
      }
      swiper.currentBreakpoint = breakpoint;
      swiper.emit("_beforeBreakpoint", breakpointParams);
      if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(
          activeIndex - loopedSlides + swiper.loopedSlides,
          0,
          false
        );
      }
      swiper.emit("breakpoint", breakpointParams);
    } // CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/getBreakpoint.js
    function getBreakpoint(breakpoints, base = "window", containerEl) {
      if (!breakpoints || (base === "container" && !containerEl))
        return undefined;
      let breakpoint = false;
      const window = ssr_window_esm_getWindow();
      const currentHeight =
        base === "window" ? window.innerHeight : containerEl.clientHeight;
      const points = Object.keys(breakpoints).map((point) => {
        if (typeof point === "string" && point.indexOf("@") === 0) {
          const minRatio = parseFloat(point.substr(1));
          const value = currentHeight * minRatio;
          return {
            value,
            point,
          };
        }
        return {
          value: point,
          point,
        };
      });
      points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));
      for (let i = 0; i < points.length; i += 1) {
        const { point, value } = points[i];
        if (base === "window") {
          if (window.matchMedia(`(min-width: ${value}px)`).matches) {
            breakpoint = point;
          }
        } else if (value <= containerEl.clientWidth) {
          breakpoint = point;
        }
      }
      return breakpoint || "max";
    } // CONCATENATED MODULE: ./node_modules/swiper/core/breakpoints/index.js
    /* harmony default export */ const breakpoints = {
      setBreakpoint: setBreakpoint,
      getBreakpoint: getBreakpoint,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/classes/addClasses.js
    function prepareClasses(entries, prefix) {
      const resultClasses = [];
      entries.forEach((item) => {
        if (typeof item === "object") {
          Object.keys(item).forEach((classNames) => {
            if (item[classNames]) {
              resultClasses.push(prefix + classNames);
            }
          });
        } else if (typeof item === "string") {
          resultClasses.push(prefix + item);
        }
      });
      return resultClasses;
    }
    function addClasses() {
      const swiper = this;
      const {
        classNames,
        params,
        rtl,
        $el,
        device,
        support
      } = swiper; // prettier-ignore

      const suffixes = prepareClasses(
        [
          "initialized",
          params.direction,
          {
            "pointer-events": !support.touch,
          },
          {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled,
          },
          {
            autoheight: params.autoHeight,
          },
          {
            rtl: rtl,
          },
          {
            grid: params.grid && params.grid.rows > 1,
          },
          {
            "grid-column":
              params.grid &&
              params.grid.rows > 1 &&
              params.grid.fill === "column",
          },
          {
            android: device.android,
          },
          {
            ios: device.ios,
          },
          {
            "css-mode": params.cssMode,
          },
          {
            centered: params.cssMode && params.centeredSlides,
          },
          {
            "watch-progress": params.watchSlidesProgress,
          },
        ],
        params.containerModifierClass
      );
      classNames.push(...suffixes);
      $el.addClass([...classNames].join(" "));
      swiper.emitContainerClasses();
    } // CONCATENATED MODULE: ./node_modules/swiper/core/classes/removeClasses.js
    function removeClasses() {
      const swiper = this;
      const { $el, classNames } = swiper;
      $el.removeClass(classNames.join(" "));
      swiper.emitContainerClasses();
    } // CONCATENATED MODULE: ./node_modules/swiper/core/classes/index.js
    /* harmony default export */ const classes = {
      addClasses: addClasses,
      removeClasses: removeClasses,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/images/loadImage.js
    function loadImage(
      imageEl,
      src,
      srcset,
      sizes,
      checkForComplete,
      callback
    ) {
      const window = ssr_window_esm_getWindow();
      let image;
      function onReady() {
        if (callback) callback();
      }
      const isPicture = dom(imageEl).parent("picture")[0];
      if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
          image = new window.Image();
          image.onload = onReady;
          image.onerror = onReady;
          if (sizes) {
            image.sizes = sizes;
          }
          if (srcset) {
            image.srcset = srcset;
          }
          if (src) {
            image.src = src;
          }
        } else {
          onReady();
        }
      } else {
        // image already loaded...
        onReady();
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/images/preloadImages.js
    function preloadImages() {
      const swiper = this;
      swiper.imagesToLoad = swiper.$el.find("img");
      function onReady() {
        if (
          typeof swiper === "undefined" ||
          swiper === null ||
          !swiper ||
          swiper.destroyed
        )
          return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
          if (swiper.params.updateOnImagesReady) swiper.update();
          swiper.emit("imagesReady");
        }
      }
      for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(
          imageEl,
          imageEl.currentSrc || imageEl.getAttribute("src"),
          imageEl.srcset || imageEl.getAttribute("srcset"),
          imageEl.sizes || imageEl.getAttribute("sizes"),
          true,
          onReady
        );
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/core/images/index.js
    /* harmony default export */ const core_images = {
      loadImage: loadImage,
      preloadImages: preloadImages,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/check-overflow/index.js
    function checkOverflow() {
      const swiper = this;
      const { isLocked: wasLocked, params } = swiper;
      const { slidesOffsetBefore } = params;
      if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge =
          swiper.slidesGrid[lastSlideIndex] +
          swiper.slidesSizesGrid[lastSlideIndex] +
          slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
      } else {
        swiper.isLocked = swiper.snapGrid.length === 1;
      }
      if (params.allowSlideNext === true) {
        swiper.allowSlideNext = !swiper.isLocked;
      }
      if (params.allowSlidePrev === true) {
        swiper.allowSlidePrev = !swiper.isLocked;
      }
      if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
      }
      if (wasLocked !== swiper.isLocked) {
        swiper.emit(swiper.isLocked ? "lock" : "unlock");
      }
    }
    /* harmony default export */ const check_overflow = {
      checkOverflow,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/defaults.js
    /* harmony default export */ const defaults = {
      init: true,
      direction: "horizontal",
      touchEventsTarget: "wrapper",
      initialSlide: 0,
      speed: 300,
      cssMode: false,
      updateOnWindowResize: true,
      resizeObserver: true,
      nested: false,
      createElements: false,
      enabled: true,
      focusableElements:
        "input, select, option, textarea, button, video, label",
      // Overrides
      width: null,
      height: null,
      //
      preventInteractionOnTransition: false,
      // ssr
      userAgent: null,
      url: null,
      // To support iOS's swipe-to-go-back gesture (when being used in-app).
      edgeSwipeDetection: false,
      edgeSwipeThreshold: 20,
      // Autoheight
      autoHeight: false,
      // Set wrapper width
      setWrapperSize: false,
      // Virtual Translate
      virtualTranslate: false,
      // Effects
      effect: "slide",
      // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
      // Breakpoints
      breakpoints: undefined,
      breakpointsBase: "window",
      // Slides grid
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerGroup: 1,
      slidesPerGroupSkip: 0,
      slidesPerGroupAuto: false,
      centeredSlides: false,
      centeredSlidesBounds: false,
      slidesOffsetBefore: 0,
      // in px
      slidesOffsetAfter: 0,
      // in px
      normalizeSlideIndex: true,
      centerInsufficientSlides: false,
      // Disable swiper and hide navigation when container not overflow
      watchOverflow: true,
      // Round length
      roundLengths: false,
      // Touches
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      allowTouchMove: true,
      threshold: 0,
      touchMoveStopPropagation: false,
      touchStartPreventDefault: true,
      touchStartForcePreventDefault: false,
      touchReleaseOnEdges: false,
      // Unique Navigation Elements
      uniqueNavElements: true,
      // Resistance
      resistance: true,
      resistanceRatio: 0.85,
      // Progress
      watchSlidesProgress: false,
      // Cursor
      grabCursor: false,
      // Clicks
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      // Images
      preloadImages: true,
      updateOnImagesReady: true,
      // loop
      loop: false,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopedSlidesLimit: true,
      loopFillGroupWithBlank: false,
      loopPreventsSlide: true,
      // rewind
      rewind: false,
      // Swiping/no swiping
      allowSlidePrev: true,
      allowSlideNext: true,
      swipeHandler: null,
      // '.swipe-handler',
      noSwiping: true,
      noSwipingClass: "swiper-no-swiping",
      noSwipingSelector: null,
      // Passive Listeners
      passiveListeners: true,
      maxBackfaceHiddenSlides: 10,
      // NS
      containerModifierClass: "swiper-",
      // NEW
      slideClass: "swiper-slide",
      slideBlankClass: "swiper-slide-invisible-blank",
      slideActiveClass: "swiper-slide-active",
      slideDuplicateActiveClass: "swiper-slide-duplicate-active",
      slideVisibleClass: "swiper-slide-visible",
      slideDuplicateClass: "swiper-slide-duplicate",
      slideNextClass: "swiper-slide-next",
      slideDuplicateNextClass: "swiper-slide-duplicate-next",
      slidePrevClass: "swiper-slide-prev",
      slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
      wrapperClass: "swiper-wrapper",
      // Callbacks
      runCallbacksOnInit: true,
      // Internals
      _emitClasses: false,
    }; // CONCATENATED MODULE: ./node_modules/swiper/core/moduleExtendParams.js
    function moduleExtendParams(params, allModulesParams) {
      return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
          utils_extend(allModulesParams, obj);
          return;
        }
        if (
          ["navigation", "pagination", "scrollbar"].indexOf(moduleParamName) >=
          0 &&
          params[moduleParamName] === true
        ) {
          params[moduleParamName] = {
            auto: true,
          };
        }
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
          utils_extend(allModulesParams, obj);
          return;
        }
        if (params[moduleParamName] === true) {
          params[moduleParamName] = {
            enabled: true,
          };
        }
        if (
          typeof params[moduleParamName] === "object" &&
          !("enabled" in params[moduleParamName])
        ) {
          params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName])
          params[moduleParamName] = {
            enabled: false,
          };
        utils_extend(allModulesParams, obj);
      };
    } // CONCATENATED MODULE: ./node_modules/swiper/core/core.js
    /* eslint no-param-reassign: "off" */

    const prototypes = {
      eventsEmitter: events_emitter,
      update: update,
      translate: translate,
      transition: core_transition,
      slide: slide,
      loop: loop,
      grabCursor: grab_cursor,
      events: core_events,
      breakpoints: breakpoints,
      checkOverflow: check_overflow,
      classes: classes,
      images: core_images,
    };
    const extendedDefaults = {};
    class Swiper {
      constructor(...args) {
        let el;
        let params;
        if (
          args.length === 1 &&
          args[0].constructor &&
          Object.prototype.toString.call(args[0]).slice(8, -1) === "Object"
        ) {
          params = args[0];
        } else {
          [el, params] = args;
        }
        if (!params) params = {};
        params = utils_extend({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && dom(params.el).length > 1) {
          const swipers = [];
          dom(params.el).each((containerEl) => {
            const newParams = utils_extend({}, params, {
              el: containerEl,
            });
            swipers.push(new Swiper(newParams));
          }); // eslint-disable-next-line no-constructor-return

          return swipers;
        } // Swiper Instance

        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = getSupport();
        swiper.device = getDevice({
          userAgent: params.userAgent,
        });
        swiper.browser = getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [...swiper.__modules__];
        if (params.modules && Array.isArray(params.modules)) {
          swiper.modules.push(...params.modules);
        }
        const allModulesParams = {};
        swiper.modules.forEach((mod) => {
          mod({
            swiper,
            extendParams: moduleExtendParams(params, allModulesParams),
            on: swiper.on.bind(swiper),
            once: swiper.once.bind(swiper),
            off: swiper.off.bind(swiper),
            emit: swiper.emit.bind(swiper),
          });
        }); // Extend defaults with modules params

        const swiperParams = utils_extend({}, defaults, allModulesParams); // Extend defaults with passed params

        swiper.params = utils_extend(
          {},
          swiperParams,
          extendedDefaults,
          params
        );
        swiper.originalParams = utils_extend({}, swiper.params);
        swiper.passedParams = utils_extend({}, params); // add event listeners

        if (swiper.params && swiper.params.on) {
          Object.keys(swiper.params.on).forEach((eventName) => {
            swiper.on(eventName, swiper.params.on[eventName]);
          });
        }
        if (swiper.params && swiper.params.onAny) {
          swiper.onAny(swiper.params.onAny);
        } // Save Dom lib

        swiper.$ = dom; // Extend Swiper

        Object.assign(swiper, {
          enabled: swiper.params.enabled,
          el,
          // Classes
          classNames: [],
          // Slides
          slides: dom(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          // isDirection
          isHorizontal() {
            return swiper.params.direction === "horizontal";
          },
          isVertical() {
            return swiper.params.direction === "vertical";
          },
          // Indexes
          activeIndex: 0,
          realIndex: 0,
          //
          isBeginning: true,
          isEnd: false,
          // Props
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: false,
          // Locks
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev,
          // Touch Events
          touchEvents: (function touchEvents() {
            const touch = [
              "touchstart",
              "touchmove",
              "touchend",
              "touchcancel",
            ];
            const desktop = ["pointerdown", "pointermove", "pointerup"];
            swiper.touchEventsTouch = {
              start: touch[0],
              move: touch[1],
              end: touch[2],
              cancel: touch[3],
            };
            swiper.touchEventsDesktop = {
              start: desktop[0],
              move: desktop[1],
              end: desktop[2],
            };
            return swiper.support.touch || !swiper.params.simulateTouch
              ? swiper.touchEventsTouch
              : swiper.touchEventsDesktop;
          })(),
          touchEventsData: {
            isTouched: undefined,
            isMoved: undefined,
            allowTouchCallbacks: undefined,
            touchStartTime: undefined,
            isScrolling: undefined,
            currentTranslate: undefined,
            startTranslate: undefined,
            allowThresholdMove: undefined,
            // Form elements to match
            focusableElements: swiper.params.focusableElements,
            // Last click time
            lastClickTime: utils_now(),
            clickTimeout: undefined,
            // Velocities
            velocities: [],
            allowMomentumBounce: undefined,
            isTouchEvent: undefined,
            startMoving: undefined,
          },
          // Clicks
          allowClick: true,
          // Touches
          allowTouchMove: swiper.params.allowTouchMove,
          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0,
          },
          // Images
          imagesToLoad: [],
          imagesLoaded: 0,
        });
        swiper.emit("_swiper"); // Init

        if (swiper.params.init) {
          swiper.init();
        } // Return app instance
        // eslint-disable-next-line no-constructor-return

        return swiper;
      }
      enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) {
          swiper.setGrabCursor();
        }
        swiper.emit("enable");
      }
      disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) {
          swiper.unsetGrabCursor();
        }
        swiper.emit("disable");
      }
      setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className) => {
          return (
            className.indexOf("swiper") === 0 ||
            className.indexOf(swiper.params.containerModifierClass) === 0
          );
        });
        swiper.emit("_containerClasses", cls.join(" "));
      }
      getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className
          .split(" ")
          .filter((className) => {
            return (
              className.indexOf("swiper-slide") === 0 ||
              className.indexOf(swiper.params.slideClass) === 0
            );
          })
          .join(" ");
      }
      emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl) => {
          const classNames = swiper.getSlideClasses(slideEl);
          updates.push({
            slideEl,
            classNames,
          });
          swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
      }
      slidesPerViewDynamic(view = "current", exact = false) {
        const swiper = this;
        const {
          params,
          slides,
          slidesGrid,
          slidesSizesGrid,
          size: swiperSize,
          activeIndex,
        } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
          let slideSize = slides[activeIndex].swiperSlideSize;
          let breakLoop;
          for (let i = activeIndex + 1; i < slides.length; i += 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
          for (let i = activeIndex - 1; i >= 0; i -= 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) breakLoop = true;
            }
          }
        } else {
          // eslint-disable-next-line
          if (view === "current") {
            for (let i = activeIndex + 1; i < slides.length; i += 1) {
              const slideInView = exact
                ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] <
                swiperSize
                : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
              if (slideInView) {
                spv += 1;
              }
            }
          } else {
            // previous
            for (let i = activeIndex - 1; i >= 0; i -= 1) {
              const slideInView =
                slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
              if (slideInView) {
                spv += 1;
              }
            }
          }
        }
        return spv;
      }
      update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid, params } = swiper; // Breakpoints

        if (params.breakpoints) {
          swiper.setBreakpoint();
        }
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
          const translateValue = swiper.rtlTranslate
            ? swiper.translate * -1
            : swiper.translate;
          const newTranslate = Math.min(
            Math.max(translateValue, swiper.maxTranslate()),
            swiper.minTranslate()
          );
          swiper.setTranslate(newTranslate);
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
          setTranslate();
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        } else {
          if (
            (swiper.params.slidesPerView === "auto" ||
              swiper.params.slidesPerView > 1) &&
            swiper.isEnd &&
            !swiper.params.centeredSlides
          ) {
            translated = swiper.slideTo(
              swiper.slides.length - 1,
              0,
              false,
              true
            );
          } else {
            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
          }
          if (!translated) {
            setTranslate();
          }
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
          swiper.checkOverflow();
        }
        swiper.emit("update");
      }
      changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) {
          // eslint-disable-next-line
          newDirection =
            currentDirection === "horizontal" ? "vertical" : "horizontal";
        }
        if (
          newDirection === currentDirection ||
          (newDirection !== "horizontal" && newDirection !== "vertical")
        ) {
          return swiper;
        }
        swiper.$el
          .removeClass(
            `${swiper.params.containerModifierClass}${currentDirection}`
          )
          .addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl) => {
          if (newDirection === "vertical") {
            slideEl.style.width = "";
          } else {
            slideEl.style.height = "";
          }
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
      }
      changeLanguageDirection(direction) {
        const swiper = this;
        if (
          (swiper.rtl && direction === "rtl") ||
          (!swiper.rtl && direction === "ltr")
        )
          return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate =
          swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
          swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
          swiper.el.dir = "rtl";
        } else {
          swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
          swiper.el.dir = "ltr";
        }
        swiper.update();
      }
      mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el

        const $el = dom(el || swiper.params.el);
        el = $el[0];
        if (!el) {
          return false;
        }
        el.swiper = swiper;
        const getWrapperSelector = () => {
          return `.${(swiper.params.wrapperClass || "")
            .trim()
            .split(" ")
            .join(".")}`;
        };
        const getWrapper = () => {
          if (el && el.shadowRoot && el.shadowRoot.querySelector) {
            const res = dom(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

            res.children = (options) => $el.children(options);
            return res;
          }
          if (!$el.children) {
            return dom($el).children(getWrapperSelector());
          }
          return $el.children(getWrapperSelector());
        }; // Find Wrapper

        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
          const document = ssr_window_esm_getDocument();
          const wrapper = document.createElement("div");
          $wrapperEl = dom(wrapper);
          wrapper.className = swiper.params.wrapperClass;
          $el.append(wrapper);
          $el.children(`.${swiper.params.slideClass}`).each((slideEl) => {
            $wrapperEl.append(slideEl);
          });
        }
        Object.assign(swiper, {
          $el,
          el,
          $wrapperEl,
          wrapperEl: $wrapperEl[0],
          mounted: true,
          // RTL
          rtl: el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl",
          rtlTranslate:
            swiper.params.direction === "horizontal" &&
            (el.dir.toLowerCase() === "rtl" || $el.css("direction") === "rtl"),
          wrongRTL: $wrapperEl.css("display") === "-webkit-box",
        });
        return true;
      }
      init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit"); // Set breakpoint

        if (swiper.params.breakpoints) {
          swiper.setBreakpoint();
        } // Add Classes

        swiper.addClasses(); // Create loop

        if (swiper.params.loop) {
          swiper.loopCreate();
        } // Update size

        swiper.updateSize(); // Update slides

        swiper.updateSlides();
        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        } // Set Grab Cursor

        if (swiper.params.grabCursor && swiper.enabled) {
          swiper.setGrabCursor();
        }
        if (swiper.params.preloadImages) {
          swiper.preloadImages();
        } // Slide To Initial Slide

        if (swiper.params.loop) {
          swiper.slideTo(
            swiper.params.initialSlide + swiper.loopedSlides,
            0,
            swiper.params.runCallbacksOnInit,
            false,
            true
          );
        } else {
          swiper.slideTo(
            swiper.params.initialSlide,
            0,
            swiper.params.runCallbacksOnInit,
            false,
            true
          );
        } // Attach events

        swiper.attachEvents(); // Init Flag

        swiper.initialized = true; // Emit

        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
      }
      destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params, $el, $wrapperEl, slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) {
          return null;
        }
        swiper.emit("beforeDestroy"); // Init Flag

        swiper.initialized = false; // Detach events

        swiper.detachEvents(); // Destroy loop

        if (params.loop) {
          swiper.loopDestroy();
        } // Cleanup styles

        if (cleanStyles) {
          swiper.removeClasses();
          $el.removeAttr("style");
          $wrapperEl.removeAttr("style");
          if (slides && slides.length) {
            slides
              .removeClass(
                [
                  params.slideVisibleClass,
                  params.slideActiveClass,
                  params.slideNextClass,
                  params.slidePrevClass,
                ].join(" ")
              )
              .removeAttr("style")
              .removeAttr("data-swiper-slide-index");
          }
        }
        swiper.emit("destroy"); // Detach emitter events

        Object.keys(swiper.eventsListeners).forEach((eventName) => {
          swiper.off(eventName);
        });
        if (deleteInstance !== false) {
          swiper.$el[0].swiper = null;
          deleteProps(swiper);
        }
        swiper.destroyed = true;
        return null;
      }
      static extendDefaults(newDefaults) {
        utils_extend(extendedDefaults, newDefaults);
      }
      static get extendedDefaults() {
        return extendedDefaults;
      }
      static get defaults() {
        return defaults;
      }
      static installModule(mod) {
        if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
        const modules = Swiper.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) {
          modules.push(mod);
        }
      }
      static use(module) {
        if (Array.isArray(module)) {
          module.forEach((m) => Swiper.installModule(m));
          return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
      }
    }
    Object.keys(prototypes).forEach((prototypeGroup) => {
      Object.keys(prototypes[prototypeGroup]).forEach((protoMethod) => {
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
      });
    });
    Swiper.use([Resize, Observer]);
    /* harmony default export */ const core = Swiper; // CONCATENATED MODULE: ./node_modules/swiper/modules/virtual/virtual.js
    function Virtual({ swiper, extendParams, on, emit }) {
      extendParams({
        virtual: {
          enabled: false,
          slides: [],
          cache: true,
          renderSlide: null,
          renderExternal: null,
          renderExternalUpdate: true,
          addSlidesBefore: 0,
          addSlidesAfter: 0,
        },
      });
      let cssModeTimeout;
      swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: [],
      };
      function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) {
          return swiper.virtual.cache[index];
        }
        const $slideEl = params.renderSlide
          ? $(params.renderSlide.call(swiper, slide, index))
          : $(
            `<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`
          );
        if (!$slideEl.attr("data-swiper-slide-index"))
          $slideEl.attr("data-swiper-slide-index", index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
      }
      function update(force) {
        const { slidesPerView, slidesPerGroup, centeredSlides } = swiper.params;
        const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
        const {
          from: previousFrom,
          to: previousTo,
          slides,
          slidesGrid: previousSlidesGrid,
          offset: previousOffset,
        } = swiper.virtual;
        if (!swiper.params.cssMode) {
          swiper.updateActiveIndex();
        }
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
          slidesAfter =
            Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
          slidesBefore =
            Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
          slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
          slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min(
          (activeIndex || 0) + slidesAfter,
          slides.length - 1
        );
        const offset =
          (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
          from,
          to,
          offset,
          slidesGrid: swiper.slidesGrid,
        });
        function onRendered() {
          swiper.updateSlides();
          swiper.updateProgress();
          swiper.updateSlidesClasses();
          if (swiper.lazy && swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
          emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
          if (
            swiper.slidesGrid !== previousSlidesGrid &&
            offset !== previousOffset
          ) {
            swiper.slides.css(offsetProp, `${offset}px`);
          }
          swiper.updateProgress();
          emit("virtualUpdate");
          return;
        }
        if (swiper.params.virtual.renderExternal) {
          swiper.params.virtual.renderExternal.call(swiper, {
            offset,
            from,
            to,
            slides: (function getSlides() {
              const slidesToRender = [];
              for (let i = from; i <= to; i += 1) {
                slidesToRender.push(slides[i]);
              }
              return slidesToRender;
            })(),
          });
          if (swiper.params.virtual.renderExternalUpdate) {
            onRendered();
          } else {
            emit("virtualUpdate");
          }
          return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) {
          swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        } else {
          for (let i = previousFrom; i <= previousTo; i += 1) {
            if (i < from || i > to) {
              swiper.$wrapperEl
                .find(
                  `.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`
                )
                .remove();
            }
          }
        }
        for (let i = 0; i < slides.length; i += 1) {
          if (i >= from && i <= to) {
            if (typeof previousTo === "undefined" || force) {
              appendIndexes.push(i);
            } else {
              if (i > previousTo) appendIndexes.push(i);
              if (i < previousFrom) prependIndexes.push(i);
            }
          }
        }
        appendIndexes.forEach((index) => {
          swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes
          .sort((a, b) => b - a)
          .forEach((index) => {
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
          });
        swiper.$wrapperEl
          .children(".swiper-slide")
          .css(offsetProp, `${offset}px`);
        onRendered();
      }
      function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
          for (let i = 0; i < slides.length; i += 1) {
            if (slides[i]) swiper.virtual.slides.push(slides[i]);
          }
        } else {
          swiper.virtual.slides.push(slides);
        }
        update(true);
      }
      function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
          for (let i = 0; i < slides.length; i += 1) {
            if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
          }
          newActiveIndex = activeIndex + slides.length;
          numberOfNewSlides = slides.length;
        } else {
          swiper.virtual.slides.unshift(slides);
        }
        if (swiper.params.virtual.cache) {
          const cache = swiper.virtual.cache;
          const newCache = {};
          Object.keys(cache).forEach((cachedIndex) => {
            const $cachedEl = cache[cachedIndex];
            const cachedElIndex = $cachedEl.attr("data-swiper-slide-index");
            if (cachedElIndex) {
              $cachedEl.attr(
                "data-swiper-slide-index",
                parseInt(cachedElIndex, 10) + numberOfNewSlides
              );
            }
            newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
          });
          swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
      }
      function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null)
          return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) {
          for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) {
              delete swiper.virtual.cache[slidesIndexes[i]];
            }
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
          }
        } else {
          swiper.virtual.slides.splice(slidesIndexes, 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes];
          }
          if (slidesIndexes < activeIndex) activeIndex -= 1;
          activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
      }
      function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) {
          swiper.virtual.cache = {};
        }
        update(true);
        swiper.slideTo(0, 0);
      }
      on("beforeInit", () => {
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(
          `${swiper.params.containerModifierClass}virtual`
        );
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) {
          update();
        }
      });
      on("setTranslate", () => {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
          clearTimeout(cssModeTimeout);
          cssModeTimeout = setTimeout(() => {
            update();
          }, 100);
        } else {
          update();
        }
      });
      on("init update resize", () => {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) {
          setCSSProperty(
            swiper.wrapperEl,
            "--swiper-virtual-size",
            `${swiper.virtualSize}px`
          );
        }
      });
      Object.assign(swiper.virtual, {
        appendSlide,
        prependSlide,
        removeSlide,
        removeAllSlides,
        update,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/keyboard/keyboard.js
    /* eslint-disable consistent-return */

    function Keyboard({ swiper, extendParams, on, emit }) {
      const document = getDocument();
      const window = getWindow();
      swiper.keyboard = {
        enabled: false,
      };
      extendParams({
        keyboard: {
          enabled: false,
          onlyInViewport: true,
          pageUpDown: true,
        },
      });
      function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix

        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks

        if (
          !swiper.allowSlideNext &&
          ((swiper.isHorizontal() && isArrowRight) ||
            (swiper.isVertical() && isArrowDown) ||
            isPageDown)
        ) {
          return false;
        }
        if (
          !swiper.allowSlidePrev &&
          ((swiper.isHorizontal() && isArrowLeft) ||
            (swiper.isVertical() && isArrowUp) ||
            isPageUp)
        ) {
          return false;
        }
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
          return undefined;
        }
        if (
          document.activeElement &&
          document.activeElement.nodeName &&
          (document.activeElement.nodeName.toLowerCase() === "input" ||
            document.activeElement.nodeName.toLowerCase() === "textarea")
        ) {
          return undefined;
        }
        if (
          swiper.params.keyboard.onlyInViewport &&
          (isPageUp ||
            isPageDown ||
            isArrowLeft ||
            isArrowRight ||
            isArrowUp ||
            isArrowDown)
        ) {
          let inView = false; // Check that swiper should be inside of visible area of window

          if (
            swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 &&
            swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length ===
            0
          ) {
            return undefined;
          }
          const $el = swiper.$el;
          const swiperWidth = $el[0].clientWidth;
          const swiperHeight = $el[0].clientHeight;
          const windowWidth = window.innerWidth;
          const windowHeight = window.innerHeight;
          const swiperOffset = swiper.$el.offset();
          if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
          const swiperCoord = [
            [swiperOffset.left, swiperOffset.top],
            [swiperOffset.left + swiperWidth, swiperOffset.top],
            [swiperOffset.left, swiperOffset.top + swiperHeight],
            [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight],
          ];
          for (let i = 0; i < swiperCoord.length; i += 1) {
            const point = swiperCoord[i];
            if (
              point[0] >= 0 &&
              point[0] <= windowWidth &&
              point[1] >= 0 &&
              point[1] <= windowHeight
            ) {
              if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

              inView = true;
            }
          }
          if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
          if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
          }
          if (
            ((isPageDown || isArrowRight) && !rtl) ||
            ((isPageUp || isArrowLeft) && rtl)
          )
            swiper.slideNext();
          if (
            ((isPageUp || isArrowLeft) && !rtl) ||
            ((isPageDown || isArrowRight) && rtl)
          )
            swiper.slidePrev();
        } else {
          if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
          }
          if (isPageDown || isArrowDown) swiper.slideNext();
          if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
      }
      function enable() {
        if (swiper.keyboard.enabled) return;
        $(document).on("keydown", handle);
        swiper.keyboard.enabled = true;
      }
      function disable() {
        if (!swiper.keyboard.enabled) return;
        $(document).off("keydown", handle);
        swiper.keyboard.enabled = false;
      }
      on("init", () => {
        if (swiper.params.keyboard.enabled) {
          enable();
        }
      });
      on("destroy", () => {
        if (swiper.keyboard.enabled) {
          disable();
        }
      });
      Object.assign(swiper.keyboard, {
        enable,
        disable,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/mousewheel/mousewheel.js
    /* eslint-disable consistent-return */

    function Mousewheel({ swiper, extendParams, on, emit }) {
      const window = getWindow();
      extendParams({
        mousewheel: {
          enabled: false,
          releaseOnEdges: false,
          invert: false,
          forceToAxis: false,
          sensitivity: 1,
          eventsTarget: "container",
          thresholdDelta: null,
          thresholdTime: null,
        },
      });
      swiper.mousewheel = {
        enabled: false,
      };
      let timeout;
      let lastScrollTime = now();
      let lastEventBeforeSnap;
      const recentWheelEvents = [];
      function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY

        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy

        if ("detail" in e) {
          sY = e.detail;
        }
        if ("wheelDelta" in e) {
          sY = -e.wheelDelta / 120;
        }
        if ("wheelDeltaY" in e) {
          sY = -e.wheelDeltaY / 120;
        }
        if ("wheelDeltaX" in e) {
          sX = -e.wheelDeltaX / 120;
        } // side scrolling on FF with DOMMouseScroll

        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
          sX = sY;
          sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) {
          pY = e.deltaY;
        }
        if ("deltaX" in e) {
          pX = e.deltaX;
        }
        if (e.shiftKey && !pX) {
          // if user scrolls with shift he wants horizontal scroll
          pX = pY;
          pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
          if (e.deltaMode === 1) {
            // delta in LINE units
            pX *= LINE_HEIGHT;
            pY *= LINE_HEIGHT;
          } else {
            // delta in PAGE units
            pX *= PAGE_HEIGHT;
            pY *= PAGE_HEIGHT;
          }
        } // Fall-back if spin cannot be determined

        if (pX && !sX) {
          sX = pX < 1 ? -1 : 1;
        }
        if (pY && !sY) {
          sY = pY < 1 ? -1 : 1;
        }
        return {
          spinX: sX,
          spinY: sY,
          pixelX: pX,
          pixelY: pY,
        };
      }
      function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
      }
      function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
      }
      function animateSlider(newEvent) {
        if (
          swiper.params.mousewheel.thresholdDelta &&
          newEvent.delta < swiper.params.mousewheel.thresholdDelta
        ) {
          // Prevent if delta of wheel scroll delta is below configured threshold
          return false;
        }
        if (
          swiper.params.mousewheel.thresholdTime &&
          now() - lastScrollTime < swiper.params.mousewheel.thresholdTime
        ) {
          // Prevent if time between scrolls is below configured threshold
          return false;
        } // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).

        if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
          // Return false as a default
          return true;
        } // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.

        if (newEvent.direction < 0) {
          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
            swiper.slideNext();
            emit("scroll", newEvent.raw);
          }
        } else if (
          (!swiper.isBeginning || swiper.params.loop) &&
          !swiper.animating
        ) {
          swiper.slidePrev();
          emit("scroll", newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time

        lastScrollTime = new window.Date().getTime(); // Return false as a default

        return false;
      }
      function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
          if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
            // Return true to animate scroll on edges
            return true;
          }
        } else if (
          swiper.isBeginning &&
          !swiper.params.loop &&
          params.releaseOnEdges
        ) {
          // Return true to animate scroll on edges
          return true;
        }
        return false;
      }
      function handle(event) {
        let e = event;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) {
          e.preventDefault();
        }
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") {
          target = $(swiper.params.mousewheel.eventsTarget);
        }
        if (
          !swiper.mouseEntered &&
          !target[0].contains(e.target) &&
          !params.releaseOnEdges
        )
          return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix

        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
          if (swiper.isHorizontal()) {
            if (Math.abs(data.pixelX) > Math.abs(data.pixelY))
              delta = -data.pixelX * rtlFactor;
            else return true;
          } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX))
            delta = -data.pixelY;
          else return true;
        } else {
          delta =
            Math.abs(data.pixelX) > Math.abs(data.pixelY)
              ? -data.pixelX * rtlFactor
              : -data.pixelY;
        }
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions

        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate())
          positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate())
          positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.

        disableParentSwiper = swiper.params.loop
          ? true
          : !(
            positions === swiper.minTranslate() ||
            positions === swiper.maxTranslate()
          );
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
          // Register the new event in a variable which stores the relevant data
          const newEvent = {
            time: now(),
            delta: Math.abs(delta),
            direction: Math.sign(delta),
            raw: event,
          }; // Keep the most recent events

          if (recentWheelEvents.length >= 2) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length
            ? recentWheelEvents[recentWheelEvents.length - 1]
            : undefined;
          recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
          //   If direction has changed or
          //   if the scroll is quicker than the previous one:
          //     Animate the slider.
          // Else (this is the first time the wheel is moved):
          //     Animate the slider.

          if (prevEvent) {
            if (
              newEvent.direction !== prevEvent.direction ||
              newEvent.delta > prevEvent.delta ||
              newEvent.time > prevEvent.time + 150
            ) {
              animateSlider(newEvent);
            }
          } else {
            animateSlider(newEvent);
          } // If it's time to release the scroll:
          //   Return now so you don't hit the preventDefault.

          if (releaseScroll(newEvent)) {
            return true;
          }
        } else {
          // Freemode or scrollContainer:
          // If we recently snapped after a momentum scroll, then ignore wheel events
          // to give time for the deceleration to finish. Stop ignoring after 500 msecs
          // or if it's a new scroll (larger delta or inverse sign as last event before
          // an end-of-momentum snap).
          const newEvent = {
            time: now(),
            delta: Math.abs(delta),
            direction: Math.sign(delta),
          };
          const ignoreWheelEvents =
            lastEventBeforeSnap &&
            newEvent.time < lastEventBeforeSnap.time + 500 &&
            newEvent.delta <= lastEventBeforeSnap.delta &&
            newEvent.direction === lastEventBeforeSnap.direction;
          if (!ignoreWheelEvents) {
            lastEventBeforeSnap = undefined;
            if (swiper.params.loop) {
              swiper.loopFix();
            }
            let position = swiper.getTranslate() + delta * params.sensitivity;
            const wasBeginning = swiper.isBeginning;
            const wasEnd = swiper.isEnd;
            if (position >= swiper.minTranslate())
              position = swiper.minTranslate();
            if (position <= swiper.maxTranslate())
              position = swiper.maxTranslate();
            swiper.setTransition(0);
            swiper.setTranslate(position);
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
            if (
              (!wasBeginning && swiper.isBeginning) ||
              (!wasEnd && swiper.isEnd)
            ) {
              swiper.updateSlidesClasses();
            }
            if (swiper.params.freeMode.sticky) {
              // When wheel scrolling starts with sticky (aka snap) enabled, then detect
              // the end of a momentum scroll by storing recent (N=15?) wheel events.
              // 1. do all N events have decreasing or same (absolute value) delta?
              // 2. did all N events arrive in the last M (M=500?) msecs?
              // 3. does the earliest event have an (absolute value) delta that's
              //    at least P (P=1?) larger than the most recent event's delta?
              // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
              // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
              // Snap immediately and ignore remaining wheel events in this scroll.
              // See comment above for "remaining wheel events in this scroll" determination.
              // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
              clearTimeout(timeout);
              timeout = undefined;
              if (recentWheelEvents.length >= 15) {
                recentWheelEvents.shift(); // only store the last N events
              }

              const prevEvent = recentWheelEvents.length
                ? recentWheelEvents[recentWheelEvents.length - 1]
                : undefined;
              const firstEvent = recentWheelEvents[0];
              recentWheelEvents.push(newEvent);
              if (
                prevEvent &&
                (newEvent.delta > prevEvent.delta ||
                  newEvent.direction !== prevEvent.direction)
              ) {
                // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                recentWheelEvents.splice(0);
              } else if (
                recentWheelEvents.length >= 15 &&
                newEvent.time - firstEvent.time < 500 &&
                firstEvent.delta - newEvent.delta >= 1 &&
                newEvent.delta <= 6
              ) {
                // We're at the end of the deceleration of a momentum scroll, so there's no need
                // to wait for more events. Snap ASAP on the next tick.
                // Also, because there's some remaining momentum we'll bias the snap in the
                // direction of the ongoing scroll because it's better UX for the scroll to snap
                // in the same direction as the scroll instead of reversing to snap.  Therefore,
                // if it's already scrolled more than 20% in the current direction, keep going.
                const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                lastEventBeforeSnap = newEvent;
                recentWheelEvents.splice(0);
                timeout = nextTick(() => {
                  swiper.slideToClosest(
                    swiper.params.speed,
                    true,
                    undefined,
                    snapToThreshold
                  );
                }, 0); // no delay; move on next tick
              }

              if (!timeout) {
                // if we get here, then we haven't detected the end of a momentum scroll, so
                // we'll consider a scroll "complete" when there haven't been any wheel events
                // for 500ms.
                timeout = nextTick(() => {
                  const snapToThreshold = 0.5;
                  lastEventBeforeSnap = newEvent;
                  recentWheelEvents.splice(0);
                  swiper.slideToClosest(
                    swiper.params.speed,
                    true,
                    undefined,
                    snapToThreshold
                  );
                }, 500);
              }
            } // Emit event

            if (!ignoreWheelEvents) emit("scroll", e); // Stop autoplay

            if (
              swiper.params.autoplay &&
              swiper.params.autoplayDisableOnInteraction
            )
              swiper.autoplay.stop(); // Return page scroll on edge positions

            if (
              position === swiper.minTranslate() ||
              position === swiper.maxTranslate()
            )
              return true;
          }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
      }
      function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== "container") {
          target = $(swiper.params.mousewheel.eventsTarget);
        }
        target[method]("mouseenter", handleMouseEnter);
        target[method]("mouseleave", handleMouseLeave);
        target[method]("wheel", handle);
      }
      function enable() {
        if (swiper.params.cssMode) {
          swiper.wrapperEl.removeEventListener("wheel", handle);
          return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("on");
        swiper.mousewheel.enabled = true;
        return true;
      }
      function disable() {
        if (swiper.params.cssMode) {
          swiper.wrapperEl.addEventListener(event, handle);
          return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("off");
        swiper.mousewheel.enabled = false;
        return true;
      }
      on("init", () => {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
          disable();
        }
        if (swiper.params.mousewheel.enabled) enable();
      });
      on("destroy", () => {
        if (swiper.params.cssMode) {
          enable();
        }
        if (swiper.mousewheel.enabled) disable();
      });
      Object.assign(swiper.mousewheel, {
        enable,
        disable,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/create-element-if-not-defined.js
    function create_element_if_not_defined_createElementIfNotDefined(
      swiper,
      originalParams,
      params,
      checkProps
    ) {
      const document = ssr_window_esm_getDocument();
      if (swiper.params.createElements) {
        Object.keys(checkProps).forEach((key) => {
          if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
              element = document.createElement("div");
              element.className = checkProps[key];
              swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
          }
        });
      }
      return params;
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/navigation/navigation.js
    function Navigation({ swiper, extendParams, on, emit }) {
      extendParams({
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: false,
          disabledClass: "swiper-button-disabled",
          hiddenClass: "swiper-button-hidden",
          lockClass: "swiper-button-lock",
          navigationDisabledClass: "swiper-navigation-disabled",
        },
      });
      swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null,
      };
      function getEl(el) {
        let $el;
        if (el) {
          $el = dom(el);
          if (
            swiper.params.uniqueNavElements &&
            typeof el === "string" &&
            $el.length > 1 &&
            swiper.$el.find(el).length === 1
          ) {
            $el = swiper.$el.find(el);
          }
        }
        return $el;
      }
      function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
          $el[disabled ? "addClass" : "removeClass"](params.disabledClass);
          if ($el[0] && $el[0].tagName === "BUTTON") $el[0].disabled = disabled;
          if (swiper.params.watchOverflow && swiper.enabled) {
            $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
          }
        }
      }
      function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl, $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
      }
      function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind)
          return;
        swiper.slidePrev();
        emit("navigationPrev");
      }
      function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind)
          return;
        swiper.slideNext();
        emit("navigationNext");
      }
      function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation =
          create_element_if_not_defined_createElementIfNotDefined(
            swiper,
            swiper.originalParams.navigation,
            swiper.params.navigation,
            {
              nextEl: "swiper-button-next",
              prevEl: "swiper-button-prev",
            }
          );
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) {
          $nextEl.on("click", onNextClick);
        }
        if ($prevEl && $prevEl.length > 0) {
          $prevEl.on("click", onPrevClick);
        }
        Object.assign(swiper.navigation, {
          $nextEl,
          nextEl: $nextEl && $nextEl[0],
          $prevEl,
          prevEl: $prevEl && $prevEl[0],
        });
        if (!swiper.enabled) {
          if ($nextEl) $nextEl.addClass(params.lockClass);
          if ($prevEl) $prevEl.addClass(params.lockClass);
        }
      }
      function destroy() {
        const { $nextEl, $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
          $nextEl.off("click", onNextClick);
          $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
          $prevEl.off("click", onPrevClick);
          $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
      }
      on("init", () => {
        if (swiper.params.navigation.enabled === false) {
          // eslint-disable-next-line
          disable();
        } else {
          init();
          update();
        }
      });
      on("toEdge fromEdge lock unlock", () => {
        update();
      });
      on("destroy", () => {
        destroy();
      });
      on("enable disable", () => {
        const { $nextEl, $prevEl } = swiper.navigation;
        if ($nextEl) {
          $nextEl[swiper.enabled ? "removeClass" : "addClass"](
            swiper.params.navigation.lockClass
          );
        }
        if ($prevEl) {
          $prevEl[swiper.enabled ? "removeClass" : "addClass"](
            swiper.params.navigation.lockClass
          );
        }
      });
      on("click", (_s, e) => {
        const { $nextEl, $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (
          swiper.params.navigation.hideOnClick &&
          !dom(targetEl).is($prevEl) &&
          !dom(targetEl).is($nextEl)
        ) {
          if (
            swiper.pagination &&
            swiper.params.pagination &&
            swiper.params.pagination.clickable &&
            (swiper.pagination.el === targetEl ||
              swiper.pagination.el.contains(targetEl))
          )
            return;
          let isHidden;
          if ($nextEl) {
            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
          } else if ($prevEl) {
            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
          }
          if (isHidden === true) {
            emit("navigationShow");
          } else {
            emit("navigationHide");
          }
          if ($nextEl) {
            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
          if ($prevEl) {
            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
          }
        }
      });
      const enable = () => {
        swiper.$el.removeClass(
          swiper.params.navigation.navigationDisabledClass
        );
        init();
        update();
      };
      const disable = () => {
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
      };
      Object.assign(swiper.navigation, {
        enable,
        disable,
        update,
        init,
        destroy,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/classes-to-selector.js
    function classes_to_selector_classesToSelector(classes = "") {
      return `.${classes
        .trim()
        .replace(/([\.:!\/])/g, "\\$1") // eslint-disable-line
        .replace(/ /g, ".")}`;
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/pagination/pagination.js
    function Pagination({ swiper, extendParams, on, emit }) {
      const pfx = "swiper-pagination";
      extendParams({
        pagination: {
          el: null,
          bulletElement: "span",
          clickable: false,
          hideOnClick: false,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: false,
          type: "bullets",
          // 'bullets' or 'progressbar' or 'fraction' or 'custom'
          dynamicBullets: false,
          dynamicMainBullets: 1,
          formatFractionCurrent: (number) => number,
          formatFractionTotal: (number) => number,
          bulletClass: `${pfx}-bullet`,
          bulletActiveClass: `${pfx}-bullet-active`,
          modifierClass: `${pfx}-`,
          currentClass: `${pfx}-current`,
          totalClass: `${pfx}-total`,
          hiddenClass: `${pfx}-hidden`,
          progressbarFillClass: `${pfx}-progressbar-fill`,
          progressbarOppositeClass: `${pfx}-progressbar-opposite`,
          clickableClass: `${pfx}-clickable`,
          lockClass: `${pfx}-lock`,
          horizontalClass: `${pfx}-horizontal`,
          verticalClass: `${pfx}-vertical`,
          paginationDisabledClass: `${pfx}-disabled`,
        },
      });
      swiper.pagination = {
        el: null,
        $el: null,
        bullets: [],
      };
      let bulletSize;
      let dynamicBulletIndex = 0;
      function isPaginationDisabled() {
        return (
          !swiper.params.pagination.el ||
          !swiper.pagination.el ||
          !swiper.pagination.$el ||
          swiper.pagination.$el.length === 0
        );
      }
      function setSideBullets($bulletEl, position) {
        const { bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]()
          .addClass(`${bulletActiveClass}-${position}`)
        [position]()
          .addClass(`${bulletActiveClass}-${position}-${position}`);
      }
      function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength =
          swiper.virtual && swiper.params.virtual.enabled
            ? swiper.virtual.slides.length
            : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total

        let current;
        const total = swiper.params.loop
          ? Math.ceil(
            (slidesLength - swiper.loopedSlides * 2) /
            swiper.params.slidesPerGroup
          )
          : swiper.snapGrid.length;
        if (swiper.params.loop) {
          current = Math.ceil(
            (swiper.activeIndex - swiper.loopedSlides) /
            swiper.params.slidesPerGroup
          );
          if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
            current -= slidesLength - swiper.loopedSlides * 2;
          }
          if (current > total - 1) current -= total;
          if (current < 0 && swiper.params.paginationType !== "bullets")
            current = total + current;
        } else if (typeof swiper.snapIndex !== "undefined") {
          current = swiper.snapIndex;
        } else {
          current = swiper.activeIndex || 0;
        } // Types

        if (
          params.type === "bullets" &&
          swiper.pagination.bullets &&
          swiper.pagination.bullets.length > 0
        ) {
          const bullets = swiper.pagination.bullets;
          let firstIndex;
          let lastIndex;
          let midIndex;
          if (params.dynamicBullets) {
            bulletSize = bullets
              .eq(0)
            [swiper.isHorizontal() ? "outerWidth" : "outerHeight"](true);
            $el.css(
              swiper.isHorizontal() ? "width" : "height",
              `${bulletSize * (params.dynamicMainBullets + 4)}px`
            );
            if (
              params.dynamicMainBullets > 1 &&
              swiper.previousIndex !== undefined
            ) {
              dynamicBulletIndex +=
                current - (swiper.previousIndex - swiper.loopedSlides || 0);
              if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
                dynamicBulletIndex = params.dynamicMainBullets - 1;
              } else if (dynamicBulletIndex < 0) {
                dynamicBulletIndex = 0;
              }
            }
            firstIndex = Math.max(current - dynamicBulletIndex, 0);
            lastIndex =
              firstIndex +
              (Math.min(bullets.length, params.dynamicMainBullets) - 1);
            midIndex = (lastIndex + firstIndex) / 2;
          }
          bullets.removeClass(
            ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
              .map((suffix) => `${params.bulletActiveClass}${suffix}`)
              .join(" ")
          );
          if ($el.length > 1) {
            bullets.each((bullet) => {
              const $bullet = dom(bullet);
              const bulletIndex = $bullet.index();
              if (bulletIndex === current) {
                $bullet.addClass(params.bulletActiveClass);
              }
              if (params.dynamicBullets) {
                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                  $bullet.addClass(`${params.bulletActiveClass}-main`);
                }
                if (bulletIndex === firstIndex) {
                  setSideBullets($bullet, "prev");
                }
                if (bulletIndex === lastIndex) {
                  setSideBullets($bullet, "next");
                }
              }
            });
          } else {
            const $bullet = bullets.eq(current);
            const bulletIndex = $bullet.index();
            $bullet.addClass(params.bulletActiveClass);
            if (params.dynamicBullets) {
              const $firstDisplayedBullet = bullets.eq(firstIndex);
              const $lastDisplayedBullet = bullets.eq(lastIndex);
              for (let i = firstIndex; i <= lastIndex; i += 1) {
                bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
              }
              if (swiper.params.loop) {
                if (bulletIndex >= bullets.length) {
                  for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                    bullets
                      .eq(bullets.length - i)
                      .addClass(`${params.bulletActiveClass}-main`);
                  }
                  bullets
                    .eq(bullets.length - params.dynamicMainBullets - 1)
                    .addClass(`${params.bulletActiveClass}-prev`);
                } else {
                  setSideBullets($firstDisplayedBullet, "prev");
                  setSideBullets($lastDisplayedBullet, "next");
                }
              } else {
                setSideBullets($firstDisplayedBullet, "prev");
                setSideBullets($lastDisplayedBullet, "next");
              }
            }
          }
          if (params.dynamicBullets) {
            const dynamicBulletsLength = Math.min(
              bullets.length,
              params.dynamicMainBullets + 4
            );
            const bulletsOffset =
              (bulletSize * dynamicBulletsLength - bulletSize) / 2 -
              midIndex * bulletSize;
            const offsetProp = rtl ? "right" : "left";
            bullets.css(
              swiper.isHorizontal() ? offsetProp : "top",
              `${bulletsOffset}px`
            );
          }
        }
        if (params.type === "fraction") {
          $el
            .find(classes_to_selector_classesToSelector(params.currentClass))
            .text(params.formatFractionCurrent(current + 1));
          $el
            .find(classes_to_selector_classesToSelector(params.totalClass))
            .text(params.formatFractionTotal(total));
        }
        if (params.type === "progressbar") {
          let progressbarDirection;
          if (params.progressbarOpposite) {
            progressbarDirection = swiper.isHorizontal()
              ? "vertical"
              : "horizontal";
          } else {
            progressbarDirection = swiper.isHorizontal()
              ? "horizontal"
              : "vertical";
          }
          const scale = (current + 1) / total;
          let scaleX = 1;
          let scaleY = 1;
          if (progressbarDirection === "horizontal") {
            scaleX = scale;
          } else {
            scaleY = scale;
          }
          $el
            .find(
              classes_to_selector_classesToSelector(params.progressbarFillClass)
            )
            .transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`)
            .transition(swiper.params.speed);
        }
        if (params.type === "custom" && params.renderCustom) {
          $el.html(params.renderCustom(swiper, current + 1, total));
          emit("paginationRender", $el[0]);
        } else {
          emit("paginationUpdate", $el[0]);
        }
        if (swiper.params.watchOverflow && swiper.enabled) {
          $el[swiper.isLocked ? "addClass" : "removeClass"](params.lockClass);
        }
      }
      function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength =
          swiper.virtual && swiper.params.virtual.enabled
            ? swiper.virtual.slides.length
            : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = "";
        if (params.type === "bullets") {
          let numberOfBullets = swiper.params.loop
            ? Math.ceil(
              (slidesLength - swiper.loopedSlides * 2) /
              swiper.params.slidesPerGroup
            )
            : swiper.snapGrid.length;
          if (
            swiper.params.freeMode &&
            swiper.params.freeMode.enabled &&
            !swiper.params.loop &&
            numberOfBullets > slidesLength
          ) {
            numberOfBullets = slidesLength;
          }
          for (let i = 0; i < numberOfBullets; i += 1) {
            if (params.renderBullet) {
              paginationHTML += params.renderBullet.call(
                swiper,
                i,
                params.bulletClass
              );
            } else {
              paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            }
          }
          $el.html(paginationHTML);
          swiper.pagination.bullets = $el.find(
            classes_to_selector_classesToSelector(params.bulletClass)
          );
        }
        if (params.type === "fraction") {
          if (params.renderFraction) {
            paginationHTML = params.renderFraction.call(
              swiper,
              params.currentClass,
              params.totalClass
            );
          } else {
            paginationHTML =
              `<span class="${params.currentClass}"></span>` +
              " / " +
              `<span class="${params.totalClass}"></span>`;
          }
          $el.html(paginationHTML);
        }
        if (params.type === "progressbar") {
          if (params.renderProgressbar) {
            paginationHTML = params.renderProgressbar.call(
              swiper,
              params.progressbarFillClass
            );
          } else {
            paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
          }
          $el.html(paginationHTML);
        }
        if (params.type !== "custom") {
          emit("paginationRender", swiper.pagination.$el[0]);
        }
      }
      function init() {
        swiper.params.pagination =
          create_element_if_not_defined_createElementIfNotDefined(
            swiper,
            swiper.originalParams.pagination,
            swiper.params.pagination,
            {
              el: "swiper-pagination",
            }
          );
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = dom(params.el);
        if ($el.length === 0) return;
        if (
          swiper.params.uniqueNavElements &&
          typeof params.el === "string" &&
          $el.length > 1
        ) {
          $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

          if ($el.length > 1) {
            $el = $el.filter((el) => {
              if (dom(el).parents(".swiper")[0] !== swiper.el) return false;
              return true;
            });
          }
        }
        if (params.type === "bullets" && params.clickable) {
          $el.addClass(params.clickableClass);
        }
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(
          swiper.isHorizontal() ? params.horizontalClass : params.verticalClass
        );
        if (params.type === "bullets" && params.dynamicBullets) {
          $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
          dynamicBulletIndex = 0;
          if (params.dynamicMainBullets < 1) {
            params.dynamicMainBullets = 1;
          }
        }
        if (params.type === "progressbar" && params.progressbarOpposite) {
          $el.addClass(params.progressbarOppositeClass);
        }
        if (params.clickable) {
          $el.on(
            "click",
            classes_to_selector_classesToSelector(params.bulletClass),
            function onClick(e) {
              e.preventDefault();
              let index = dom(this).index() * swiper.params.slidesPerGroup;
              if (swiper.params.loop) index += swiper.loopedSlides;
              swiper.slideTo(index);
            }
          );
        }
        Object.assign(swiper.pagination, {
          $el,
          el: $el[0],
        });
        if (!swiper.enabled) {
          $el.addClass(params.lockClass);
        }
      }
      function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(
          swiper.isHorizontal() ? params.horizontalClass : params.verticalClass
        );
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass)
          swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) {
          $el.off(
            "click",
            classes_to_selector_classesToSelector(params.bulletClass)
          );
        }
      }
      on("init", () => {
        if (swiper.params.pagination.enabled === false) {
          // eslint-disable-next-line
          disable();
        } else {
          init();
          render();
          update();
        }
      });
      on("activeIndexChange", () => {
        if (swiper.params.loop) {
          update();
        } else if (typeof swiper.snapIndex === "undefined") {
          update();
        }
      });
      on("snapIndexChange", () => {
        if (!swiper.params.loop) {
          update();
        }
      });
      on("slidesLengthChange", () => {
        if (swiper.params.loop) {
          render();
          update();
        }
      });
      on("snapGridLengthChange", () => {
        if (!swiper.params.loop) {
          render();
          update();
        }
      });
      on("destroy", () => {
        destroy();
      });
      on("enable disable", () => {
        const { $el } = swiper.pagination;
        if ($el) {
          $el[swiper.enabled ? "removeClass" : "addClass"](
            swiper.params.pagination.lockClass
          );
        }
      });
      on("lock unlock", () => {
        update();
      });
      on("click", (_s, e) => {
        const targetEl = e.target;
        const { $el } = swiper.pagination;
        if (
          swiper.params.pagination.el &&
          swiper.params.pagination.hideOnClick &&
          $el &&
          $el.length > 0 &&
          !dom(targetEl).hasClass(swiper.params.pagination.bulletClass)
        ) {
          if (
            swiper.navigation &&
            ((swiper.navigation.nextEl &&
              targetEl === swiper.navigation.nextEl) ||
              (swiper.navigation.prevEl &&
                targetEl === swiper.navigation.prevEl))
          )
            return;
          const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
          if (isHidden === true) {
            emit("paginationShow");
          } else {
            emit("paginationHide");
          }
          $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
      });
      const enable = () => {
        swiper.$el.removeClass(
          swiper.params.pagination.paginationDisabledClass
        );
        if (swiper.pagination.$el) {
          swiper.pagination.$el.removeClass(
            swiper.params.pagination.paginationDisabledClass
          );
        }
        init();
        render();
        update();
      };
      const disable = () => {
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) {
          swiper.pagination.$el.addClass(
            swiper.params.pagination.paginationDisabledClass
          );
        }
        destroy();
      };
      Object.assign(swiper.pagination, {
        enable,
        disable,
        render,
        update,
        init,
        destroy,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.js
    function Scrollbar({ swiper, extendParams, on, emit }) {
      const document = getDocument();
      let isTouched = false;
      let timeout = null;
      let dragTimeout = null;
      let dragStartPos;
      let dragSize;
      let trackSize;
      let divider;
      extendParams({
        scrollbar: {
          el: null,
          dragSize: "auto",
          hide: false,
          draggable: false,
          snapOnRelease: true,
          lockClass: "swiper-scrollbar-lock",
          dragClass: "swiper-scrollbar-drag",
          scrollbarDisabledClass: "swiper-scrollbar-disabled",
          horizontalClass: `swiper-scrollbar-horizontal`,
          verticalClass: `swiper-scrollbar-vertical`,
        },
      });
      swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null,
      };
      function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar, rtlTranslate: rtl, progress } = swiper;
        const { $dragEl, $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
          newPos = -newPos;
          if (newPos > 0) {
            newSize = dragSize - newPos;
            newPos = 0;
          } else if (-newPos + dragSize > trackSize) {
            newSize = trackSize + newPos;
          }
        } else if (newPos < 0) {
          newSize = dragSize + newPos;
          newPos = 0;
        } else if (newPos + dragSize > trackSize) {
          newSize = trackSize - newPos;
        }
        if (swiper.isHorizontal()) {
          $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
          $dragEl[0].style.width = `${newSize}px`;
        } else {
          $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
          $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
          clearTimeout(timeout);
          $el[0].style.opacity = 1;
          timeout = setTimeout(() => {
            $el[0].style.opacity = 0;
            $el.transition(400);
          }, 1000);
        }
      }
      function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
      }
      function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar } = swiper;
        const { $dragEl, $el } = scrollbar;
        $dragEl[0].style.width = "";
        $dragEl[0].style.height = "";
        trackSize = swiper.isHorizontal()
          ? $el[0].offsetWidth
          : $el[0].offsetHeight;
        divider =
          swiper.size /
          (swiper.virtualSize +
            swiper.params.slidesOffsetBefore -
            (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") {
          dragSize = trackSize * divider;
        } else {
          dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        }
        if (swiper.isHorizontal()) {
          $dragEl[0].style.width = `${dragSize}px`;
        } else {
          $dragEl[0].style.height = `${dragSize}px`;
        }
        if (divider >= 1) {
          $el[0].style.display = "none";
        } else {
          $el[0].style.display = "";
        }
        if (swiper.params.scrollbar.hide) {
          $el[0].style.opacity = 0;
        }
        if (swiper.params.watchOverflow && swiper.enabled) {
          scrollbar.$el[swiper.isLocked ? "addClass" : "removeClass"](
            swiper.params.scrollbar.lockClass
          );
        }
      }
      function getPointerPosition(e) {
        if (swiper.isHorizontal()) {
          return e.type === "touchstart" || e.type === "touchmove"
            ? e.targetTouches[0].clientX
            : e.clientX;
        }
        return e.type === "touchstart" || e.type === "touchmove"
          ? e.targetTouches[0].clientY
          : e.clientY;
      }
      function setDragPosition(e) {
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { $el } = scrollbar;
        let positionRatio;
        positionRatio =
          (getPointerPosition(e) -
            $el.offset()[swiper.isHorizontal() ? "left" : "top"] -
            (dragStartPos !== null ? dragStartPos : dragSize / 2)) /
          (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) {
          positionRatio = 1 - positionRatio;
        }
        const position =
          swiper.minTranslate() +
          (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar, $wrapperEl } = swiper;
        const { $el, $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos =
          e.target === $dragEl[0] || e.target === $dragEl
            ? getPointerPosition(e) -
            e.target.getBoundingClientRect()[
            swiper.isHorizontal() ? "left" : "top"
            ]
            : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) {
          $el.css("opacity", 1);
        }
        if (swiper.params.cssMode) {
          swiper.$wrapperEl.css("scroll-snap-type", "none");
        }
        emit("scrollbarDragStart", e);
      }
      function onDragMove(e) {
        const { scrollbar, $wrapperEl } = swiper;
        const { $el, $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit("scrollbarDragMove", e);
      }
      function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar, $wrapperEl } = swiper;
        const { $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
          swiper.$wrapperEl.css("scroll-snap-type", "");
          $wrapperEl.transition("");
        }
        if (params.hide) {
          clearTimeout(dragTimeout);
          dragTimeout = nextTick(() => {
            $el.css("opacity", 0);
            $el.transition(400);
          }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) {
          swiper.slideToClosest();
        }
      }
      function events(method) {
        const {
          scrollbar,
          touchEventsTouch,
          touchEventsDesktop,
          params,
          support,
        } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener =
          support.passiveListener && params.passiveListeners
            ? {
              passive: false,
              capture: false,
            }
            : false;
        const passiveListener =
          support.passiveListener && params.passiveListeners
            ? {
              passive: true,
              capture: false,
            }
            : false;
        if (!target) return;
        const eventMethod =
          method === "on" ? "addEventListener" : "removeEventListener";
        if (!support.touch) {
          target[eventMethod](
            touchEventsDesktop.start,
            onDragStart,
            activeListener
          );
          document[eventMethod](
            touchEventsDesktop.move,
            onDragMove,
            activeListener
          );
          document[eventMethod](
            touchEventsDesktop.end,
            onDragEnd,
            passiveListener
          );
        } else {
          target[eventMethod](
            touchEventsTouch.start,
            onDragStart,
            activeListener
          );
          target[eventMethod](
            touchEventsTouch.move,
            onDragMove,
            activeListener
          );
          target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
      }
      function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
      }
      function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
      }
      function init() {
        const { scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = createElementIfNotDefined(
          swiper,
          swiper.originalParams.scrollbar,
          swiper.params.scrollbar,
          {
            el: "swiper-scrollbar",
          }
        );
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = $(params.el);
        if (
          swiper.params.uniqueNavElements &&
          typeof params.el === "string" &&
          $el.length > 1 &&
          $swiperEl.find(params.el).length === 1
        ) {
          $el = $swiperEl.find(params.el);
        }
        $el.addClass(
          swiper.isHorizontal() ? params.horizontalClass : params.verticalClass
        );
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
          $dragEl = $(
            `<div class="${swiper.params.scrollbar.dragClass}"></div>`
          );
          $el.append($dragEl);
        }
        Object.assign(scrollbar, {
          $el,
          el: $el[0],
          $dragEl,
          dragEl: $dragEl[0],
        });
        if (params.draggable) {
          enableDraggable();
        }
        if ($el) {
          $el[swiper.enabled ? "removeClass" : "addClass"](
            swiper.params.scrollbar.lockClass
          );
        }
      }
      function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) {
          $el.removeClass(
            swiper.isHorizontal()
              ? params.horizontalClass
              : params.verticalClass
          );
        }
        disableDraggable();
      }
      on("init", () => {
        if (swiper.params.scrollbar.enabled === false) {
          // eslint-disable-next-line
          disable();
        } else {
          init();
          updateSize();
          setTranslate();
        }
      });
      on("update resize observerUpdate lock unlock", () => {
        updateSize();
      });
      on("setTranslate", () => {
        setTranslate();
      });
      on("setTransition", (_s, duration) => {
        setTransition(duration);
      });
      on("enable disable", () => {
        const { $el } = swiper.scrollbar;
        if ($el) {
          $el[swiper.enabled ? "removeClass" : "addClass"](
            swiper.params.scrollbar.lockClass
          );
        }
      });
      on("destroy", () => {
        destroy();
      });
      const enable = () => {
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) {
          swiper.scrollbar.$el.removeClass(
            swiper.params.scrollbar.scrollbarDisabledClass
          );
        }
        init();
        updateSize();
        setTranslate();
      };
      const disable = () => {
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) {
          swiper.scrollbar.$el.addClass(
            swiper.params.scrollbar.scrollbarDisabledClass
          );
        }
        destroy();
      };
      Object.assign(swiper.scrollbar, {
        enable,
        disable,
        updateSize,
        setTranslate,
        init,
        destroy,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/parallax/parallax.js
    function Parallax({ swiper, extendParams, on }) {
      extendParams({
        parallax: {
          enabled: false,
        },
      });
      const setTransform = (el, progress) => {
        const { rtl } = swiper;
        const $el = $(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr("data-swiper-parallax") || "0";
        let x = $el.attr("data-swiper-parallax-x");
        let y = $el.attr("data-swiper-parallax-y");
        const scale = $el.attr("data-swiper-parallax-scale");
        const opacity = $el.attr("data-swiper-parallax-opacity");
        if (x || y) {
          x = x || "0";
          y = y || "0";
        } else if (swiper.isHorizontal()) {
          x = p;
          y = "0";
        } else {
          y = p;
          x = "0";
        }
        if (x.indexOf("%") >= 0) {
          x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        } else {
          x = `${x * progress * rtlFactor}px`;
        }
        if (y.indexOf("%") >= 0) {
          y = `${parseInt(y, 10) * progress}%`;
        } else {
          y = `${y * progress}px`;
        }
        if (typeof opacity !== "undefined" && opacity !== null) {
          const currentOpacity =
            opacity - (opacity - 1) * (1 - Math.abs(progress));
          $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === "undefined" || scale === null) {
          $el.transform(`translate3d(${x}, ${y}, 0px)`);
        } else {
          const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
          $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
      };
      const setTranslate = () => {
        const { $el, slides, progress, snapGrid } = swiper;
        $el
          .children(
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
          )
          .each((el) => {
            setTransform(el, progress);
          });
        slides.each((slideEl, slideIndex) => {
          let slideProgress = slideEl.progress;
          if (
            swiper.params.slidesPerGroup > 1 &&
            swiper.params.slidesPerView !== "auto"
          ) {
            slideProgress +=
              Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
          }
          slideProgress = Math.min(Math.max(slideProgress, -1), 1);
          $(slideEl)
            .find(
              "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
            )
            .each((el) => {
              setTransform(el, slideProgress);
            });
        });
      };
      const setTransition = (duration = swiper.params.speed) => {
        const { $el } = swiper;
        $el
          .find(
            "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]"
          )
          .each((parallaxEl) => {
            const $parallaxEl = $(parallaxEl);
            let parallaxDuration =
              parseInt($parallaxEl.attr("data-swiper-parallax-duration"), 10) ||
              duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
          });
      };
      on("beforeInit", () => {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
      });
      on("init", () => {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
      });
      on("setTranslate", () => {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
      });
      on("setTransition", (_swiper, duration) => {
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/zoom/zoom.js
    function Zoom({ swiper, extendParams, on, emit }) {
      const window = getWindow();
      extendParams({
        zoom: {
          enabled: false,
          maxRatio: 3,
          minRatio: 1,
          toggle: true,
          containerClass: "swiper-zoom-container",
          zoomedSlideClass: "swiper-slide-zoomed",
        },
      });
      swiper.zoom = {
        enabled: false,
      };
      let currentScale = 1;
      let isScaling = false;
      let gesturesEnabled;
      let fakeGestureTouched;
      let fakeGestureMoved;
      const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3,
      };
      const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {},
      };
      const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined,
      };
      let scale = 1;
      Object.defineProperty(swiper.zoom, "scale", {
        get() {
          return scale;
        },
        set(value) {
          if (scale !== value) {
            const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
            const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
            emit("zoomChange", value, imageEl, slideEl);
          }
          scale = value;
        },
      });
      function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
      } // Events

      function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
          if (
            e.type !== "touchstart" ||
            (e.type === "touchstart" && e.targetTouches.length < 2)
          ) {
            return;
          }
          fakeGestureTouched = true;
          gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
          gesture.$slideEl = $(e.target).closest(
            `.${swiper.params.slideClass}`
          );
          if (gesture.$slideEl.length === 0)
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          gesture.$imageEl = gesture.$slideEl
            .find(`.${params.containerClass}`)
            .eq(0)
            .find("picture, img, svg, canvas, .swiper-zoom-target")
            .eq(0);
          gesture.$imageWrapEl = gesture.$imageEl.parent(
            `.${params.containerClass}`
          );
          gesture.maxRatio =
            gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
          if (gesture.$imageWrapEl.length === 0) {
            gesture.$imageEl = undefined;
            return;
          }
        }
        if (gesture.$imageEl) {
          gesture.$imageEl.transition(0);
        }
        isScaling = true;
      }
      function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
          if (
            e.type !== "touchmove" ||
            (e.type === "touchmove" && e.targetTouches.length < 2)
          ) {
            return;
          }
          fakeGestureMoved = true;
          gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          if (e.type === "gesturechange") onGestureStart(e);
          return;
        }
        if (support.gestures) {
          zoom.scale = e.scale * currentScale;
        } else {
          zoom.scale = (gesture.scaleMove / gesture.scaleStart) * currentScale;
        }
        if (zoom.scale > gesture.maxRatio) {
          zoom.scale =
            gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        }
        if (zoom.scale < params.minRatio) {
          zoom.scale =
            params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        }
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
      }
      function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
          if (!fakeGestureTouched || !fakeGestureMoved) {
            return;
          }
          if (
            e.type !== "touchend" ||
            (e.type === "touchend" &&
              e.changedTouches.length < 2 &&
              !device.android)
          ) {
            return;
          }
          fakeGestureTouched = false;
          fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(
          Math.min(zoom.scale, gesture.maxRatio),
          params.minRatio
        );
        gesture.$imageEl
          .transition(swiper.params.speed)
          .transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
      }
      function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x =
          e.type === "touchstart" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y =
          e.type === "touchstart" ? e.targetTouches[0].pageY : e.pageY;
      }
      function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
          image.width = gesture.$imageEl[0].offsetWidth;
          image.height = gesture.$imageEl[0].offsetHeight;
          image.startX = getTranslate(gesture.$imageWrapEl[0], "x") || 0;
          image.startY = getTranslate(gesture.$imageWrapEl[0], "y") || 0;
          gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
          gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
          gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag

        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (
          scaledWidth < gesture.slideWidth &&
          scaledHeight < gesture.slideHeight
        )
          return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x =
          e.type === "touchmove" ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y =
          e.type === "touchmove" ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
          if (
            swiper.isHorizontal() &&
            ((Math.floor(image.minX) === Math.floor(image.startX) &&
              image.touchesCurrent.x < image.touchesStart.x) ||
              (Math.floor(image.maxX) === Math.floor(image.startX) &&
                image.touchesCurrent.x > image.touchesStart.x))
          ) {
            image.isTouched = false;
            return;
          }
          if (
            !swiper.isHorizontal() &&
            ((Math.floor(image.minY) === Math.floor(image.startY) &&
              image.touchesCurrent.y < image.touchesStart.y) ||
              (Math.floor(image.maxY) === Math.floor(image.startY) &&
                image.touchesCurrent.y > image.touchesStart.y))
          ) {
            image.isTouched = false;
            return;
          }
        }
        if (e.cancelable) {
          e.preventDefault();
        }
        e.stopPropagation();
        image.isMoved = true;
        image.currentX =
          image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY =
          image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) {
          image.currentX =
            image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        }
        if (image.currentX > image.maxX) {
          image.currentX =
            image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        }
        if (image.currentY < image.minY) {
          image.currentY =
            image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        }
        if (image.currentY > image.maxY) {
          image.currentY =
            image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        } // Velocity

        if (!velocity.prevPositionX)
          velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY)
          velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x =
          (image.touchesCurrent.x - velocity.prevPositionX) /
          (Date.now() - velocity.prevTime) /
          2;
        velocity.y =
          (image.touchesCurrent.y - velocity.prevPositionY) /
          (Date.now() - velocity.prevTime) /
          2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2)
          velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2)
          velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(
          `translate3d(${image.currentX}px, ${image.currentY}px,0)`
        );
      }
      function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
          image.isTouched = false;
          image.isMoved = false;
          return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration

        if (velocity.x !== 0)
          momentumDurationX = Math.abs(
            (newPositionX - image.currentX) / velocity.x
          );
        if (velocity.y !== 0)
          momentumDurationY = Math.abs(
            (newPositionY - image.currentY) / velocity.y
          );
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag

        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(
          Math.min(image.currentX, image.maxX),
          image.minX
        );
        image.currentY = Math.max(
          Math.min(image.currentY, image.maxY),
          image.minY
        );
        gesture.$imageWrapEl
          .transition(momentumDuration)
          .transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
      }
      function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
          if (gesture.$imageEl) {
            gesture.$imageEl.transform("translate3d(0,0,0) scale(1)");
          }
          if (gesture.$imageWrapEl) {
            gesture.$imageWrapEl.transform("translate3d(0,0,0)");
          }
          zoom.scale = 1;
          currentScale = 1;
          gesture.$slideEl = undefined;
          gesture.$imageEl = undefined;
          gesture.$imageWrapEl = undefined;
        }
      }
      function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
          if (e && e.target) {
            gesture.$slideEl = $(e.target).closest(
              `.${swiper.params.slideClass}`
            );
          }
          if (!gesture.$slideEl) {
            if (
              swiper.params.virtual &&
              swiper.params.virtual.enabled &&
              swiper.virtual
            ) {
              gesture.$slideEl = swiper.$wrapperEl.children(
                `.${swiper.params.slideActiveClass}`
              );
            } else {
              gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
          }
          gesture.$imageEl = gesture.$slideEl
            .find(`.${params.containerClass}`)
            .eq(0)
            .find("picture, img, svg, canvas, .swiper-zoom-target")
            .eq(0);
          gesture.$imageWrapEl = gesture.$imageEl.parent(
            `.${params.containerClass}`
          );
        }
        if (
          !gesture.$imageEl ||
          gesture.$imageEl.length === 0 ||
          !gesture.$imageWrapEl ||
          gesture.$imageWrapEl.length === 0
        )
          return;
        if (swiper.params.cssMode) {
          swiper.wrapperEl.style.overflow = "hidden";
          swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
          touchX = e.type === "touchend" ? e.changedTouches[0].pageX : e.pageX;
          touchY = e.type === "touchend" ? e.changedTouches[0].pageY : e.pageY;
        } else {
          touchX = image.touchesStart.x;
          touchY = image.touchesStart.y;
        }
        zoom.scale =
          gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        currentScale =
          gesture.$imageWrapEl.attr("data-swiper-zoom") || params.maxRatio;
        if (e) {
          slideWidth = gesture.$slideEl[0].offsetWidth;
          slideHeight = gesture.$slideEl[0].offsetHeight;
          offsetX = gesture.$slideEl.offset().left + window.scrollX;
          offsetY = gesture.$slideEl.offset().top + window.scrollY;
          diffX = offsetX + slideWidth / 2 - touchX;
          diffY = offsetY + slideHeight / 2 - touchY;
          imageWidth = gesture.$imageEl[0].offsetWidth;
          imageHeight = gesture.$imageEl[0].offsetHeight;
          scaledWidth = imageWidth * zoom.scale;
          scaledHeight = imageHeight * zoom.scale;
          translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
          translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
          translateMaxX = -translateMinX;
          translateMaxY = -translateMinY;
          translateX = diffX * zoom.scale;
          translateY = diffY * zoom.scale;
          if (translateX < translateMinX) {
            translateX = translateMinX;
          }
          if (translateX > translateMaxX) {
            translateX = translateMaxX;
          }
          if (translateY < translateMinY) {
            translateY = translateMinY;
          }
          if (translateY > translateMaxY) {
            translateY = translateMaxY;
          }
        } else {
          translateX = 0;
          translateY = 0;
        }
        gesture.$imageWrapEl
          .transition(300)
          .transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl
          .transition(300)
          .transform(`translate3d(0,0,0) scale(${zoom.scale})`);
      }
      function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
          if (
            swiper.params.virtual &&
            swiper.params.virtual.enabled &&
            swiper.virtual
          ) {
            gesture.$slideEl = swiper.$wrapperEl.children(
              `.${swiper.params.slideActiveClass}`
            );
          } else {
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          }
          gesture.$imageEl = gesture.$slideEl
            .find(`.${params.containerClass}`)
            .eq(0)
            .find("picture, img, svg, canvas, .swiper-zoom-target")
            .eq(0);
          gesture.$imageWrapEl = gesture.$imageEl.parent(
            `.${params.containerClass}`
          );
        }
        if (
          !gesture.$imageEl ||
          gesture.$imageEl.length === 0 ||
          !gesture.$imageWrapEl ||
          gesture.$imageWrapEl.length === 0
        )
          return;
        if (swiper.params.cssMode) {
          swiper.wrapperEl.style.overflow = "";
          swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform("translate3d(0,0,0)");
        gesture.$imageEl
          .transition(300)
          .transform("translate3d(0,0,0) scale(1)");
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
      } // Toggle Zoom

      function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) {
          // Zoom Out
          zoomOut();
        } else {
          // Zoom In
          zoomIn(e);
        }
      }
      function getListeners() {
        const support = swiper.support;
        const passiveListener =
          swiper.touchEvents.start === "touchstart" &&
            support.passiveListener &&
            swiper.params.passiveListeners
            ? {
              passive: true,
              capture: false,
            }
            : false;
        const activeListenerWithCapture = support.passiveListener
          ? {
            passive: false,
            capture: true,
          }
          : true;
        return {
          passiveListener,
          activeListenerWithCapture,
        };
      }
      function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
      }
      function toggleGestures(method) {
        const { passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method](
          "gesturestart",
          slideSelector,
          onGestureStart,
          passiveListener
        );
        swiper.$wrapperEl[method](
          "gesturechange",
          slideSelector,
          onGestureChange,
          passiveListener
        );
        swiper.$wrapperEl[method](
          "gestureend",
          slideSelector,
          onGestureEnd,
          passiveListener
        );
      }
      function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures("on");
      }
      function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures("off");
      } // Attach/Detach Events

      function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image

        if (support.gestures) {
          swiper.$wrapperEl.on(
            swiper.touchEvents.start,
            enableGestures,
            passiveListener
          );
          swiper.$wrapperEl.on(
            swiper.touchEvents.end,
            disableGestures,
            passiveListener
          );
        } else if (swiper.touchEvents.start === "touchstart") {
          swiper.$wrapperEl.on(
            swiper.touchEvents.start,
            slideSelector,
            onGestureStart,
            passiveListener
          );
          swiper.$wrapperEl.on(
            swiper.touchEvents.move,
            slideSelector,
            onGestureChange,
            activeListenerWithCapture
          );
          swiper.$wrapperEl.on(
            swiper.touchEvents.end,
            slideSelector,
            onGestureEnd,
            passiveListener
          );
          if (swiper.touchEvents.cancel) {
            swiper.$wrapperEl.on(
              swiper.touchEvents.cancel,
              slideSelector,
              onGestureEnd,
              passiveListener
            );
          }
        } // Move image

        swiper.$wrapperEl.on(
          swiper.touchEvents.move,
          `.${swiper.params.zoom.containerClass}`,
          onTouchMove,
          activeListenerWithCapture
        );
      }
      function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image

        if (support.gestures) {
          swiper.$wrapperEl.off(
            swiper.touchEvents.start,
            enableGestures,
            passiveListener
          );
          swiper.$wrapperEl.off(
            swiper.touchEvents.end,
            disableGestures,
            passiveListener
          );
        } else if (swiper.touchEvents.start === "touchstart") {
          swiper.$wrapperEl.off(
            swiper.touchEvents.start,
            slideSelector,
            onGestureStart,
            passiveListener
          );
          swiper.$wrapperEl.off(
            swiper.touchEvents.move,
            slideSelector,
            onGestureChange,
            activeListenerWithCapture
          );
          swiper.$wrapperEl.off(
            swiper.touchEvents.end,
            slideSelector,
            onGestureEnd,
            passiveListener
          );
          if (swiper.touchEvents.cancel) {
            swiper.$wrapperEl.off(
              swiper.touchEvents.cancel,
              slideSelector,
              onGestureEnd,
              passiveListener
            );
          }
        } // Move image

        swiper.$wrapperEl.off(
          swiper.touchEvents.move,
          `.${swiper.params.zoom.containerClass}`,
          onTouchMove,
          activeListenerWithCapture
        );
      }
      on("init", () => {
        if (swiper.params.zoom.enabled) {
          enable();
        }
      });
      on("destroy", () => {
        disable();
      });
      on("touchStart", (_s, e) => {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
      });
      on("touchEnd", (_s, e) => {
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
      });
      on("doubleTap", (_s, e) => {
        if (
          !swiper.animating &&
          swiper.params.zoom.enabled &&
          swiper.zoom.enabled &&
          swiper.params.zoom.toggle
        ) {
          zoomToggle(e);
        }
      });
      on("transitionEnd", () => {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
          onTransitionEnd();
        }
      });
      on("slideChange", () => {
        if (
          swiper.zoom.enabled &&
          swiper.params.zoom.enabled &&
          swiper.params.cssMode
        ) {
          onTransitionEnd();
        }
      });
      Object.assign(swiper.zoom, {
        enable,
        disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/lazy/lazy.js
    function Lazy({ swiper, extendParams, on, emit }) {
      extendParams({
        lazy: {
          checkInView: false,
          enabled: false,
          loadPrevNext: false,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: false,
          scrollingElement: "",
          elementClass: "swiper-lazy",
          loadingClass: "swiper-lazy-loading",
          loadedClass: "swiper-lazy-loaded",
          preloaderClass: "swiper-lazy-preloader",
        },
      });
      swiper.lazy = {};
      let scrollHandlerAttached = false;
      let initialImageLoaded = false;
      function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === "undefined") return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual
          ? swiper.$wrapperEl.children(
            `.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`
          )
          : swiper.slides.eq(index);
        const $images = $slideEl.find(
          `.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`
        );
        if (
          $slideEl.hasClass(params.elementClass) &&
          !$slideEl.hasClass(params.loadedClass) &&
          !$slideEl.hasClass(params.loadingClass)
        ) {
          $images.push($slideEl[0]);
        }
        if ($images.length === 0) return;
        $images.each((imageEl) => {
          const $imageEl = $(imageEl);
          $imageEl.addClass(params.loadingClass);
          const background = $imageEl.attr("data-background");
          const src = $imageEl.attr("data-src");
          const srcset = $imageEl.attr("data-srcset");
          const sizes = $imageEl.attr("data-sizes");
          const $pictureEl = $imageEl.parent("picture");
          swiper.loadImage(
            $imageEl[0],
            src || background,
            srcset,
            sizes,
            false,
            () => {
              if (
                typeof swiper === "undefined" ||
                swiper === null ||
                !swiper ||
                (swiper && !swiper.params) ||
                swiper.destroyed
              )
                return;
              if (background) {
                $imageEl.css("background-image", `url("${background}")`);
                $imageEl.removeAttr("data-background");
              } else {
                if (srcset) {
                  $imageEl.attr("srcset", srcset);
                  $imageEl.removeAttr("data-srcset");
                }
                if (sizes) {
                  $imageEl.attr("sizes", sizes);
                  $imageEl.removeAttr("data-sizes");
                }
                if ($pictureEl.length) {
                  $pictureEl.children("source").each((sourceEl) => {
                    const $source = $(sourceEl);
                    if ($source.attr("data-srcset")) {
                      $source.attr("srcset", $source.attr("data-srcset"));
                      $source.removeAttr("data-srcset");
                    }
                  });
                }
                if (src) {
                  $imageEl.attr("src", src);
                  $imageEl.removeAttr("data-src");
                }
              }
              $imageEl
                .addClass(params.loadedClass)
                .removeClass(params.loadingClass);
              $slideEl.find(`.${params.preloaderClass}`).remove();
              if (swiper.params.loop && loadInDuplicate) {
                const slideOriginalIndex = $slideEl.attr(
                  "data-swiper-slide-index"
                );
                if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                  const originalSlide = swiper.$wrapperEl.children(
                    `[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`
                  );
                  loadInSlide(originalSlide.index(), false);
                } else {
                  const duplicatedSlide = swiper.$wrapperEl.children(
                    `.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`
                  );
                  loadInSlide(duplicatedSlide.index(), false);
                }
              }
              emit("lazyImageReady", $slideEl[0], $imageEl[0]);
              if (swiper.params.autoHeight) {
                swiper.updateAutoHeight();
              }
            }
          );
          emit("lazyImageLoad", $slideEl[0], $imageEl[0]);
        });
      }
      function load() {
        const {
          $wrapperEl,
          params: swiperParams,
          slides,
          activeIndex,
        } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === "auto") {
          slidesPerView = 0;
        }
        function slideExist(index) {
          if (isVirtual) {
            if (
              $wrapperEl.children(
                `.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`
              ).length
            ) {
              return true;
            }
          } else if (slides[index]) return true;
          return false;
        }
        function slideIndex(slideEl) {
          if (isVirtual) {
            return $(slideEl).attr("data-swiper-slide-index");
          }
          return $(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) {
          $wrapperEl
            .children(`.${swiperParams.slideVisibleClass}`)
            .each((slideEl) => {
              const index = isVirtual
                ? $(slideEl).attr("data-swiper-slide-index")
                : $(slideEl).index();
              loadInSlide(index);
            });
        } else if (slidesPerView > 1) {
          for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
            if (slideExist(i)) loadInSlide(i);
          }
        } else {
          loadInSlide(activeIndex);
        }
        if (params.loadPrevNext) {
          if (
            slidesPerView > 1 ||
            (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)
          ) {
            const amount = params.loadPrevNextAmount;
            const spv = Math.ceil(slidesPerView);
            const maxIndex = Math.min(
              activeIndex + spv + Math.max(amount, spv),
              slides.length
            );
            const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

            for (let i = activeIndex + spv; i < maxIndex; i += 1) {
              if (slideExist(i)) loadInSlide(i);
            } // Prev Slides

            for (let i = minIndex; i < activeIndex; i += 1) {
              if (slideExist(i)) loadInSlide(i);
            }
          } else {
            const nextSlide = $wrapperEl.children(
              `.${swiperParams.slideNextClass}`
            );
            if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
            const prevSlide = $wrapperEl.children(
              `.${swiperParams.slidePrevClass}`
            );
            if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
          }
        }
      }
      function checkInViewOnLoad() {
        const window = getWindow();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement
          ? $(swiper.params.lazy.scrollingElement)
          : $(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow
          ? window.innerWidth
          : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow
          ? window.innerHeight
          : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
          [swiperOffset.left, swiperOffset.top],
          [swiperOffset.left + swiper.width, swiperOffset.top],
          [swiperOffset.left, swiperOffset.top + swiper.height],
          [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height],
        ];
        for (let i = 0; i < swiperCoord.length; i += 1) {
          const point = swiperCoord[i];
          if (
            point[0] >= 0 &&
            point[0] <= scrollElementWidth &&
            point[1] >= 0 &&
            point[1] <= scrollElementHeight
          ) {
            if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

            inView = true;
          }
        }
        const passiveListener =
          swiper.touchEvents.start === "touchstart" &&
            swiper.support.passiveListener &&
            swiper.params.passiveListeners
            ? {
              passive: true,
              capture: false,
            }
            : false;
        if (inView) {
          load();
          $scrollElement.off("scroll", checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
          scrollHandlerAttached = true;
          $scrollElement.on("scroll", checkInViewOnLoad, passiveListener);
        }
      }
      on("beforeInit", () => {
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
          swiper.params.preloadImages = false;
        }
      });
      on("init", () => {
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.checkInView) {
            checkInViewOnLoad();
          } else {
            load();
          }
        }
      });
      on("scroll", () => {
        if (
          swiper.params.freeMode &&
          swiper.params.freeMode.enabled &&
          !swiper.params.freeMode.sticky
        ) {
          load();
        }
      });
      on("scrollbarDragMove resize _freeModeNoMomentumRelease", () => {
        if (swiper.params.lazy.enabled) {
          if (swiper.params.lazy.checkInView) {
            checkInViewOnLoad();
          } else {
            load();
          }
        }
      });
      on("transitionStart", () => {
        if (swiper.params.lazy.enabled) {
          if (
            swiper.params.lazy.loadOnTransitionStart ||
            (!swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded)
          ) {
            if (swiper.params.lazy.checkInView) {
              checkInViewOnLoad();
            } else {
              load();
            }
          }
        }
      });
      on("transitionEnd", () => {
        if (
          swiper.params.lazy.enabled &&
          !swiper.params.lazy.loadOnTransitionStart
        ) {
          if (swiper.params.lazy.checkInView) {
            checkInViewOnLoad();
          } else {
            load();
          }
        }
      });
      on("slideChange", () => {
        const {
          lazy,
          cssMode,
          watchSlidesProgress,
          touchReleaseOnEdges,
          resistanceRatio,
        } = swiper.params;
        if (
          lazy.enabled &&
          (cssMode ||
            (watchSlidesProgress &&
              (touchReleaseOnEdges || resistanceRatio === 0)))
        ) {
          load();
        }
      });
      on("destroy", () => {
        if (!swiper.$el) return;
        swiper.$el
          .find(`.${swiper.params.lazy.loadingClass}`)
          .removeClass(swiper.params.lazy.loadingClass);
      });
      Object.assign(swiper.lazy, {
        load,
        loadInSlide,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/controller/controller.js
    /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

    function Controller({ swiper, extendParams, on }) {
      extendParams({
        controller: {
          control: undefined,
          inverse: false,
          by: "slide", // or 'container'
        },
      });

      swiper.controller = {
        control: undefined,
      };
      function LinearSpline(x, y) {
        const binarySearch = (function search() {
          let maxIndex;
          let minIndex;
          let guess;
          return (array, val) => {
            minIndex = -1;
            maxIndex = array.length;
            while (maxIndex - minIndex > 1) {
              guess = (maxIndex + minIndex) >> 1;
              if (array[guess] <= val) {
                minIndex = guess;
              } else {
                maxIndex = guess;
              }
            }
            return maxIndex;
          };
        })();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.

        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
          if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):

          i3 = binarySearch(this.x, x2);
          i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
          // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

          return (
            ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) /
            (this.x[i3] - this.x[i1]) +
            this.y[i1]
          );
        };
        return this;
      } // xxx: for now i will just save one spline function to to

      function getInterpolateFunction(c) {
        if (!swiper.controller.spline) {
          swiper.controller.spline = swiper.params.loop
            ? new LinearSpline(swiper.slidesGrid, c.slidesGrid)
            : new LinearSpline(swiper.snapGrid, c.snapGrid);
        }
      }
      function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
          // this will create an Interpolate function based on the snapGrids
          // x is the Grid of the scrolled scroller and y will be the controlled scroller
          // it makes sense to create this only once and recall it for the interpolation
          // the function does a lot of value caching for performance
          const translate = swiper.rtlTranslate
            ? -swiper.translate
            : swiper.translate;
          if (swiper.params.controller.by === "slide") {
            getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
            // but it did not work out

            controlledTranslate = -swiper.controller.spline.interpolate(
              -translate
            );
          }
          if (
            !controlledTranslate ||
            swiper.params.controller.by === "container"
          ) {
            multiplier =
              (c.maxTranslate() - c.minTranslate()) /
              (swiper.maxTranslate() - swiper.minTranslate());
            controlledTranslate =
              (translate - swiper.minTranslate()) * multiplier +
              c.minTranslate();
          }
          if (swiper.params.controller.inverse) {
            controlledTranslate = c.maxTranslate() - controlledTranslate;
          }
          c.updateProgress(controlledTranslate);
          c.setTranslate(controlledTranslate, swiper);
          c.updateActiveIndex();
          c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
          for (let i = 0; i < controlled.length; i += 1) {
            if (
              controlled[i] !== byController &&
              controlled[i] instanceof Swiper
            ) {
              setControlledTranslate(controlled[i]);
            }
          }
        } else if (
          controlled instanceof Swiper &&
          byController !== controlled
        ) {
          setControlledTranslate(controlled);
        }
      }
      function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
          c.setTransition(duration, swiper);
          if (duration !== 0) {
            c.transitionStart();
            if (c.params.autoHeight) {
              nextTick(() => {
                c.updateAutoHeight();
              });
            }
            c.$wrapperEl.transitionEnd(() => {
              if (!controlled) return;
              if (c.params.loop && swiper.params.controller.by === "slide") {
                c.loopFix();
              }
              c.transitionEnd();
            });
          }
        }
        if (Array.isArray(controlled)) {
          for (i = 0; i < controlled.length; i += 1) {
            if (
              controlled[i] !== byController &&
              controlled[i] instanceof Swiper
            ) {
              setControlledTransition(controlled[i]);
            }
          }
        } else if (
          controlled instanceof Swiper &&
          byController !== controlled
        ) {
          setControlledTransition(controlled);
        }
      }
      function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
          swiper.controller.spline = undefined;
          delete swiper.controller.spline;
        }
      }
      on("beforeInit", () => {
        swiper.controller.control = swiper.params.controller.control;
      });
      on("update", () => {
        removeSpline();
      });
      on("resize", () => {
        removeSpline();
      });
      on("observerUpdate", () => {
        removeSpline();
      });
      on("setTranslate", (_s, translate, byController) => {
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
      });
      on("setTransition", (_s, duration, byController) => {
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
      });
      Object.assign(swiper.controller, {
        setTranslate,
        setTransition,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/a11y/a11y.js
    function A11y({ swiper, extendParams, on }) {
      extendParams({
        a11y: {
          enabled: true,
          notificationClass: "swiper-notification",
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
          firstSlideMessage: "This is the first slide",
          lastSlideMessage: "This is the last slide",
          paginationBulletMessage: "Go to slide {{index}}",
          slideLabelMessage: "{{index}} / {{slidesLength}}",
          containerMessage: null,
          containerRoleDescriptionMessage: null,
          itemRoleDescriptionMessage: null,
          slideRole: "group",
          id: null,
        },
      });
      swiper.a11y = {
        clicked: false,
      };
      let liveRegion = null;
      function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html("");
        notification.html(message);
      }
      function getRandomNumber(size = 16) {
        const randomChar = () => Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
      }
      function makeElFocusable($el) {
        $el.attr("tabIndex", "0");
      }
      function makeElNotFocusable($el) {
        $el.attr("tabIndex", "-1");
      }
      function addElRole($el, role) {
        $el.attr("role", role);
      }
      function addElRoleDescription($el, description) {
        $el.attr("aria-roledescription", description);
      }
      function addElControls($el, controls) {
        $el.attr("aria-controls", controls);
      }
      function addElLabel($el, label) {
        $el.attr("aria-label", label);
      }
      function addElId($el, id) {
        $el.attr("id", id);
      }
      function addElLive($el, live) {
        $el.attr("aria-live", live);
      }
      function disableEl($el) {
        $el.attr("aria-disabled", true);
      }
      function enableEl($el) {
        $el.attr("aria-disabled", false);
      }
      function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = $(e.target);
        if (
          swiper.navigation &&
          swiper.navigation.$nextEl &&
          $targetEl.is(swiper.navigation.$nextEl)
        ) {
          if (!(swiper.isEnd && !swiper.params.loop)) {
            swiper.slideNext();
          }
          if (swiper.isEnd) {
            notify(params.lastSlideMessage);
          } else {
            notify(params.nextSlideMessage);
          }
        }
        if (
          swiper.navigation &&
          swiper.navigation.$prevEl &&
          $targetEl.is(swiper.navigation.$prevEl)
        ) {
          if (!(swiper.isBeginning && !swiper.params.loop)) {
            swiper.slidePrev();
          }
          if (swiper.isBeginning) {
            notify(params.firstSlideMessage);
          } else {
            notify(params.prevSlideMessage);
          }
        }
        if (
          swiper.pagination &&
          $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))
        ) {
          $targetEl[0].click();
        }
      }
      function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation)
          return;
        const { $nextEl, $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            disableEl($prevEl);
            makeElNotFocusable($prevEl);
          } else {
            enableEl($prevEl);
            makeElFocusable($prevEl);
          }
        }
        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            disableEl($nextEl);
            makeElNotFocusable($nextEl);
          } else {
            enableEl($nextEl);
            makeElFocusable($nextEl);
          }
        }
      }
      function hasPagination() {
        return (
          swiper.pagination &&
          swiper.pagination.bullets &&
          swiper.pagination.bullets.length
        );
      }
      function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
      }
      function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl) => {
          const $bulletEl = $(bulletEl);
          if (swiper.params.pagination.clickable) {
            makeElFocusable($bulletEl);
            if (!swiper.params.pagination.renderBullet) {
              addElRole($bulletEl, "button");
              addElLabel(
                $bulletEl,
                params.paginationBulletMessage.replace(
                  /\{\{index\}\}/,
                  $bulletEl.index() + 1
                )
              );
            }
          }
          if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) {
            $bulletEl.attr("aria-current", "true");
          } else {
            $bulletEl.removeAttr("aria-current");
          }
        });
      }
      const initNavEl = ($el, wrapperId, message) => {
        makeElFocusable($el);
        if ($el[0].tagName !== "BUTTON") {
          addElRole($el, "button");
          $el.on("keydown", onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
      };
      const handlePointerDown = () => {
        swiper.a11y.clicked = true;
      };
      const handlePointerUp = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!swiper.destroyed) {
              swiper.a11y.clicked = false;
            }
          });
        });
      };
      const handleFocus = (e) => {
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible =
          swiper.params.watchSlidesProgress &&
          swiper.visibleSlides &&
          swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents)
          return;
        if (swiper.isHorizontal()) {
          swiper.el.scrollLeft = 0;
        } else {
          swiper.el.scrollTop = 0;
        }
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
      };
      const initSlides = () => {
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) {
          addElRoleDescription(
            $(swiper.slides),
            params.itemRoleDescriptionMessage
          );
        }
        if (params.slideRole) {
          addElRole($(swiper.slides), params.slideRole);
        }
        const slidesLength = swiper.params.loop
          ? swiper.slides.filter(
            (el) => !el.classList.contains(swiper.params.slideDuplicateClass)
          ).length
          : swiper.slides.length;
        if (params.slideLabelMessage) {
          swiper.slides.each((slideEl, index) => {
            const $slideEl = $(slideEl);
            const slideIndex = swiper.params.loop
              ? parseInt($slideEl.attr("data-swiper-slide-index"), 10)
              : index;
            const ariaLabelMessage = params.slideLabelMessage
              .replace(/\{\{index\}\}/, slideIndex + 1)
              .replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
          });
        }
      };
      const init = () => {
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container

        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) {
          addElRoleDescription(
            $containerEl,
            params.containerRoleDescriptionMessage
          );
        }
        if (params.containerMessage) {
          addElLabel($containerEl, params.containerMessage);
        } // Wrapper

        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId =
          params.id ||
          $wrapperEl.attr("id") ||
          `swiper-wrapper-${getRandomNumber(16)}`;
        const live =
          swiper.params.autoplay && swiper.params.autoplay.enabled
            ? "off"
            : "polite";
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide

        initSlides(); // Navigation

        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }
        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }
        if ($nextEl && $nextEl.length) {
          initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        }
        if ($prevEl && $prevEl.length) {
          initNavEl($prevEl, wrapperId, params.prevSlideMessage);
        } // Pagination

        if (hasClickablePagination()) {
          swiper.pagination.$el.on(
            "keydown",
            classesToSelector(swiper.params.pagination.bulletClass),
            onEnterOrSpaceKey
          );
        } // Tab focus

        swiper.$el.on("focus", handleFocus, true);
        swiper.$el.on("pointerdown", handlePointerDown, true);
        swiper.$el.on("pointerup", handlePointerUp, true);
      };
      function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }
        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }
        if ($nextEl) {
          $nextEl.off("keydown", onEnterOrSpaceKey);
        }
        if ($prevEl) {
          $prevEl.off("keydown", onEnterOrSpaceKey);
        } // Pagination

        if (hasClickablePagination()) {
          swiper.pagination.$el.off(
            "keydown",
            classesToSelector(swiper.params.pagination.bulletClass),
            onEnterOrSpaceKey
          );
        } // Tab focus

        swiper.$el.off("focus", handleFocus, true);
        swiper.$el.off("pointerdown", handlePointerDown, true);
        swiper.$el.off("pointerup", handlePointerUp, true);
      }
      on("beforeInit", () => {
        liveRegion = $(
          `<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`
        );
      });
      on("afterInit", () => {
        if (!swiper.params.a11y.enabled) return;
        init();
      });
      on(
        "slidesLengthChange snapGridLengthChange slidesGridLengthChange",
        () => {
          if (!swiper.params.a11y.enabled) return;
          initSlides();
        }
      );
      on("fromEdge toEdge afterInit lock unlock", () => {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
      });
      on("paginationUpdate", () => {
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
      });
      on("destroy", () => {
        if (!swiper.params.a11y.enabled) return;
        destroy();
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/history/history.js
    function History({ swiper, extendParams, on }) {
      extendParams({
        history: {
          enabled: false,
          root: "",
          replaceState: false,
          key: "slides",
          keepQuery: false,
        },
      });
      let initialized = false;
      let paths = {};
      const slugify = (text) => {
        return text
          .toString()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]+/g, "")
          .replace(/--+/g, "-")
          .replace(/^-+/, "")
          .replace(/-+$/, "");
      };
      const getPathValues = (urlOverride) => {
        const window = getWindow();
        let location;
        if (urlOverride) {
          location = new URL(urlOverride);
        } else {
          location = window.location;
        }
        const pathArray = location.pathname
          .slice(1)
          .split("/")
          .filter((part) => part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
          key,
          value,
        };
      };
      const setHistory = (key, index) => {
        const window = getWindow();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) {
          location = new URL(swiper.params.url);
        } else {
          location = window.location;
        }
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr("data-history"));
        if (swiper.params.history.root.length > 0) {
          let root = swiper.params.history.root;
          if (root[root.length - 1] === "/")
            root = root.slice(0, root.length - 1);
          value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) {
          value = `${key}/${value}`;
        }
        if (swiper.params.history.keepQuery) {
          value += location.search;
        }
        const currentState = window.history.state;
        if (currentState && currentState.value === value) {
          return;
        }
        if (swiper.params.history.replaceState) {
          window.history.replaceState(
            {
              value,
            },
            null,
            value
          );
        } else {
          window.history.pushState(
            {
              value,
            },
            null,
            value
          );
        }
      };
      const scrollToSlide = (speed, value, runCallbacks) => {
        if (value) {
          for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr("data-history"));
            if (
              slideHistory === value &&
              !slide.hasClass(swiper.params.slideDuplicateClass)
            ) {
              const index = slide.index();
              swiper.slideTo(index, speed, runCallbacks);
            }
          }
        } else {
          swiper.slideTo(0, speed, runCallbacks);
        }
      };
      const setHistoryPopState = () => {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
      };
      const init = () => {
        const window = getWindow();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
          swiper.params.history.enabled = false;
          swiper.params.hashNavigation.enabled = true;
          return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) {
          window.addEventListener("popstate", setHistoryPopState);
        }
      };
      const destroy = () => {
        const window = getWindow();
        if (!swiper.params.history.replaceState) {
          window.removeEventListener("popstate", setHistoryPopState);
        }
      };
      on("init", () => {
        if (swiper.params.history.enabled) {
          init();
        }
      });
      on("destroy", () => {
        if (swiper.params.history.enabled) {
          destroy();
        }
      });
      on("transitionEnd _freeModeNoMomentumRelease", () => {
        if (initialized) {
          setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      });
      on("slideChange", () => {
        if (initialized && swiper.params.cssMode) {
          setHistory(swiper.params.history.key, swiper.activeIndex);
        }
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/hash-navigation/hash-navigation.js
    function HashNavigation({ swiper, extendParams, emit, on }) {
      let initialized = false;
      const document = getDocument();
      const window = getWindow();
      extendParams({
        hashNavigation: {
          enabled: false,
          replaceState: false,
          watchState: false,
        },
      });
      const onHashChange = () => {
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideHash = swiper.slides
          .eq(swiper.activeIndex)
          .attr("data-hash");
        if (newHash !== activeSlideHash) {
          const newIndex = swiper.$wrapperEl
            .children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`)
            .index();
          if (typeof newIndex === "undefined") return;
          swiper.slideTo(newIndex);
        }
      };
      const setHash = () => {
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (
          swiper.params.hashNavigation.replaceState &&
          window.history &&
          window.history.replaceState
        ) {
          window.history.replaceState(
            null,
            null,
            `#${swiper.slides.eq(swiper.activeIndex).attr("data-hash")}` || ""
          );
          emit("hashSet");
        } else {
          const slide = swiper.slides.eq(swiper.activeIndex);
          const hash = slide.attr("data-hash") || slide.attr("data-history");
          document.location.hash = hash || "";
          emit("hashSet");
        }
      };
      const init = () => {
        if (
          !swiper.params.hashNavigation.enabled ||
          (swiper.params.history && swiper.params.history.enabled)
        )
          return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
          const speed = 0;
          for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
            const slide = swiper.slides.eq(i);
            const slideHash =
              slide.attr("data-hash") || slide.attr("data-history");
            if (
              slideHash === hash &&
              !slide.hasClass(swiper.params.slideDuplicateClass)
            ) {
              const index = slide.index();
              swiper.slideTo(
                index,
                speed,
                swiper.params.runCallbacksOnInit,
                true
              );
            }
          }
        }
        if (swiper.params.hashNavigation.watchState) {
          $(window).on("hashchange", onHashChange);
        }
      };
      const destroy = () => {
        if (swiper.params.hashNavigation.watchState) {
          $(window).off("hashchange", onHashChange);
        }
      };
      on("init", () => {
        if (swiper.params.hashNavigation.enabled) {
          init();
        }
      });
      on("destroy", () => {
        if (swiper.params.hashNavigation.enabled) {
          destroy();
        }
      });
      on("transitionEnd _freeModeNoMomentumRelease", () => {
        if (initialized) {
          setHash();
        }
      });
      on("slideChange", () => {
        if (initialized && swiper.params.cssMode) {
          setHash();
        }
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/autoplay/autoplay.js
    /* eslint no-underscore-dangle: "off" */

    /* eslint no-use-before-define: "off" */

    function Autoplay({ swiper, extendParams, on, emit }) {
      let timeout;
      swiper.autoplay = {
        running: false,
        paused: false,
      };
      extendParams({
        autoplay: {
          enabled: false,
          delay: 3000,
          waitForTransition: true,
          disableOnInteraction: true,
          stopOnLastSlide: false,
          reverseDirection: false,
          pauseOnMouseEnter: false,
        },
      });
      function run() {
        if (!swiper.size) {
          swiper.autoplay.running = false;
          swiper.autoplay.paused = false;
          return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr("data-swiper-autoplay")) {
          delay =
            $activeSlideEl.attr("data-swiper-autoplay") ||
            swiper.params.autoplay.delay;
        }
        clearTimeout(timeout);
        timeout = utils_nextTick(() => {
          let autoplayResult;
          if (swiper.params.autoplay.reverseDirection) {
            if (swiper.params.loop) {
              swiper.loopFix();
              autoplayResult = swiper.slidePrev(
                swiper.params.speed,
                true,
                true
              );
              emit("autoplay");
            } else if (!swiper.isBeginning) {
              autoplayResult = swiper.slidePrev(
                swiper.params.speed,
                true,
                true
              );
              emit("autoplay");
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
              autoplayResult = swiper.slideTo(
                swiper.slides.length - 1,
                swiper.params.speed,
                true,
                true
              );
              emit("autoplay");
            } else {
              stop();
            }
          } else if (swiper.params.loop) {
            swiper.loopFix();
            autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
            emit("autoplay");
          } else if (!swiper.isEnd) {
            autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
            emit("autoplay");
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
            emit("autoplay");
          } else {
            stop();
          }
          if (swiper.params.cssMode && swiper.autoplay.running) run();
          else if (autoplayResult === false) {
            run();
          }
        }, delay);
      }
      function start() {
        if (typeof timeout !== "undefined") return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit("autoplayStart");
        run();
        return true;
      }
      function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === "undefined") return false;
        if (timeout) {
          clearTimeout(timeout);
          timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit("autoplayStop");
        return true;
      }
      function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
          swiper.autoplay.paused = false;
          run();
        } else {
          ["transitionend", "webkitTransitionEnd"].forEach((event) => {
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
          });
        }
      }
      function onVisibilityChange() {
        const document = ssr_window_esm_getDocument();
        if (document.visibilityState === "hidden" && swiper.autoplay.running) {
          pause();
        }
        if (document.visibilityState === "visible" && swiper.autoplay.paused) {
          run();
          swiper.autoplay.paused = false;
        }
      }
      function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        ["transitionend", "webkitTransitionEnd"].forEach((event) => {
          swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) {
          stop();
        } else {
          run();
        }
      }
      function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) {
          stop();
        } else {
          emit("autoplayPause");
          pause();
        }
        ["transitionend", "webkitTransitionEnd"].forEach((event) => {
          swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
      }
      function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) {
          return;
        }
        swiper.autoplay.paused = false;
        emit("autoplayResume");
        run();
      }
      function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
          swiper.$el.on("mouseenter", onMouseEnter);
          swiper.$el.on("mouseleave", onMouseLeave);
        }
      }
      function detachMouseEvents() {
        swiper.$el.off("mouseenter", onMouseEnter);
        swiper.$el.off("mouseleave", onMouseLeave);
      }
      on("init", () => {
        if (swiper.params.autoplay.enabled) {
          start();
          const document = ssr_window_esm_getDocument();
          document.addEventListener("visibilitychange", onVisibilityChange);
          attachMouseEvents();
        }
      });
      on("beforeTransitionStart", (_s, speed, internal) => {
        if (swiper.autoplay.running) {
          if (internal || !swiper.params.autoplay.disableOnInteraction) {
            swiper.autoplay.pause(speed);
          } else {
            stop();
          }
        }
      });
      on("sliderFirstMove", () => {
        if (swiper.autoplay.running) {
          if (swiper.params.autoplay.disableOnInteraction) {
            stop();
          } else {
            pause();
          }
        }
      });
      on("touchEnd", () => {
        if (
          swiper.params.cssMode &&
          swiper.autoplay.paused &&
          !swiper.params.autoplay.disableOnInteraction
        ) {
          run();
        }
      });
      on("destroy", () => {
        detachMouseEvents();
        if (swiper.autoplay.running) {
          stop();
        }
        const document = ssr_window_esm_getDocument();
        document.removeEventListener("visibilitychange", onVisibilityChange);
      });
      Object.assign(swiper.autoplay, {
        pause,
        run,
        start,
        stop,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/thumbs/thumbs.js
    function Thumb({ swiper, extendParams, on }) {
      extendParams({
        thumbs: {
          swiper: null,
          multipleActiveThumbs: true,
          autoScrollOffset: 0,
          slideThumbActiveClass: "swiper-slide-thumb-active",
          thumbsContainerClass: "swiper-thumbs",
        },
      });
      let initialized = false;
      let swiperCreated = false;
      swiper.thumbs = {
        swiper: null,
      };
      function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (
          clickedSlide &&
          dom(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)
        )
          return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null)
          return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) {
          slideToIndex = parseInt(
            dom(thumbsSwiper.clickedSlide).attr("data-swiper-slide-index"),
            10
          );
        } else {
          slideToIndex = clickedIndex;
        }
        if (swiper.params.loop) {
          let currentIndex = swiper.activeIndex;
          if (
            swiper.slides
              .eq(currentIndex)
              .hasClass(swiper.params.slideDuplicateClass)
          ) {
            swiper.loopFix(); // eslint-disable-next-line

            swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
            currentIndex = swiper.activeIndex;
          }
          const prevIndex = swiper.slides
            .eq(currentIndex)
            .prevAll(`[data-swiper-slide-index="${slideToIndex}"]`)
            .eq(0)
            .index();
          const nextIndex = swiper.slides
            .eq(currentIndex)
            .nextAll(`[data-swiper-slide-index="${slideToIndex}"]`)
            .eq(0)
            .index();
          if (typeof prevIndex === "undefined") slideToIndex = nextIndex;
          else if (typeof nextIndex === "undefined") slideToIndex = prevIndex;
          else if (nextIndex - currentIndex < currentIndex - prevIndex)
            slideToIndex = nextIndex;
          else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
      }
      function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
          swiper.thumbs.swiper = thumbsParams.swiper;
          Object.assign(swiper.thumbs.swiper.originalParams, {
            watchSlidesProgress: true,
            slideToClickedSlide: false,
          });
          Object.assign(swiper.thumbs.swiper.params, {
            watchSlidesProgress: true,
            slideToClickedSlide: false,
          });
        } else if (utils_isObject(thumbsParams.swiper)) {
          const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
          Object.assign(thumbsSwiperParams, {
            watchSlidesProgress: true,
            slideToClickedSlide: false,
          });
          swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
          swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(
          swiper.params.thumbs.thumbsContainerClass
        );
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
      }
      function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView =
          thumbsSwiper.params.slidesPerView === "auto"
            ? thumbsSwiper.slidesPerViewDynamic()
            : thumbsSwiper.params.slidesPerView; // Activate thumbs

        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
          thumbsToActivate = swiper.params.slidesPerView;
        }
        if (!swiper.params.thumbs.multipleActiveThumbs) {
          thumbsToActivate = 1;
        }
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (
          thumbsSwiper.params.loop ||
          (thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled)
        ) {
          for (let i = 0; i < thumbsToActivate; i += 1) {
            thumbsSwiper.$wrapperEl
              .children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`)
              .addClass(thumbActiveClass);
          }
        } else {
          for (let i = 0; i < thumbsToActivate; i += 1) {
            thumbsSwiper.slides
              .eq(swiper.realIndex + i)
              .addClass(thumbActiveClass);
          }
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
          let currentThumbsIndex = thumbsSwiper.activeIndex;
          let newThumbsIndex;
          let direction;
          if (thumbsSwiper.params.loop) {
            if (
              thumbsSwiper.slides
                .eq(currentThumbsIndex)
                .hasClass(thumbsSwiper.params.slideDuplicateClass)
            ) {
              thumbsSwiper.loopFix(); // eslint-disable-next-line

              thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
              currentThumbsIndex = thumbsSwiper.activeIndex;
            } // Find actual thumbs index to slide to

            const prevThumbsIndex = thumbsSwiper.slides
              .eq(currentThumbsIndex)
              .prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`)
              .eq(0)
              .index();
            const nextThumbsIndex = thumbsSwiper.slides
              .eq(currentThumbsIndex)
              .nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`)
              .eq(0)
              .index();
            if (typeof prevThumbsIndex === "undefined") {
              newThumbsIndex = nextThumbsIndex;
            } else if (typeof nextThumbsIndex === "undefined") {
              newThumbsIndex = prevThumbsIndex;
            } else if (
              nextThumbsIndex - currentThumbsIndex ===
              currentThumbsIndex - prevThumbsIndex
            ) {
              newThumbsIndex =
                thumbsSwiper.params.slidesPerGroup > 1
                  ? nextThumbsIndex
                  : currentThumbsIndex;
            } else if (
              nextThumbsIndex - currentThumbsIndex <
              currentThumbsIndex - prevThumbsIndex
            ) {
              newThumbsIndex = nextThumbsIndex;
            } else {
              newThumbsIndex = prevThumbsIndex;
            }
            direction =
              swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
          } else {
            newThumbsIndex = swiper.realIndex;
            direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
          }
          if (useOffset) {
            newThumbsIndex +=
              direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
          }
          if (
            thumbsSwiper.visibleSlidesIndexes &&
            thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0
          ) {
            if (thumbsSwiper.params.centeredSlides) {
              if (newThumbsIndex > currentThumbsIndex) {
                newThumbsIndex =
                  newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
              } else {
                newThumbsIndex =
                  newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
              }
            } else if (
              newThumbsIndex > currentThumbsIndex &&
              thumbsSwiper.params.slidesPerGroup === 1
            ) {
              // newThumbsIndex = newThumbsIndex - slidesPerView + 1;
            }
            thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
          }
        }
      }
      on("beforeInit", () => {
        const { thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
      });
      on("slideChange update resize observerUpdate", () => {
        update();
      });
      on("setTransition", (_s, duration) => {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
      });
      on("beforeDestroy", () => {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) {
          thumbsSwiper.destroy();
        }
      });
      Object.assign(swiper.thumbs, {
        init,
        update,
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/free-mode/free-mode.js
    function freeMode({ swiper, extendParams, emit, once }) {
      extendParams({
        freeMode: {
          enabled: false,
          momentum: true,
          momentumRatio: 1,
          momentumBounce: true,
          momentumBounceRatio: 1,
          momentumVelocityRatio: 1,
          sticky: false,
          minimumVelocity: 0.02,
        },
      });
      function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
          currentPos: swiper.rtl ? swiper.translate : -swiper.translate,
        });
      }
      function onTouchMove() {
        const { touchEventsData: data, touches } = swiper; // Velocity

        if (data.velocities.length === 0) {
          data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime,
          });
        }
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
          time: now(),
        });
      }
      function onTouchEnd({ currentPos }) {
        const {
          params,
          $wrapperEl,
          rtlTranslate: rtl,
          snapGrid,
          touchEventsData: data,
        } = swiper; // Time diff

        const touchEndTime = now();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (currentPos > -swiper.maxTranslate()) {
          if (swiper.slides.length < snapGrid.length) {
            swiper.slideTo(snapGrid.length - 1);
          } else {
            swiper.slideTo(swiper.slides.length - 1);
          }
          return;
        }
        if (params.freeMode.momentum) {
          if (data.velocities.length > 1) {
            const lastMoveEvent = data.velocities.pop();
            const velocityEvent = data.velocities.pop();
            const distance = lastMoveEvent.position - velocityEvent.position;
            const time = lastMoveEvent.time - velocityEvent.time;
            swiper.velocity = distance / time;
            swiper.velocity /= 2;
            if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
              swiper.velocity = 0;
            } // this implies that the user stopped moving a finger then released.
            // There would be no events with distance zero, so the last event is stale.

            if (time > 150 || now() - lastMoveEvent.time > 300) {
              swiper.velocity = 0;
            }
          } else {
            swiper.velocity = 0;
          }
          swiper.velocity *= params.freeMode.momentumVelocityRatio;
          data.velocities.length = 0;
          let momentumDuration = 1000 * params.freeMode.momentumRatio;
          const momentumDistance = swiper.velocity * momentumDuration;
          let newPosition = swiper.translate + momentumDistance;
          if (rtl) newPosition = -newPosition;
          let doBounce = false;
          let afterBouncePosition;
          const bounceAmount =
            Math.abs(swiper.velocity) *
            20 *
            params.freeMode.momentumBounceRatio;
          let needsLoopFix;
          if (newPosition < swiper.maxTranslate()) {
            if (params.freeMode.momentumBounce) {
              if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                newPosition = swiper.maxTranslate() - bounceAmount;
              }
              afterBouncePosition = swiper.maxTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.maxTranslate();
            }
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (newPosition > swiper.minTranslate()) {
            if (params.freeMode.momentumBounce) {
              if (newPosition - swiper.minTranslate() > bounceAmount) {
                newPosition = swiper.minTranslate() + bounceAmount;
              }
              afterBouncePosition = swiper.minTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.minTranslate();
            }
            if (params.loop && params.centeredSlides) needsLoopFix = true;
          } else if (params.freeMode.sticky) {
            let nextSlide;
            for (let j = 0; j < snapGrid.length; j += 1) {
              if (snapGrid[j] > -newPosition) {
                nextSlide = j;
                break;
              }
            }
            if (
              Math.abs(snapGrid[nextSlide] - newPosition) <
              Math.abs(snapGrid[nextSlide - 1] - newPosition) ||
              swiper.swipeDirection === "next"
            ) {
              newPosition = snapGrid[nextSlide];
            } else {
              newPosition = snapGrid[nextSlide - 1];
            }
            newPosition = -newPosition;
          }
          if (needsLoopFix) {
            once("transitionEnd", () => {
              swiper.loopFix();
            });
          } // Fix duration

          if (swiper.velocity !== 0) {
            if (rtl) {
              momentumDuration = Math.abs(
                (-newPosition - swiper.translate) / swiper.velocity
              );
            } else {
              momentumDuration = Math.abs(
                (newPosition - swiper.translate) / swiper.velocity
              );
            }
            if (params.freeMode.sticky) {
              // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
              // event, then durations can be 20+ seconds to slide one (or zero!) slides.
              // It's easy to see this when simulating touch with mouse events. To fix this,
              // limit single-slide swipes to the default slide duration. This also has the
              // nice side effect of matching slide speed if the user stopped moving before
              // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
              // For faster swipes, also apply limits (albeit higher ones).
              const moveDistance = Math.abs(
                (rtl ? -newPosition : newPosition) - swiper.translate
              );
              const currentSlideSize =
                swiper.slidesSizesGrid[swiper.activeIndex];
              if (moveDistance < currentSlideSize) {
                momentumDuration = params.speed;
              } else if (moveDistance < 2 * currentSlideSize) {
                momentumDuration = params.speed * 1.5;
              } else {
                momentumDuration = params.speed * 2.5;
              }
            }
          } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
          }
          if (params.freeMode.momentumBounce && doBounce) {
            swiper.updateProgress(afterBouncePosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            swiper.animating = true;
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed || !data.allowMomentumBounce)
                return;
              emit("momentumBounce");
              swiper.setTransition(params.speed);
              setTimeout(() => {
                swiper.setTranslate(afterBouncePosition);
                $wrapperEl.transitionEnd(() => {
                  if (!swiper || swiper.destroyed) return;
                  swiper.transitionEnd();
                });
              }, 0);
            });
          } else if (swiper.velocity) {
            emit("_freeModeNoMomentumRelease");
            swiper.updateProgress(newPosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            if (!swiper.animating) {
              swiper.animating = true;
              $wrapperEl.transitionEnd(() => {
                if (!swiper || swiper.destroyed) return;
                swiper.transitionEnd();
              });
            }
          } else {
            swiper.updateProgress(newPosition);
          }
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
          swiper.slideToClosest();
          return;
        } else if (params.freeMode) {
          emit("_freeModeNoMomentumRelease");
        }
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
      }
      Object.assign(swiper, {
        freeMode: {
          onTouchStart,
          onTouchMove,
          onTouchEnd,
        },
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/grid/grid.js
    function Grid({ swiper, extendParams }) {
      extendParams({
        grid: {
          rows: 1,
          fill: "column",
        },
      });
      let slidesNumberEvenToRows;
      let slidesPerRow;
      let numFullColumns;
      const initSlides = (slidesLength) => {
        const { slidesPerView } = swiper.params;
        const { rows, fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) {
          slidesNumberEvenToRows = slidesLength;
        } else {
          slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        }
        if (slidesPerView !== "auto" && fill === "row") {
          slidesNumberEvenToRows = Math.max(
            slidesNumberEvenToRows,
            slidesPerView * rows
          );
        }
      };
      const updateSlide = (i, slide, slidesLength, getDirectionLabel) => {
        const { slidesPerGroup, spaceBetween } = swiper.params;
        const { rows, fill } = swiper.params.grid; // Set slides order

        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
          const groupIndex = Math.floor(i / (slidesPerGroup * rows));
          const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
          const columnsInGroup =
            groupIndex === 0
              ? slidesPerGroup
              : Math.min(
                Math.ceil(
                  (slidesLength - groupIndex * rows * slidesPerGroup) / rows
                ),
                slidesPerGroup
              );
          row = Math.floor(slideIndexInGroup / columnsInGroup);
          column =
            slideIndexInGroup -
            row * columnsInGroup +
            groupIndex * slidesPerGroup;
          newSlideOrderIndex = column + (row * slidesNumberEvenToRows) / rows;
          slide.css({
            "-webkit-order": newSlideOrderIndex,
            order: newSlideOrderIndex,
          });
        } else if (fill === "column") {
          column = Math.floor(i / rows);
          row = i - column * rows;
          if (
            column > numFullColumns ||
            (column === numFullColumns && row === rows - 1)
          ) {
            row += 1;
            if (row >= rows) {
              row = 0;
              column += 1;
            }
          }
        } else {
          row = Math.floor(i / slidesPerRow);
          column = i - row * slidesPerRow;
        }
        slide.css(
          getDirectionLabel("margin-top"),
          row !== 0 ? spaceBetween && `${spaceBetween}px` : ""
        );
      };
      const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel) => {
        const { spaceBetween, centeredSlides, roundLengths } = swiper.params;
        const { rows } = swiper.params.grid;
        swiper.virtualSize =
          (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize =
          Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
          [getDirectionLabel("width")]: `${swiper.virtualSize + spaceBetween
            }px`,
        });
        if (centeredSlides) {
          snapGrid.splice(0, snapGrid.length);
          const newSlidesGrid = [];
          for (let i = 0; i < snapGrid.length; i += 1) {
            let slidesGridItem = snapGrid[i];
            if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] < swiper.virtualSize + snapGrid[0])
              newSlidesGrid.push(slidesGridItem);
          }
          snapGrid.push(...newSlidesGrid);
        }
      };
      swiper.grid = {
        initSlides,
        updateSlide,
        updateWrapperSize,
      };
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/appendSlide.js
    function appendSlide(slides) {
      const swiper = this;
      const { $wrapperEl, params } = swiper;
      if (params.loop) {
        swiper.loopDestroy();
      }
      if (typeof slides === "object" && "length" in slides) {
        for (let i = 0; i < slides.length; i += 1) {
          if (slides[i]) $wrapperEl.append(slides[i]);
        }
      } else {
        $wrapperEl.append(slides);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!params.observer) {
        swiper.update();
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/prependSlide.js
    function prependSlide(slides) {
      const swiper = this;
      const { params, $wrapperEl, activeIndex } = swiper;
      if (params.loop) {
        swiper.loopDestroy();
      }
      let newActiveIndex = activeIndex + 1;
      if (typeof slides === "object" && "length" in slides) {
        for (let i = 0; i < slides.length; i += 1) {
          if (slides[i]) $wrapperEl.prepend(slides[i]);
        }
        newActiveIndex = activeIndex + slides.length;
      } else {
        $wrapperEl.prepend(slides);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!params.observer) {
        swiper.update();
      }
      swiper.slideTo(newActiveIndex, 0, false);
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/addSlide.js
    function addSlide(index, slides) {
      const swiper = this;
      const { $wrapperEl, params, activeIndex } = swiper;
      let activeIndexBuffer = activeIndex;
      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
      }
      const baseLength = swiper.slides.length;
      if (index <= 0) {
        swiper.prependSlide(slides);
        return;
      }
      if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
      }
      let newActiveIndex =
        activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
      const slidesBuffer = [];
      for (let i = baseLength - 1; i >= index; i -= 1) {
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
      }
      if (typeof slides === "object" && "length" in slides) {
        for (let i = 0; i < slides.length; i += 1) {
          if (slides[i]) $wrapperEl.append(slides[i]);
        }
        newActiveIndex =
          activeIndexBuffer > index
            ? activeIndexBuffer + slides.length
            : activeIndexBuffer;
      } else {
        $wrapperEl.append(slides);
      }
      for (let i = 0; i < slidesBuffer.length; i += 1) {
        $wrapperEl.append(slidesBuffer[i]);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!params.observer) {
        swiper.update();
      }
      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/removeSlide.js
    function removeSlide(slidesIndexes) {
      const swiper = this;
      const { params, $wrapperEl, activeIndex } = swiper;
      let activeIndexBuffer = activeIndex;
      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
      }
      let newActiveIndex = activeIndexBuffer;
      let indexToRemove;
      if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for (let i = 0; i < slidesIndexes.length; i += 1) {
          indexToRemove = slidesIndexes[i];
          if (swiper.slides[indexToRemove])
            swiper.slides.eq(indexToRemove).remove();
          if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
      } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove])
          swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!params.observer) {
        swiper.update();
      }
      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/methods/removeAllSlides.js
    function removeAllSlides() {
      const swiper = this;
      const slidesIndexes = [];
      for (let i = 0; i < swiper.slides.length; i += 1) {
        slidesIndexes.push(i);
      }
      swiper.removeSlide(slidesIndexes);
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/manipulation/manipulation.js
    function Manipulation({ swiper }) {
      Object.assign(swiper, {
        appendSlide: appendSlide.bind(swiper),
        prependSlide: prependSlide.bind(swiper),
        addSlide: addSlide.bind(swiper),
        removeSlide: removeSlide.bind(swiper),
        removeAllSlides: removeAllSlides.bind(swiper),
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/effect-init.js
    function effect_init_effectInit(params) {
      const {
        effect,
        swiper,
        on,
        setTranslate,
        setTransition,
        overwriteParams,
        perspective,
        recreateShadows,
        getEffectParams,
      } = params;
      on("beforeInit", () => {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(
          `${swiper.params.containerModifierClass}${effect}`
        );
        if (perspective && perspective()) {
          swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        }
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
      });
      on("setTranslate", () => {
        if (swiper.params.effect !== effect) return;
        setTranslate();
      });
      on("setTransition", (_s, duration) => {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
      });
      on("transitionEnd", () => {
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
          if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows

          swiper.slides.each((slideEl) => {
            const $slideEl = swiper.$(slideEl);
            $slideEl
              .find(
                ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
              )
              .remove();
          }); // create new one

          recreateShadows();
        }
      });
      let requireUpdateOnVirtual;
      on("virtualUpdate", () => {
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) {
          requireUpdateOnVirtual = true;
        }
        requestAnimationFrame(() => {
          if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
            setTranslate();
            requireUpdateOnVirtual = false;
          }
        });
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/effect-target.js
    function effect_target_effectTarget(effectParams, $slideEl) {
      if (effectParams.transformEl) {
        return $slideEl.find(effectParams.transformEl).css({
          "backface-visibility": "hidden",
          "-webkit-backface-visibility": "hidden",
        });
      }
      return $slideEl;
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/effect-virtual-transition-end.js
    function effect_virtual_transition_end_effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides,
    }) {
      const { slides, activeIndex, $wrapperEl } = swiper;
      if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) {
          $transitionEndTarget = transformEl
            ? slides.find(transformEl)
            : slides;
        } else {
          $transitionEndTarget = transformEl
            ? slides.eq(activeIndex).find(transformEl)
            : slides.eq(activeIndex);
        }
        $transitionEndTarget.transitionEnd(() => {
          if (eventTriggered) return;
          if (!swiper || swiper.destroyed) return;
          eventTriggered = true;
          swiper.animating = false;
          const triggerEvents = ["webkitTransitionEnd", "transitionend"];
          for (let i = 0; i < triggerEvents.length; i += 1) {
            $wrapperEl.trigger(triggerEvents[i]);
          }
        });
      }
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.js
    function EffectFade({ swiper, extendParams, on }) {
      extendParams({
        fadeEffect: {
          crossFade: false,
          transformEl: null,
        },
      });
      const setTranslate = () => {
        const { slides } = swiper;
        const params = swiper.params.fadeEffect;
        for (let i = 0; i < slides.length; i += 1) {
          const $slideEl = swiper.slides.eq(i);
          const offset = $slideEl[0].swiperSlideOffset;
          let tx = -offset;
          if (!swiper.params.virtualTranslate) tx -= swiper.translate;
          let ty = 0;
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
          }
          const slideOpacity = swiper.params.fadeEffect.crossFade
            ? Math.max(1 - Math.abs($slideEl[0].progress), 0)
            : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
          const $targetEl = effect_target_effectTarget(params, $slideEl);
          $targetEl
            .css({
              opacity: slideOpacity,
            })
            .transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
      };
      const setTransition = (duration) => {
        const { transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl
          ? swiper.slides.find(transformEl)
          : swiper.slides;
        $transitionElements.transition(duration);
        effect_virtual_transition_end_effectVirtualTransitionEnd({
          swiper,
          duration,
          transformEl,
          allSlides: true,
        });
      };
      effect_init_effectInit({
        effect: "fade",
        swiper,
        on,
        setTranslate,
        setTransition,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: !swiper.params.cssMode,
        }),
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cube/effect-cube.js
    function EffectCube({ swiper, extendParams, on }) {
      extendParams({
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 20,
          shadowScale: 0.94,
        },
      });
      const createSlideShadows = ($slideEl, progress, isHorizontal) => {
        let shadowBefore = isHorizontal
          ? $slideEl.find(".swiper-slide-shadow-left")
          : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal
          ? $slideEl.find(".swiper-slide-shadow-right")
          : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) {
          shadowBefore = $(
            `<div class="swiper-slide-shadow-${isHorizontal ? "left" : "top"
            }"></div>`
          );
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = $(
            `<div class="swiper-slide-shadow-${isHorizontal ? "right" : "bottom"
            }"></div>`
          );
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length)
          shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length)
          shadowAfter[0].style.opacity = Math.max(progress, 0);
      };
      const recreateShadows = () => {
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl) => {
          const progress = Math.max(Math.min(slideEl.progress, 1), -1);
          createSlideShadows($(slideEl), progress, isHorizontal);
        });
      };
      const setTranslate = () => {
        const {
          $el,
          $wrapperEl,
          slides,
          width: swiperWidth,
          height: swiperHeight,
          rtlTranslate: rtl,
          size: swiperSize,
          browser,
        } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl = $wrapperEl.find(".swiper-cube-shadow");
            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
              $wrapperEl.append($cubeShadowEl);
            }
            $cubeShadowEl.css({
              height: `${swiperWidth}px`,
            });
          } else {
            $cubeShadowEl = $el.find(".swiper-cube-shadow");
            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
              $el.append($cubeShadowEl);
            }
          }
        }
        for (let i = 0; i < slides.length; i += 1) {
          const $slideEl = slides.eq(i);
          let slideIndex = i;
          if (isVirtual) {
            slideIndex = parseInt($slideEl.attr("data-swiper-slide-index"), 10);
          }
          let slideAngle = slideIndex * 90;
          let round = Math.floor(slideAngle / 360);
          if (rtl) {
            slideAngle = -slideAngle;
            round = Math.floor(-slideAngle / 360);
          }
          const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          let tx = 0;
          let ty = 0;
          let tz = 0;
          if (slideIndex % 4 === 0) {
            tx = -round * 4 * swiperSize;
            tz = 0;
          } else if ((slideIndex - 1) % 4 === 0) {
            tx = 0;
            tz = -round * 4 * swiperSize;
          } else if ((slideIndex - 2) % 4 === 0) {
            tx = swiperSize + round * 4 * swiperSize;
            tz = swiperSize;
          } else if ((slideIndex - 3) % 4 === 0) {
            tx = -swiperSize;
            tz = 3 * swiperSize + swiperSize * 4 * round;
          }
          if (rtl) {
            tx = -tx;
          }
          if (!isHorizontal) {
            ty = tx;
            tx = 0;
          }
          const transform = `rotateX(${isHorizontal ? 0 : -slideAngle
            }deg) rotateY(${isHorizontal ? slideAngle : 0
            }deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
          if (progress <= 1 && progress > -1) {
            wrapperRotate = slideIndex * 90 + progress * 90;
            if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
          }
          $slideEl.transform(transform);
          if (params.slideShadows) {
            createSlideShadows($slideEl, progress, isHorizontal);
          }
        }
        $wrapperEl.css({
          "-webkit-transform-origin": `50% 50% -${swiperSize / 2}px`,
          "transform-origin": `50% 50% -${swiperSize / 2}px`,
        });
        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl.transform(
              `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2
              }px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`
            );
          } else {
            const shadowAngle =
              Math.abs(wrapperRotate) -
              Math.floor(Math.abs(wrapperRotate) / 90) * 90;
            const multiplier =
              1.5 -
              (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2 +
                Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2);
            const scale1 = params.shadowScale;
            const scale2 = params.shadowScale / multiplier;
            const offset = params.shadowOffset;
            $cubeShadowEl.transform(
              `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset
              }px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`
            );
          }
        }
        const zFactor =
          browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(
          `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate
          }deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`
        );
        $wrapperEl[0].style.setProperty(
          "--swiper-cube-translate-z",
          `${zFactor}px`
        );
      };
      const setTransition = (duration) => {
        const { $el, slides } = swiper;
        slides
          .transition(duration)
          .find(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          )
          .transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
          $el.find(".swiper-cube-shadow").transition(duration);
        }
      };
      effectInit({
        effect: "cube",
        swiper,
        on,
        setTranslate,
        setTransition,
        recreateShadows,
        getEffectParams: () => swiper.params.cubeEffect,
        perspective: () => true,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          resistanceRatio: 0,
          spaceBetween: 0,
          centeredSlides: false,
          virtualTranslate: true,
        }),
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/shared/create-shadow.js
    function create_shadow_createShadow(params, $slideEl, side) {
      const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}`;
      const $shadowContainer = params.transformEl
        ? $slideEl.find(params.transformEl)
        : $slideEl;
      let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
      if (!$shadowEl.length) {
        $shadowEl = $(
          `<div class="swiper-slide-shadow${side ? `-${side}` : ""}"></div>`
        );
        $shadowContainer.append($shadowEl);
      }
      return $shadowEl;
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/effect-flip/effect-flip.js
    function EffectFlip({ swiper, extendParams, on }) {
      extendParams({
        flipEffect: {
          slideShadows: true,
          limitRotation: true,
          transformEl: null,
        },
      });
      const createSlideShadows = ($slideEl, progress, params) => {
        let shadowBefore = swiper.isHorizontal()
          ? $slideEl.find(".swiper-slide-shadow-left")
          : $slideEl.find(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal()
          ? $slideEl.find(".swiper-slide-shadow-right")
          : $slideEl.find(".swiper-slide-shadow-bottom");
        if (shadowBefore.length === 0) {
          shadowBefore = createShadow(
            params,
            $slideEl,
            swiper.isHorizontal() ? "left" : "top"
          );
        }
        if (shadowAfter.length === 0) {
          shadowAfter = createShadow(
            params,
            $slideEl,
            swiper.isHorizontal() ? "right" : "bottom"
          );
        }
        if (shadowBefore.length)
          shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length)
          shadowAfter[0].style.opacity = Math.max(progress, 0);
      };
      const recreateShadows = () => {
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl) => {
          const $slideEl = $(slideEl);
          let progress = $slideEl[0].progress;
          if (swiper.params.flipEffect.limitRotation) {
            progress = Math.max(Math.min(slideEl.progress, 1), -1);
          }
          createSlideShadows($slideEl, progress, params);
        });
      };
      const setTranslate = () => {
        const { slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for (let i = 0; i < slides.length; i += 1) {
          const $slideEl = slides.eq(i);
          let progress = $slideEl[0].progress;
          if (swiper.params.flipEffect.limitRotation) {
            progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          }
          const offset = $slideEl[0].swiperSlideOffset;
          const rotate = -180 * progress;
          let rotateY = rotate;
          let rotateX = 0;
          let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
          let ty = 0;
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
            rotateX = -rotateY;
            rotateY = 0;
          } else if (rtl) {
            rotateY = -rotateY;
          }
          $slideEl[0].style.zIndex =
            -Math.abs(Math.round(progress)) + slides.length;
          if (params.slideShadows) {
            createSlideShadows($slideEl, progress, params);
          }
          const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
          const $targetEl = effectTarget(params, $slideEl);
          $targetEl.transform(transform);
        }
      };
      const setTransition = (duration) => {
        const { transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl
          ? swiper.slides.find(transformEl)
          : swiper.slides;
        $transitionElements
          .transition(duration)
          .find(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          )
          .transition(duration);
        effectVirtualTransitionEnd({
          swiper,
          duration,
          transformEl,
        });
      };
      effectInit({
        effect: "flip",
        swiper,
        on,
        setTranslate,
        setTransition,
        recreateShadows,
        getEffectParams: () => swiper.params.flipEffect,
        perspective: () => true,
        overwriteParams: () => ({
          slidesPerView: 1,
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          spaceBetween: 0,
          virtualTranslate: !swiper.params.cssMode,
        }),
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/effect-coverflow/effect-coverflow.js
    function EffectCoverflow({ swiper, extendParams, on }) {
      extendParams({
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          scale: 1,
          modifier: 1,
          slideShadows: true,
          transformEl: null,
        },
      });
      const setTranslate = () => {
        const {
          width: swiperWidth,
          height: swiperHeight,
          slides,
          slidesSizesGrid,
        } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal
          ? -transform + swiperWidth / 2
          : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center

        for (let i = 0, length = slides.length; i < length; i += 1) {
          const $slideEl = slides.eq(i);
          const slideSize = slidesSizesGrid[i];
          const slideOffset = $slideEl[0].swiperSlideOffset;
          const centerOffset =
            (center - slideOffset - slideSize / 2) / slideSize;
          const offsetMultiplier =
            typeof params.modifier === "function"
              ? params.modifier(centerOffset)
              : centerOffset * params.modifier;
          let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
          let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

          let translateZ = -translate * Math.abs(offsetMultiplier);
          let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders

          if (typeof stretch === "string" && stretch.indexOf("%") !== -1) {
            stretch = (parseFloat(params.stretch) / 100) * slideSize;
          }
          let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
          let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
          let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values

          if (Math.abs(translateX) < 0.001) translateX = 0;
          if (Math.abs(translateY) < 0.001) translateY = 0;
          if (Math.abs(translateZ) < 0.001) translateZ = 0;
          if (Math.abs(rotateY) < 0.001) rotateY = 0;
          if (Math.abs(rotateX) < 0.001) rotateX = 0;
          if (Math.abs(scale) < 0.001) scale = 0;
          const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
          const $targetEl = effectTarget(params, $slideEl);
          $targetEl.transform(slideTransform);
          $slideEl[0].style.zIndex =
            -Math.abs(Math.round(offsetMultiplier)) + 1;
          if (params.slideShadows) {
            // Set shadows
            let $shadowBeforeEl = isHorizontal
              ? $slideEl.find(".swiper-slide-shadow-left")
              : $slideEl.find(".swiper-slide-shadow-top");
            let $shadowAfterEl = isHorizontal
              ? $slideEl.find(".swiper-slide-shadow-right")
              : $slideEl.find(".swiper-slide-shadow-bottom");
            if ($shadowBeforeEl.length === 0) {
              $shadowBeforeEl = createShadow(
                params,
                $slideEl,
                isHorizontal ? "left" : "top"
              );
            }
            if ($shadowAfterEl.length === 0) {
              $shadowAfterEl = createShadow(
                params,
                $slideEl,
                isHorizontal ? "right" : "bottom"
              );
            }
            if ($shadowBeforeEl.length)
              $shadowBeforeEl[0].style.opacity =
                offsetMultiplier > 0 ? offsetMultiplier : 0;
            if ($shadowAfterEl.length)
              $shadowAfterEl[0].style.opacity =
                -offsetMultiplier > 0 ? -offsetMultiplier : 0;
          }
        }
      };
      const setTransition = (duration) => {
        const { transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl
          ? swiper.slides.find(transformEl)
          : swiper.slides;
        $transitionElements
          .transition(duration)
          .find(
            ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
          )
          .transition(duration);
      };
      effectInit({
        effect: "coverflow",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: () => true,
        overwriteParams: () => ({
          watchSlidesProgress: true,
        }),
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/effect-creative/effect-creative.js
    function EffectCreative({ swiper, extendParams, on }) {
      extendParams({
        creativeEffect: {
          transformEl: null,
          limitProgress: 1,
          shadowPerProgress: false,
          progressMultiplier: 1,
          perspective: true,
          prev: {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            opacity: 1,
            scale: 1,
          },
          next: {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            opacity: 1,
            scale: 1,
          },
        },
      });
      const getTranslateValue = (value) => {
        if (typeof value === "string") return value;
        return `${value}px`;
      };
      const setTranslate = () => {
        const { slides, $wrapperEl, slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
          const margin =
            slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
          $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for (let i = 0; i < slides.length; i += 1) {
          const $slideEl = slides.eq(i);
          const slideProgress = $slideEl[0].progress;
          const progress = Math.min(
            Math.max($slideEl[0].progress, -params.limitProgress),
            params.limitProgress
          );
          let originalProgress = progress;
          if (!isCenteredSlides) {
            originalProgress = Math.min(
              Math.max($slideEl[0].originalProgress, -params.limitProgress),
              params.limitProgress
            );
          }
          const offset = $slideEl[0].swiperSlideOffset;
          const t = [
            swiper.params.cssMode ? -offset - swiper.translate : -offset,
            0,
            0,
          ];
          const r = [0, 0, 0];
          let custom = false;
          if (!swiper.isHorizontal()) {
            t[1] = t[0];
            t[0] = 0;
          }
          let data = {
            translate: [0, 0, 0],
            rotate: [0, 0, 0],
            scale: 1,
            opacity: 1,
          };
          if (progress < 0) {
            data = params.next;
            custom = true;
          } else if (progress > 0) {
            data = params.prev;
            custom = true;
          } // set translate

          t.forEach((value, index) => {
            t[index] = `calc(${value}px + (${getTranslateValue(
              data.translate[index]
            )} * ${Math.abs(progress * multiplier)}))`;
          }); // set rotates

          r.forEach((value, index) => {
            r[index] = data.rotate[index] * Math.abs(progress * multiplier);
          });
          $slideEl[0].style.zIndex =
            -Math.abs(Math.round(slideProgress)) + slides.length;
          const translateString = t.join(", ");
          const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
          const scaleString =
            originalProgress < 0
              ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})`
              : `scale(${1 - (1 - data.scale) * originalProgress * multiplier
              })`;
          const opacityString =
            originalProgress < 0
              ? 1 + (1 - data.opacity) * originalProgress * multiplier
              : 1 - (1 - data.opacity) * originalProgress * multiplier;
          const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows

          if ((custom && data.shadow) || !custom) {
            let $shadowEl = $slideEl.children(".swiper-slide-shadow");
            if ($shadowEl.length === 0 && data.shadow) {
              $shadowEl = createShadow(params, $slideEl);
            }
            if ($shadowEl.length) {
              const shadowOpacity = params.shadowPerProgress
                ? progress * (1 / params.limitProgress)
                : progress;
              $shadowEl[0].style.opacity = Math.min(
                Math.max(Math.abs(shadowOpacity), 0),
                1
              );
            }
          }
          const $targetEl = effectTarget(params, $slideEl);
          $targetEl.transform(transform).css({
            opacity: opacityString,
          });
          if (data.origin) {
            $targetEl.css("transform-origin", data.origin);
          }
        }
      };
      const setTransition = (duration) => {
        const { transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl
          ? swiper.slides.find(transformEl)
          : swiper.slides;
        $transitionElements
          .transition(duration)
          .find(".swiper-slide-shadow")
          .transition(duration);
        effectVirtualTransitionEnd({
          swiper,
          duration,
          transformEl,
          allSlides: true,
        });
      };
      effectInit({
        effect: "creative",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: () => swiper.params.creativeEffect.perspective,
        overwriteParams: () => ({
          watchSlidesProgress: true,
          virtualTranslate: !swiper.params.cssMode,
        }),
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/modules/effect-cards/effect-cards.js
    function EffectCards({ swiper, extendParams, on }) {
      extendParams({
        cardsEffect: {
          slideShadows: true,
          transformEl: null,
          rotate: true,
          perSlideRotate: 2,
          perSlideOffset: 8,
        },
      });
      const setTranslate = () => {
        const { slides, activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate, isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for (let i = 0; i < slides.length; i += 1) {
          const $slideEl = slides.eq(i);
          const slideProgress = $slideEl[0].progress;
          const progress = Math.min(Math.max(slideProgress, -4), 4);
          let offset = $slideEl[0].swiperSlideOffset;
          if (swiper.params.centeredSlides && !swiper.params.cssMode) {
            swiper.$wrapperEl.transform(
              `translateX(${swiper.minTranslate()}px)`
            );
          }
          if (swiper.params.centeredSlides && swiper.params.cssMode) {
            offset -= slides[0].swiperSlideOffset;
          }
          let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
          let tY = 0;
          const tZ = -100 * Math.abs(progress);
          let scale = 1;
          let rotate = -params.perSlideRotate * progress;
          let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
          const slideIndex =
            swiper.virtual && swiper.params.virtual.enabled
              ? swiper.virtual.from + i
              : i;
          const isSwipeToNext =
            (slideIndex === activeIndex || slideIndex === activeIndex - 1) &&
            progress > 0 &&
            progress < 1 &&
            (isTouched || swiper.params.cssMode) &&
            currentTranslate < startTranslate;
          const isSwipeToPrev =
            (slideIndex === activeIndex || slideIndex === activeIndex + 1) &&
            progress < 0 &&
            progress > -1 &&
            (isTouched || swiper.params.cssMode) &&
            currentTranslate > startTranslate;
          if (isSwipeToNext || isSwipeToPrev) {
            const subProgress =
              (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
            rotate += -28 * progress * subProgress;
            scale += -0.5 * subProgress;
            tXAdd += 96 * subProgress;
            tY = `${-25 * subProgress * Math.abs(progress)}%`;
          }
          if (progress < 0) {
            // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
          } else if (progress > 0) {
            // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
          } else {
            tX = `${tX}px`;
          }
          if (!swiper.isHorizontal()) {
            const prevY = tY;
            tY = tX;
            tX = prevY;
          }
          const scaleString =
            progress < 0
              ? `${1 + (1 - scale) * progress}`
              : `${1 - (1 - scale) * progress}`;
          const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
          if (params.slideShadows) {
            // Set shadows
            let $shadowEl = $slideEl.find(".swiper-slide-shadow");
            if ($shadowEl.length === 0) {
              $shadowEl = createShadow(params, $slideEl);
            }
            if ($shadowEl.length)
              $shadowEl[0].style.opacity = Math.min(
                Math.max((Math.abs(progress) - 0.5) / 0.5, 0),
                1
              );
          }
          $slideEl[0].style.zIndex =
            -Math.abs(Math.round(slideProgress)) + slides.length;
          const $targetEl = effectTarget(params, $slideEl);
          $targetEl.transform(transform);
        }
      };
      const setTransition = (duration) => {
        const { transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl
          ? swiper.slides.find(transformEl)
          : swiper.slides;
        $transitionElements
          .transition(duration)
          .find(".swiper-slide-shadow")
          .transition(duration);
        effectVirtualTransitionEnd({
          swiper,
          duration,
          transformEl,
        });
      };
      effectInit({
        effect: "cards",
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: () => true,
        overwriteParams: () => ({
          watchSlidesProgress: true,
          virtualTranslate: !swiper.params.cssMode,
        }),
      });
    } // CONCATENATED MODULE: ./node_modules/swiper/swiper.esm.js
    /**
     * Swiper 8.4.7
     * Most modern mobile touch slider and framework with hardware accelerated transitions
     * https://swiperjs.com
     *
     * Copyright 2014-2023 Vladimir Kharlampidi
     *
     * Released under the MIT License
     *
     * Released on: January 30, 2023
     */

    // EXTERNAL MODULE: ./node_modules/animate-loading/dist/main.js
    var main = __webpack_require__(367);
    var main_default = /*#__PURE__*/ __webpack_require__.n(main); // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
    function _typeof(o) {
      "@babel/helpers - typeof";

      return (
        (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (o) {
              return typeof o;
            }
            : function (o) {
              return o &&
                "function" == typeof Symbol &&
                o.constructor === Symbol &&
                o !== Symbol.prototype
                ? "symbol"
                : typeof o;
            }),
        _typeof(o)
      );
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js
    function _toPrimitive(input, hint) {
      if (_typeof(input) !== "object" || input === null) return input;
      var prim = input[Symbol.toPrimitive];
      if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (hint === "string" ? String : Number)(input);
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
    function _toPropertyKey(arg) {
      var key = _toPrimitive(arg, "string");
      return _typeof(key) === "symbol" ? key : String(key);
    } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
    function _defineProperty(obj, key, value) {
      key = _toPropertyKey(key);
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true,
        });
      } else {
        obj[key] = value;
      }
      return obj;
    } // CONCATENATED MODULE: ./src/js/utilities/accordion.js
    class Accordion {
      constructor(container, options = this.defaultOptions) {
        _defineProperty(this, "defaultOptions", {
          presetContentHeight: false,
          duration: 300,
          onload: false,
          callback: () => { },
        });
        _defineProperty(this, "selectors", {
          items: [".m-accordion--item"],
          buttons: [".m-accordion--item-button "],
          contents: [".m-accordion--item-content"],
        });
        _defineProperty(this, "openClass", "open");
        _defineProperty(this, "initClass", "acc-initialized");
        _defineProperty(this, "removeEvents", null);
        _defineProperty(this, "destroy", () => {
          this.removeEvents();
          window.removeEventListener("resize", this.debouncedSetContentHeight);
        });
        _defineProperty(this, "setContentOpacity", () => {
          this.domNodes.contents.forEach((cont) => (cont.style.opacity = 1));
        });
        _defineProperty(this, "setItemOverflowState", () => {
          this.domNodes &&
            this.domNodes.items &&
            this.domNodes.items.forEach((item) => {
              let content = item.querySelector(".m-accordion--item-content");
              const method =
                item && item.classList.contains(this.openClass)
                  ? "remove"
                  : "add";
              content && content.classList[method]("m:overflow-hidden");
            });
        });
        _defineProperty(this, "setContentHeight", () => {
          this.domNodes = queryDomNodes(this.selectors, this.container);
          const { items } = this.domNodes;
          items.forEach((item) => {
            const content =
              item && item.querySelector(".m-accordion--item-content");
            let allImageInContent = content && content.querySelectorAll("img");
            if (item && item.classList.contains(this.openClass)) {
              item.style.setProperty("--content-max-height", `auto`);
              const maxHeight = content && content.scrollHeight;
              item.style.setProperty("--content-max-height", `${maxHeight}px`);
              if (allImageInContent && allImageInContent.length > 0) {
                allImageInContent.forEach((img) => {
                  img.setAttribute("loading", "lazy");
                  img.setAttribute("width", img.width);
                  img.setAttribute("height", img.height);
                  if (
                    (img.src.indexOf("shopify.com") != -1 ||
                      img.src.indexOf("myshopify.com")) != -1 &&
                    img.src.indexOf("&width=") == -1
                  ) {
                    img.setAttribute(
                      "src",
                      `${img.src}&width=${img.width + 100}`
                    );
                  }
                });
              }
            } else {
              item && item.style.setProperty("--content-max-height", 0);
            }
            content && content.classList.add("max-height-set");
            if (!content) {
              const buttonIcon = item.querySelector(".m-accordion--item-icon");
              buttonIcon && buttonIcon.classList.add("m:hidden");
            }
          });
          this.setItemOverflowState();
          this.setContentOpacity();
        });
        _defineProperty(this, "toggle", (index) => {
          const accItem =
            this.domNodes && this.domNodes.items && this.domNodes.items[index];
          const accContent =
            accItem && accItem.querySelector(".m-accordion--item-content");
          const isOpen = accItem && accItem.classList.contains(this.openClass);
          let allImageInContent =
            accContent && accContent.querySelectorAll("img");
          accItem && accItem.classList.toggle(this.openClass);
          const maxHeight = isOpen ? 0 : accContent && accContent.scrollHeight;
          accContent &&
            accItem &&
            accItem.style.setProperty("--content-max-height", `${maxHeight}px`);
          if (allImageInContent && allImageInContent.length > 0) {
            allImageInContent.forEach((img) => {
              img.setAttribute("loading", "lazy");
              img.setAttribute("width", img.width);
              img.setAttribute("height", img.height);
              if (
                (img.src.indexOf("shopify.com") != -1 ||
                  img.src.indexOf("myshopify.com")) != -1 &&
                img.src.indexOf("&width=") == -1
              ) {
                img.setAttribute("src", `${img.src}&width=${img.width + 100}`);
              }
            });
          }
          if (isOpen) {
            accContent && accContent.classList.add("m:overflow-hidden");
            setTimeout(() => {
              accContent && accContent.style.removeProperty("opacity");
            }, 350);
          } else {
            accContent && accContent.style.setProperty("opacity", "1");
            setTimeout(() => {
              accContent && accContent.classList.remove("m:overflow-hidden");
            }, 350);
          }
        });
        if (!container || container.classList.contains(this.initClass)) return;
        this.container = container;
        this.domNodes = queryDomNodes(this.selectors, this.container);
        this.options = Object.assign({}, this.defaultOptions, options);
        this.debouncedSetContentHeight = debounce(
          this.setContentHeight.bind(this),
          300
        );
        this.init();
      }
      init() {
        this.container &&
          this.container.style.setProperty(
            "--duration",
            ` ${this.options.duration}ms`
          );
        this.removeEvents = addEventDelegate({
          context: this.container,
          selector: this.selectors.buttons[0],
          handler: (e, btn) => {
            btn.classList.add("m-according");
            const index = this.domNodes.buttons.indexOf(btn);
            this.toggle(index);
            setTimeout(() => {
              btn.classList.remove("m-according");
            }, 350);
          },
        });
        if (this.options.presetContentHeight) {
          if (this.options.onload) {
            window.addEventListener("load", () => {
              window.requestAnimationFrame(this.setContentHeight);
            });
          } else {
            window.requestAnimationFrame(this.setContentHeight);
          }
        } else {
          this.setItemOverflowState();
          this.setContentOpacity();
        }
        window.addEventListener("resize", this.debouncedSetContentHeight);
        if (typeof this.options.callback === "function")
          this.options.callback();
        this.container.classList.add(this.initClass);
      }
    } // CONCATENATED MODULE: ./src/js/components/Modal.jsx
    /* provided dependency */ var createElement = __webpack_require__(295)["Z"];
    function Modal_Modal() {
      return createElement(
        "div",
        {
          className: `m-modal m-modal--wrapper m:flex m:items-center m:justify-center`,
        },
        createElement(
          "div",
          {
            className: "m-modal--content",
          },
          createElement(
            "button",
            {
              className: "m-modal--close",
              "aria-label": "Close",
            },
            createElement(
              "svg",
              {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              createElement("path", {
                d: "M15.625 4.375L4.375 15.625",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              }),
              createElement("path", {
                d: "M15.625 15.625L4.375 4.375",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              })
            )
          ),
          createElement("div", {
            className: "m-modal--content-inner",
          })
        )
      );
    } // CONCATENATED MODULE: ./src/js/modules/modal.js
    /* provided dependency */ var modal_createElement =
      __webpack_require__(295)["Z"];

    // eslint-disable-next-line no-unused-vars

    class Modal {
      constructor() {
        var _this$modal, _this$modal2;
        _defineProperty(this, "init", () => {
          addEventDelegate({
            selector: ".m-modal--wrapper",
            handler: (e) => {
              var _e$target;
              if (
                (e === null || e === void 0 ? void 0 : e.target) ===
                this.modal ||
                (e !== null &&
                  e !== void 0 &&
                  (_e$target = e.target) !== null &&
                  _e$target !== void 0 &&
                  _e$target.closest(".m-modal--close"))
              ) {
                this.close(e);
              }
            },
          });
        });
        _defineProperty(this, "setSizes", (sizes = "") => {
          this.resetSize();
          this.sizes = sizes;
          sizes.split(" ").forEach((size) => {
            var _this$modalContent, _this$modalContent$cl;
            (_this$modalContent = this.modalContent) === null ||
              _this$modalContent === void 0
              ? void 0
              : (_this$modalContent$cl = _this$modalContent.classList) ===
                null || _this$modalContent$cl === void 0
                ? void 0
                : _this$modalContent$cl.add(size);
          });
        });
        _defineProperty(this, "setWidth", (width) => {
          this.modalContent.style.width = width;
        });
        _defineProperty(this, "resetSize", () => {
          if (this.sizes) {
            this.sizes.split(" ").forEach((size) => {
              var _this$modalContent2, _this$modalContent2$c;
              (_this$modalContent2 = this.modalContent) === null ||
                _this$modalContent2 === void 0
                ? void 0
                : (_this$modalContent2$c = _this$modalContent2.classList) ===
                  null || _this$modalContent2$c === void 0
                  ? void 0
                  : _this$modalContent2$c.remove(size);
            });
            this.sizes = "";
          }
        });
        _defineProperty(this, "appendChild", (child) => {
          var _this$modalContentInn;
          this === null || this === void 0
            ? void 0
            : (_this$modalContentInn = this.modalContentInner) === null ||
              _this$modalContentInn === void 0
              ? void 0
              : _this$modalContentInn.appendChild(child);
          this.children = child;
        });
        _defineProperty(this, "removeChild", () => {
          var _this$children;
          this === null || this === void 0
            ? void 0
            : (_this$children = this.children) === null ||
              _this$children === void 0
              ? void 0
              : _this$children.remove();
        });
        _defineProperty(this, "open", () => {
          // document.documentElement.classList.add('prevent-scroll')
          document.body.appendChild(this.modal);
          setTimeout(() => {
            this.modal.style.setProperty("--m-opacity", "1");
            this.modal.classList.add("m-open-modal");
          }, this.transitionDuration);
          window.addEventListener("keydown", this.handleKeyDown);
        });
        _defineProperty(this, "close", (e) => {
          if (e) e.preventDefault();
          this.modal.classList.remove("m-open-modal");
          this.modal.style.setProperty("--m-opacity", "0");
          window.removeEventListener("keydown", this.handleKeyDown);
          setTimeout(() => {
            this.modal.remove();
            this.removeChild();
            this.resetSize();
            this.modalContent.style.removeProperty("width");
            // document.documentElement.classList.remove('prevent-scroll')
          }, this.transitionDuration);
        });
        _defineProperty(this, "handleKeyDown", (e) => {
          // ESC
          if (e.keyCode === 27) {
            this.close();
          }
        });
        this.modal = modal_createElement(Modal_Modal, null);
        this.modalContent =
          (_this$modal = this.modal) === null || _this$modal === void 0
            ? void 0
            : _this$modal.querySelector(".m-modal--content");
        this.modalContentInner =
          (_this$modal2 = this.modal) === null || _this$modal2 === void 0
            ? void 0
            : _this$modal2.querySelector(".m-modal--content-inner");
        this.transitionDuration = 200;
        this.init();
      }
    }
    /* harmony default export */ const modal = Modal;
    // EXTERNAL MODULE: ./node_modules/scroll-into-view/scrollIntoView.js
    var scrollIntoView = __webpack_require__(643);
    var scrollIntoView_default =
      /*#__PURE__*/ __webpack_require__.n(scrollIntoView); // CONCATENATED MODULE: ./src/js/components/Notification.jsx
    /* provided dependency */ var Notification_createElement =
      __webpack_require__(295)["Z"];
    /* harmony default export */ function components_Notification({
        type,
        message,
        onclick,
        sticky,
      }) {
      let icon;
      if (type === "warning") {
        icon = Notification_createElement(
          "svg",
          {
            className: "m-svg-icon--large",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
          },
          Notification_createElement("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
          })
        );
      } else if (type === "success") {
        icon = Notification_createElement(
          "svg",
          {
            className: "m-svg-icon--large",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
          },
          Notification_createElement("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
          })
        );
      }
      return Notification_createElement(
        "div",
        {
          className: `notification ${type} ${sticky ? "notification--sticky" : null
            }`,
          onclick: onclick,
        },
        icon,
        Notification_createElement(
          "div",
          {
            className: `notification__text`,
          },
          message
        )
      );
    } // CONCATENATED MODULE: ./src/js/modules/notification.js
    /* provided dependency */ var notification_createElement =
      __webpack_require__(295)["Z"];

    // eslint-disable-next-line no-unused-vars

    class Notification {
      constructor() {
        _defineProperty(this, "noti", null);
        _defineProperty(this, "removeTimeoutId", null);
        _defineProperty(this, "hideTimeoutId", null);
        _defineProperty(this, "transitionDuration", 300);
        _defineProperty(
          this,
          "show",
          ({
            target,
            type,
            message,
            method = "after",
            last = 3000,
            delay = 0,
            debug = false,
            sticky = false,
          }) => {
            this.clearTimeout();
            this.removeNoti();
            setTimeout(() => {
              this.noti = notification_createElement(components_Notification, {
                type: type,
                message: message,
                onclick: this.handleClick,
                sticky: sticky,
              });
              target === null || target === void 0
                ? void 0
                : target[method](this.noti);
              requestAnimationFrame(() => this.noti.classList.add("show"));
              if (!debug) {
                this.hideTimeoutId = setTimeout(() => {
                  this.noti.classList.add("hide");
                  this.removeTimeoutId = setTimeout(
                    this.removeNoti,
                    this.transitionDuration * 2
                  );
                }, last);
              }
            }, delay);
          }
        );
        _defineProperty(this, "handleClick", () => {
          clearTimeout(this.removeTimeoutId);
          this.noti.classList.add("hide");
          setTimeout(this.removeNoti, this.transitionDuration * 2);
        });
        _defineProperty(this, "clearTimeout", () => {
          clearTimeout(this.removeTimeoutId);
          clearTimeout(this.hideTimeoutId);
        });
        _defineProperty(this, "removeNoti", () => {
          var _this$noti;
          this === null || this === void 0
            ? void 0
            : (_this$noti = this.noti) === null || _this$noti === void 0
              ? void 0
              : _this$noti.remove();
        });
      }
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
    function getWindow_getWindow(node) {
      if (node == null) {
        return window;
      }
      if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
      }
      return node;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
    function isElement(node) {
      var OwnElement = getWindow_getWindow(node).Element;
      return node instanceof OwnElement || node instanceof Element;
    }
    function isHTMLElement(node) {
      var OwnElement = getWindow_getWindow(node).HTMLElement;
      return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function isShadowRoot(node) {
      // IE 11 has no ShadowRoot
      if (typeof ShadowRoot === "undefined") {
        return false;
      }
      var OwnElement = getWindow_getWindow(node).ShadowRoot;
      return node instanceof OwnElement || node instanceof ShadowRoot;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js

    var math_max = Math.max;
    var math_min = Math.min;
    var round = Math.round; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/userAgent.js
    function getUAString() {
      var uaData = navigator.userAgentData;
      if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
        return uaData.brands
          .map(function (item) {
            return item.brand + "/" + item.version;
          })
          .join(" ");
      }
      return navigator.userAgent;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
    function isLayoutViewport() {
      return !/^((?!chrome|android).)*safari/i.test(getUAString());
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
    function getBoundingClientRect(element, includeScale, isFixedStrategy) {
      if (includeScale === void 0) {
        includeScale = false;
      }
      if (isFixedStrategy === void 0) {
        isFixedStrategy = false;
      }
      var clientRect = element.getBoundingClientRect();
      var scaleX = 1;
      var scaleY = 1;
      if (includeScale && isHTMLElement(element)) {
        scaleX =
          element.offsetWidth > 0
            ? round(clientRect.width) / element.offsetWidth || 1
            : 1;
        scaleY =
          element.offsetHeight > 0
            ? round(clientRect.height) / element.offsetHeight || 1
            : 1;
      }
      var _ref = isElement(element) ? getWindow_getWindow(element) : window,
        visualViewport = _ref.visualViewport;
      var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
      var x =
        (clientRect.left +
          (addVisualOffsets && visualViewport
            ? visualViewport.offsetLeft
            : 0)) /
        scaleX;
      var y =
        (clientRect.top +
          (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) /
        scaleY;
      var width = clientRect.width / scaleX;
      var height = clientRect.height / scaleY;
      return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y,
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
    function getWindowScroll(node) {
      var win = getWindow_getWindow(node);
      var scrollLeft = win.pageXOffset;
      var scrollTop = win.pageYOffset;
      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
    function getHTMLElementScroll(element) {
      return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop,
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
    function getNodeScroll(node) {
      if (node === getWindow_getWindow(node) || !isHTMLElement(node)) {
        return getWindowScroll(node);
      } else {
        return getHTMLElementScroll(node);
      }
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
    function getNodeName(element) {
      return element ? (element.nodeName || "").toLowerCase() : null;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
    function getDocumentElement(element) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return (
        (isElement(element)
          ? element.ownerDocument
          : // $FlowFixMe[prop-missing]
          element.document) || window.document
      ).documentElement;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
    function getWindowScrollBarX(element) {
      // If <html> has a CSS width greater than the viewport, then this will be
      // incorrect for RTL.
      // Popper 1 is broken in this case and never had a bug report so let's assume
      // it's not an issue. I don't think anyone ever specifies width on <html>
      // anyway.
      // Browsers where the left scrollbar doesn't cause an issue report `0` for
      // this (e.g. Edge 2019, IE11, Safari)
      return (
        getBoundingClientRect(getDocumentElement(element)).left +
        getWindowScroll(element).scrollLeft
      );
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
    function getComputedStyle_getComputedStyle(element) {
      return getWindow_getWindow(element).getComputedStyle(element);
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
    function isScrollParent(element) {
      // Firefox wants us to check `-x` and `-y` variations as well
      var _getComputedStyle = getComputedStyle_getComputedStyle(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;
      return /auto|scroll|overlay|hidden/.test(
        overflow + overflowY + overflowX
      );
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
    function isElementScaled(element) {
      var rect = element.getBoundingClientRect();
      var scaleX = round(rect.width) / element.offsetWidth || 1;
      var scaleY = round(rect.height) / element.offsetHeight || 1;
      return scaleX !== 1 || scaleY !== 1;
    } // Returns the composite rect of an element relative to its offsetParent.
    // Composite means it takes into account transforms as well as layout.

    function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
      if (isFixed === void 0) {
        isFixed = false;
      }
      var isOffsetParentAnElement = isHTMLElement(offsetParent);
      var offsetParentIsScaled =
        isHTMLElement(offsetParent) && isElementScaled(offsetParent);
      var documentElement = getDocumentElement(offsetParent);
      var rect = getBoundingClientRect(
        elementOrVirtualElement,
        offsetParentIsScaled,
        isFixed
      );
      var scroll = {
        scrollLeft: 0,
        scrollTop: 0,
      };
      var offsets = {
        x: 0,
        y: 0,
      };
      if (isOffsetParentAnElement || (!isOffsetParentAnElement && !isFixed)) {
        if (
          getNodeName(offsetParent) !== "body" ||
          // https://github.com/popperjs/popper-core/issues/1078
          isScrollParent(documentElement)
        ) {
          scroll = getNodeScroll(offsetParent);
        }
        if (isHTMLElement(offsetParent)) {
          offsets = getBoundingClientRect(offsetParent, true);
          offsets.x += offsetParent.clientLeft;
          offsets.y += offsetParent.clientTop;
        } else if (documentElement) {
          offsets.x = getWindowScrollBarX(documentElement);
        }
      }
      return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height,
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
    // Returns the layout rect of an element relative to its offsetParent. Layout
    // means it doesn't take into account transforms.

    function getLayoutRect(element) {
      var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
      // Fixes https://github.com/popperjs/popper-core/issues/1223

      var width = element.offsetWidth;
      var height = element.offsetHeight;
      if (Math.abs(clientRect.width - width) <= 1) {
        width = clientRect.width;
      }
      if (Math.abs(clientRect.height - height) <= 1) {
        height = clientRect.height;
      }
      return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height,
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
    function getParentNode(element) {
      if (getNodeName(element) === "html") {
        return element;
      }
      return (
        // this is a quicker (but less type safe) way to save quite some bytes from the bundle
        // $FlowFixMe[incompatible-return]
        // $FlowFixMe[prop-missing]
        element.assignedSlot ||
        // step into the shadow DOM of the parent of a slotted node
        element.parentNode ||
        // DOM Element detected
        (isShadowRoot(element) ? element.host : null) ||
        // ShadowRoot detected
        // $FlowFixMe[incompatible-call]: HTMLElement is a Node
        getDocumentElement(element) // fallback
      );
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
    function getScrollParent(node) {
      if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
        // $FlowFixMe[incompatible-return]: assume body is always available
        return node.ownerDocument.body;
      }
      if (isHTMLElement(node) && isScrollParent(node)) {
        return node;
      }
      return getScrollParent(getParentNode(node));
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
    /*
    given a DOM element, return the list of all scroll parents, up the list of ancesors
    until we get to the top window object. This list is what we attach scroll listeners
    to, because if any of these parent elements scroll, we'll need to re-calculate the
    reference element's position.
    */

    function listScrollParents(element, list) {
      var _element$ownerDocumen;
      if (list === void 0) {
        list = [];
      }
      var scrollParent = getScrollParent(element);
      var isBody =
        scrollParent ===
        ((_element$ownerDocumen = element.ownerDocument) == null
          ? void 0
          : _element$ownerDocumen.body);
      var win = getWindow_getWindow(scrollParent);
      var target = isBody
        ? [win].concat(
          win.visualViewport || [],
          isScrollParent(scrollParent) ? scrollParent : []
        )
        : scrollParent;
      var updatedList = list.concat(target);
      return isBody
        ? updatedList
        : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
        updatedList.concat(listScrollParents(getParentNode(target)));
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
    function isTableElement(element) {
      return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
    function getTrueOffsetParent(element) {
      if (
        !isHTMLElement(element) ||
        // https://github.com/popperjs/popper-core/issues/837
        getComputedStyle_getComputedStyle(element).position === "fixed"
      ) {
        return null;
      }
      return element.offsetParent;
    } // `.offsetParent` reports `null` for fixed elements, while absolute elements
    // return the containing block

    function getContainingBlock(element) {
      var isFirefox = /firefox/i.test(getUAString());
      var isIE = /Trident/i.test(getUAString());
      if (isIE && isHTMLElement(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = getComputedStyle_getComputedStyle(element);
        if (elementCss.position === "fixed") {
          return null;
        }
      }
      var currentNode = getParentNode(element);
      if (isShadowRoot(currentNode)) {
        currentNode = currentNode.host;
      }
      while (
        isHTMLElement(currentNode) &&
        ["html", "body"].indexOf(getNodeName(currentNode)) < 0
      ) {
        var css = getComputedStyle_getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

        if (
          css.transform !== "none" ||
          css.perspective !== "none" ||
          css.contain === "paint" ||
          ["transform", "perspective"].indexOf(css.willChange) !== -1 ||
          (isFirefox && css.willChange === "filter") ||
          (isFirefox && css.filter && css.filter !== "none")
        ) {
          return currentNode;
        } else {
          currentNode = currentNode.parentNode;
        }
      }
      return null;
    } // Gets the closest ancestor positioned element. Handles some edge cases,
    // such as table ancestors and cross browser bugs.

    function getOffsetParent(element) {
      var window = getWindow_getWindow(element);
      var offsetParent = getTrueOffsetParent(element);
      while (
        offsetParent &&
        isTableElement(offsetParent) &&
        getComputedStyle_getComputedStyle(offsetParent).position === "static"
      ) {
        offsetParent = getTrueOffsetParent(offsetParent);
      }
      if (
        offsetParent &&
        (getNodeName(offsetParent) === "html" ||
          (getNodeName(offsetParent) === "body" &&
            getComputedStyle_getComputedStyle(offsetParent).position ===
            "static"))
      ) {
        return window;
      }
      return offsetParent || getContainingBlock(element) || window;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
    var enums_top = "top";
    var bottom = "bottom";
    var right = "right";
    var left = "left";
    var auto = "auto";
    var basePlacements = [enums_top, bottom, right, left];
    var start = "start";
    var end = "end";
    var clippingParents = "clippingParents";
    var viewport = "viewport";
    var popper = "popper";
    var reference = "reference";
    var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function (
      acc,
      placement
    ) {
      return acc.concat([placement + "-" + start, placement + "-" + end]);
    },
      []);
    var enums_placements = /*#__PURE__*/[]
      .concat(basePlacements, [auto])
      .reduce(function (acc, placement) {
        return acc.concat([
          placement,
          placement + "-" + start,
          placement + "-" + end,
        ]);
      }, []); // modifiers that need to read the DOM

    var beforeRead = "beforeRead";
    var read = "read";
    var afterRead = "afterRead"; // pure-logic modifiers

    var beforeMain = "beforeMain";
    var enums_main = "main";
    var afterMain = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)

    var beforeWrite = "beforeWrite";
    var write = "write";
    var afterWrite = "afterWrite";
    var modifierPhases = [
      beforeRead,
      read,
      afterRead,
      beforeMain,
      enums_main,
      afterMain,
      beforeWrite,
      write,
      afterWrite,
    ]; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
    // source: https://stackoverflow.com/questions/49875255

    function order(modifiers) {
      var map = new Map();
      var visited = new Set();
      var result = [];
      modifiers.forEach(function (modifier) {
        map.set(modifier.name, modifier);
      }); // On visiting object, check for its dependencies and visit them recursively

      function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(
          modifier.requires || [],
          modifier.requiresIfExists || []
        );
        requires.forEach(function (dep) {
          if (!visited.has(dep)) {
            var depModifier = map.get(dep);
            if (depModifier) {
              sort(depModifier);
            }
          }
        });
        result.push(modifier);
      }
      modifiers.forEach(function (modifier) {
        if (!visited.has(modifier.name)) {
          // check for visited object
          sort(modifier);
        }
      });
      return result;
    }
    function orderModifiers(modifiers) {
      // order based on dependencies
      var orderedModifiers = order(modifiers); // order based on phase

      return modifierPhases.reduce(function (acc, phase) {
        return acc.concat(
          orderedModifiers.filter(function (modifier) {
            return modifier.phase === phase;
          })
        );
      }, []);
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
    function debounce_debounce(fn) {
      var pending;
      return function () {
        if (!pending) {
          pending = new Promise(function (resolve) {
            Promise.resolve().then(function () {
              pending = undefined;
              resolve(fn());
            });
          });
        }
        return pending;
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
    function mergeByName(modifiers) {
      var merged = modifiers.reduce(function (merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing
          ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data),
          })
          : current;
        return merged;
      }, {}); // IE11 does not support Object.values

      return Object.keys(merged).map(function (key) {
        return merged[key];
      });
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js
    var DEFAULT_OPTIONS = {
      placement: "bottom",
      modifiers: [],
      strategy: "absolute",
    };
    function areValidElements() {
      for (
        var _len = arguments.length, args = new Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }
      return !args.some(function (element) {
        return !(
          element && typeof element.getBoundingClientRect === "function"
        );
      });
    }
    function popperGenerator(generatorOptions) {
      if (generatorOptions === void 0) {
        generatorOptions = {};
      }
      var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers =
          _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions =
          _generatorOptions$def2 === void 0
            ? DEFAULT_OPTIONS
            : _generatorOptions$def2;
      return function createPopper(reference, popper, options) {
        if (options === void 0) {
          options = defaultOptions;
        }
        var state = {
          placement: "bottom",
          orderedModifiers: [],
          options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
          modifiersData: {},
          elements: {
            reference: reference,
            popper: popper,
          },
          attributes: {},
          styles: {},
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
          state: state,
          setOptions: function setOptions(setOptionsAction) {
            var options =
              typeof setOptionsAction === "function"
                ? setOptionsAction(state.options)
                : setOptionsAction;
            cleanupModifierEffects();
            state.options = Object.assign(
              {},
              defaultOptions,
              state.options,
              options
            );
            state.scrollParents = {
              reference: isElement(reference)
                ? listScrollParents(reference)
                : reference.contextElement
                  ? listScrollParents(reference.contextElement)
                  : [],
              popper: listScrollParents(popper),
            }; // Orders the modifiers based on their dependencies and `phase`
            // properties

            var orderedModifiers = orderModifiers(
              mergeByName([].concat(defaultModifiers, state.options.modifiers))
            ); // Strip out disabled modifiers

            state.orderedModifiers = orderedModifiers.filter(function (m) {
              return m.enabled;
            });
            runModifierEffects();
            return instance.update();
          },
          // Sync update – it will always be executed, even if not necessary. This
          // is useful for low frequency updates where sync behavior simplifies the
          // logic.
          // For high frequency updates (e.g. `resize` and `scroll` events), always
          // prefer the async Popper#update method
          forceUpdate: function forceUpdate() {
            if (isDestroyed) {
              return;
            }
            var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
            // anymore

            if (!areValidElements(reference, popper)) {
              return;
            } // Store the reference and popper rects to be read by modifiers

            state.rects = {
              reference: getCompositeRect(
                reference,
                getOffsetParent(popper),
                state.options.strategy === "fixed"
              ),
              popper: getLayoutRect(popper),
            }; // Modifiers have the ability to reset the current update cycle. The
            // most common use case for this is the `flip` modifier changing the
            // placement, which then needs to re-run all the modifiers, because the
            // logic was previously ran for the previous placement and is therefore
            // stale/incorrect

            state.reset = false;
            state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
            // is filled with the initial data specified by the modifier. This means
            // it doesn't persist and is fresh on each update.
            // To ensure persistent data, use `${name}#persistent`

            state.orderedModifiers.forEach(function (modifier) {
              return (state.modifiersData[modifier.name] = Object.assign(
                {},
                modifier.data
              ));
            });
            for (
              var index = 0;
              index < state.orderedModifiers.length;
              index++
            ) {
              if (state.reset === true) {
                state.reset = false;
                index = -1;
                continue;
              }
              var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options =
                  _state$orderedModifie2 === void 0
                    ? {}
                    : _state$orderedModifie2,
                name = _state$orderedModifie.name;
              if (typeof fn === "function") {
                state =
                  fn({
                    state: state,
                    options: _options,
                    name: name,
                    instance: instance,
                  }) || state;
              }
            }
          },
          // Async and optimistically optimized update – it will not be executed if
          // not necessary (debounced to run at most once-per-tick)
          update: debounce_debounce(function () {
            return new Promise(function (resolve) {
              instance.forceUpdate();
              resolve(state);
            });
          }),
          destroy: function destroy() {
            cleanupModifierEffects();
            isDestroyed = true;
          },
        };
        if (!areValidElements(reference, popper)) {
          return instance;
        }
        instance.setOptions(options).then(function (state) {
          if (!isDestroyed && options.onFirstUpdate) {
            options.onFirstUpdate(state);
          }
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.

        function runModifierEffects() {
          state.orderedModifiers.forEach(function (_ref) {
            var name = _ref.name,
              _ref$options = _ref.options,
              options = _ref$options === void 0 ? {} : _ref$options,
              effect = _ref.effect;
            if (typeof effect === "function") {
              var cleanupFn = effect({
                state: state,
                name: name,
                instance: instance,
                options: options,
              });
              var noopFn = function noopFn() { };
              effectCleanupFns.push(cleanupFn || noopFn);
            }
          });
        }
        function cleanupModifierEffects() {
          effectCleanupFns.forEach(function (fn) {
            return fn();
          });
          effectCleanupFns = [];
        }
        return instance;
      };
    }
    var createPopper =
      /*#__PURE__*/ /* unused pure expression or super */ null &&
      popperGenerator(); // eslint-disable-next-line import/no-unused-modules // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js

    // eslint-disable-next-line import/no-unused-modules

    var passive = {
      passive: true,
    };
    function effect(_ref) {
      var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
      var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
      var window = getWindow_getWindow(state.elements.popper);
      var scrollParents = [].concat(
        state.scrollParents.reference,
        state.scrollParents.popper
      );
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.addEventListener("scroll", instance.update, passive);
        });
      }
      if (resize) {
        window.addEventListener("resize", instance.update, passive);
      }
      return function () {
        if (scroll) {
          scrollParents.forEach(function (scrollParent) {
            scrollParent.removeEventListener(
              "scroll",
              instance.update,
              passive
            );
          });
        }
        if (resize) {
          window.removeEventListener("resize", instance.update, passive);
        }
      };
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const eventListeners = {
      name: "eventListeners",
      enabled: true,
      phase: "write",
      fn: function fn() { },
      effect: effect,
      data: {},
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js
    function getBasePlacement(placement) {
      return placement.split("-")[0];
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
    function getVariation(placement) {
      return placement.split("-")[1];
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
    function getMainAxisFromPlacement(placement) {
      return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js
    function computeOffsets(_ref) {
      var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
      var basePlacement = placement ? getBasePlacement(placement) : null;
      var variation = placement ? getVariation(placement) : null;
      var commonX = reference.x + reference.width / 2 - element.width / 2;
      var commonY = reference.y + reference.height / 2 - element.height / 2;
      var offsets;
      switch (basePlacement) {
        case enums_top:
          offsets = {
            x: commonX,
            y: reference.y - element.height,
          };
          break;
        case bottom:
          offsets = {
            x: commonX,
            y: reference.y + reference.height,
          };
          break;
        case right:
          offsets = {
            x: reference.x + reference.width,
            y: commonY,
          };
          break;
        case left:
          offsets = {
            x: reference.x - element.width,
            y: commonY,
          };
          break;
        default:
          offsets = {
            x: reference.x,
            y: reference.y,
          };
      }
      var mainAxis = basePlacement
        ? getMainAxisFromPlacement(basePlacement)
        : null;
      if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch (variation) {
          case start:
            offsets[mainAxis] =
              offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
            break;
          case end:
            offsets[mainAxis] =
              offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
            break;
          default:
        }
      }
      return offsets;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
    function popperOffsets(_ref) {
      var state = _ref.state,
        name = _ref.name;
      // Offsets are the actual position the popper needs to have to be
      // properly positioned near its reference element
      // This is the most basic placement, and will be adjusted by
      // the modifiers in the next step
      state.modifiersData[name] = computeOffsets({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement,
      });
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const modifiers_popperOffsets = {
      name: "popperOffsets",
      enabled: true,
      phase: "read",
      fn: popperOffsets,
      data: {},
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js
    // eslint-disable-next-line import/no-unused-modules

    var unsetSides = {
      top: "auto",
      right: "auto",
      bottom: "auto",
      left: "auto",
    }; // Round the offsets to the nearest suitable subpixel based on the DPR.
    // Zooming can change the DPR, but it seems to report a value that will
    // cleanly divide the values into the appropriate subpixels.

    function roundOffsetsByDPR(_ref, win) {
      var x = _ref.x,
        y = _ref.y;
      var dpr = win.devicePixelRatio || 1;
      return {
        x: round(x * dpr) / dpr || 0,
        y: round(y * dpr) / dpr || 0,
      };
    }
    function mapToStyles(_ref2) {
      var _Object$assign2;
      var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets,
        isFixed = _ref2.isFixed;
      var _offsets$x = offsets.x,
        x = _offsets$x === void 0 ? 0 : _offsets$x,
        _offsets$y = offsets.y,
        y = _offsets$y === void 0 ? 0 : _offsets$y;
      var _ref3 =
        typeof roundOffsets === "function"
          ? roundOffsets({
            x: x,
            y: y,
          })
          : {
            x: x,
            y: y,
          };
      x = _ref3.x;
      y = _ref3.y;
      var hasX = offsets.hasOwnProperty("x");
      var hasY = offsets.hasOwnProperty("y");
      var sideX = left;
      var sideY = enums_top;
      var win = window;
      if (adaptive) {
        var offsetParent = getOffsetParent(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === getWindow_getWindow(popper)) {
          offsetParent = getDocumentElement(popper);
          if (
            getComputedStyle_getComputedStyle(offsetParent).position !==
            "static" &&
            position === "absolute"
          ) {
            heightProp = "scrollHeight";
            widthProp = "scrollWidth";
          }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

        offsetParent = offsetParent;
        if (
          placement === enums_top ||
          ((placement === left || placement === right) && variation === end)
        ) {
          sideY = bottom;
          var offsetY =
            isFixed && offsetParent === win && win.visualViewport
              ? win.visualViewport.height
              : // $FlowFixMe[prop-missing]
              offsetParent[heightProp];
          y -= offsetY - popperRect.height;
          y *= gpuAcceleration ? 1 : -1;
        }
        if (
          placement === left ||
          ((placement === enums_top || placement === bottom) &&
            variation === end)
        ) {
          sideX = right;
          var offsetX =
            isFixed && offsetParent === win && win.visualViewport
              ? win.visualViewport.width
              : // $FlowFixMe[prop-missing]
              offsetParent[widthProp];
          x -= offsetX - popperRect.width;
          x *= gpuAcceleration ? 1 : -1;
        }
      }
      var commonStyles = Object.assign(
        {
          position: position,
        },
        adaptive && unsetSides
      );
      var _ref4 =
        roundOffsets === true
          ? roundOffsetsByDPR(
            {
              x: x,
              y: y,
            },
            getWindow_getWindow(popper)
          )
          : {
            x: x,
            y: y,
          };
      x = _ref4.x;
      y = _ref4.y;
      if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign(
          {},
          commonStyles,
          ((_Object$assign = {}),
            (_Object$assign[sideY] = hasY ? "0" : ""),
            (_Object$assign[sideX] = hasX ? "0" : ""),
            (_Object$assign.transform =
              (win.devicePixelRatio || 1) <= 1
                ? "translate(" + x + "px, " + y + "px)"
                : "translate3d(" + x + "px, " + y + "px, 0)"),
            _Object$assign)
        );
      }
      return Object.assign(
        {},
        commonStyles,
        ((_Object$assign2 = {}),
          (_Object$assign2[sideY] = hasY ? y + "px" : ""),
          (_Object$assign2[sideX] = hasX ? x + "px" : ""),
          (_Object$assign2.transform = ""),
          _Object$assign2)
      );
    }
    function computeStyles(_ref5) {
      var state = _ref5.state,
        options = _ref5.options;
      var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration =
          _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets =
          _options$roundOffsets === void 0 ? true : _options$roundOffsets;
      var commonStyles = {
        placement: getBasePlacement(state.placement),
        variation: getVariation(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed",
      };
      if (state.modifiersData.popperOffsets != null) {
        state.styles.popper = Object.assign(
          {},
          state.styles.popper,
          mapToStyles(
            Object.assign({}, commonStyles, {
              offsets: state.modifiersData.popperOffsets,
              position: state.options.strategy,
              adaptive: adaptive,
              roundOffsets: roundOffsets,
            })
          )
        );
      }
      if (state.modifiersData.arrow != null) {
        state.styles.arrow = Object.assign(
          {},
          state.styles.arrow,
          mapToStyles(
            Object.assign({}, commonStyles, {
              offsets: state.modifiersData.arrow,
              position: "absolute",
              adaptive: false,
              roundOffsets: roundOffsets,
            })
          )
        );
      }
      state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement,
      });
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const modifiers_computeStyles = {
      name: "computeStyles",
      enabled: true,
      phase: "beforeWrite",
      fn: computeStyles,
      data: {},
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js
    // This modifier takes the styles prepared by the `computeStyles` modifier
    // and applies them to the HTMLElements such as popper and arrow

    function applyStyles(_ref) {
      var state = _ref.state;
      Object.keys(state.elements).forEach(function (name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        } // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (name) {
          var value = attributes[name];
          if (value === false) {
            element.removeAttribute(name);
          } else {
            element.setAttribute(name, value === true ? "" : value);
          }
        });
      });
    }
    function applyStyles_effect(_ref2) {
      var state = _ref2.state;
      var initialStyles = {
        popper: {
          position: state.options.strategy,
          left: "0",
          top: "0",
          margin: "0",
        },
        arrow: {
          position: "absolute",
        },
        reference: {},
      };
      Object.assign(state.elements.popper.style, initialStyles.popper);
      state.styles = initialStyles;
      if (state.elements.arrow) {
        Object.assign(state.elements.arrow.style, initialStyles.arrow);
      }
      return function () {
        Object.keys(state.elements).forEach(function (name) {
          var element = state.elements[name];
          var attributes = state.attributes[name] || {};
          var styleProperties = Object.keys(
            state.styles.hasOwnProperty(name)
              ? state.styles[name]
              : initialStyles[name]
          ); // Set all values to an empty string to unset them

          var style = styleProperties.reduce(function (style, property) {
            style[property] = "";
            return style;
          }, {}); // arrow is optional + virtual elements

          if (!isHTMLElement(element) || !getNodeName(element)) {
            return;
          }
          Object.assign(element.style, style);
          Object.keys(attributes).forEach(function (attribute) {
            element.removeAttribute(attribute);
          });
        });
      };
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const modifiers_applyStyles = {
      name: "applyStyles",
      enabled: true,
      phase: "write",
      fn: applyStyles,
      effect: applyStyles_effect,
      requires: ["computeStyles"],
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js
    // eslint-disable-next-line import/no-unused-modules

    function distanceAndSkiddingToXY(placement, rects, offset) {
      var basePlacement = getBasePlacement(placement);
      var invertDistance =
        [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;
      var _ref =
        typeof offset === "function"
          ? offset(
            Object.assign({}, rects, {
              placement: placement,
            })
          )
          : offset,
        skidding = _ref[0],
        distance = _ref[1];
      skidding = skidding || 0;
      distance = (distance || 0) * invertDistance;
      return [left, right].indexOf(basePlacement) >= 0
        ? {
          x: distance,
          y: skidding,
        }
        : {
          x: skidding,
          y: distance,
        };
    }
    function offset_offset(_ref2) {
      var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
      var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
      var data = enums_placements.reduce(function (acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(
          placement,
          state.rects,
          offset
        );
        return acc;
      }, {});
      var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;
      if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
      }
      state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const modifiers_offset = {
      name: "offset",
      enabled: true,
      phase: "main",
      requires: ["popperOffsets"],
      fn: offset_offset,
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
    var hash = {
      left: "right",
      right: "left",
      bottom: "top",
      top: "bottom",
    };
    function getOppositePlacement(placement) {
      return placement.replace(/left|right|bottom|top/g, function (matched) {
        return hash[matched];
      });
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
    var getOppositeVariationPlacement_hash = {
      start: "end",
      end: "start",
    };
    function getOppositeVariationPlacement(placement) {
      return placement.replace(/start|end/g, function (matched) {
        return getOppositeVariationPlacement_hash[matched];
      });
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js
    function getViewportRect(element, strategy) {
      var win = getWindow_getWindow(element);
      var html = getDocumentElement(element);
      var visualViewport = win.visualViewport;
      var width = html.clientWidth;
      var height = html.clientHeight;
      var x = 0;
      var y = 0;
      if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = isLayoutViewport();
        if (layoutViewport || (!layoutViewport && strategy === "fixed")) {
          x = visualViewport.offsetLeft;
          y = visualViewport.offsetTop;
        }
      }
      return {
        width: width,
        height: height,
        x: x + getWindowScrollBarX(element),
        y: y,
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js
    // Gets the entire size of the scrollable document area, even extending outside
    // of the `<html>` and `<body>` rect bounds if horizontally scrollable

    function getDocumentRect(element) {
      var _element$ownerDocumen;
      var html = getDocumentElement(element);
      var winScroll = getWindowScroll(element);
      var body =
        (_element$ownerDocumen = element.ownerDocument) == null
          ? void 0
          : _element$ownerDocumen.body;
      var width = math_max(
        html.scrollWidth,
        html.clientWidth,
        body ? body.scrollWidth : 0,
        body ? body.clientWidth : 0
      );
      var height = math_max(
        html.scrollHeight,
        html.clientHeight,
        body ? body.scrollHeight : 0,
        body ? body.clientHeight : 0
      );
      var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
      var y = -winScroll.scrollTop;
      if (getComputedStyle_getComputedStyle(body || html).direction === "rtl") {
        x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
      }
      return {
        width: width,
        height: height,
        x: x,
        y: y,
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js
    function contains(parent, child) {
      var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

      if (parent.contains(child)) {
        return true;
      } // then fallback to custom implementation with Shadow DOM support
      else if (rootNode && isShadowRoot(rootNode)) {
        var next = child;
        do {
          if (next && parent.isSameNode(next)) {
            return true;
          } // $FlowFixMe[prop-missing]: need a better way to handle this...

          next = next.parentNode || next.host;
        } while (next);
      } // Give up, the result is false

      return false;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
    function rectToClientRect(rect) {
      return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height,
      });
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
    function getInnerBoundingClientRect(element, strategy) {
      var rect = getBoundingClientRect(element, false, strategy === "fixed");
      rect.top = rect.top + element.clientTop;
      rect.left = rect.left + element.clientLeft;
      rect.bottom = rect.top + element.clientHeight;
      rect.right = rect.left + element.clientWidth;
      rect.width = element.clientWidth;
      rect.height = element.clientHeight;
      rect.x = rect.left;
      rect.y = rect.top;
      return rect;
    }
    function getClientRectFromMixedType(element, clippingParent, strategy) {
      return clippingParent === viewport
        ? rectToClientRect(getViewportRect(element, strategy))
        : isElement(clippingParent)
          ? getInnerBoundingClientRect(clippingParent, strategy)
          : rectToClientRect(getDocumentRect(getDocumentElement(element)));
    } // A "clipping parent" is an overflowable container with the characteristic of
    // clipping (or hiding) overflowing elements with a position different from
    // `initial`

    function getClippingParents(element) {
      var clippingParents = listScrollParents(getParentNode(element));
      var canEscapeClipping =
        ["absolute", "fixed"].indexOf(
          getComputedStyle_getComputedStyle(element).position
        ) >= 0;
      var clipperElement =
        canEscapeClipping && isHTMLElement(element)
          ? getOffsetParent(element)
          : element;
      if (!isElement(clipperElement)) {
        return [];
      } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

      return clippingParents.filter(function (clippingParent) {
        return (
          isElement(clippingParent) &&
          contains(clippingParent, clipperElement) &&
          getNodeName(clippingParent) !== "body"
        );
      });
    } // Gets the maximum area that the element is visible in due to any number of
    // clipping parents

    function getClippingRect(element, boundary, rootBoundary, strategy) {
      var mainClippingParents =
        boundary === "clippingParents"
          ? getClippingParents(element)
          : [].concat(boundary);
      var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
      var firstClippingParent = clippingParents[0];
      var clippingRect = clippingParents.reduce(function (
        accRect,
        clippingParent
      ) {
        var rect = getClientRectFromMixedType(
          element,
          clippingParent,
          strategy
        );
        accRect.top = math_max(rect.top, accRect.top);
        accRect.right = math_min(rect.right, accRect.right);
        accRect.bottom = math_min(rect.bottom, accRect.bottom);
        accRect.left = math_max(rect.left, accRect.left);
        return accRect;
      },
        getClientRectFromMixedType(element, firstClippingParent, strategy));
      clippingRect.width = clippingRect.right - clippingRect.left;
      clippingRect.height = clippingRect.bottom - clippingRect.top;
      clippingRect.x = clippingRect.left;
      clippingRect.y = clippingRect.top;
      return clippingRect;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
    function getFreshSideObject() {
      return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      };
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
    function mergePaddingObject(paddingObject) {
      return Object.assign({}, getFreshSideObject(), paddingObject);
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
    function expandToHashMap(value, keys) {
      return keys.reduce(function (hashMap, key) {
        hashMap[key] = value;
        return hashMap;
      }, {});
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js
    // eslint-disable-next-line import/no-unused-modules

    function detectOverflow(state, options) {
      if (options === void 0) {
        options = {};
      }
      var _options = options,
        _options$placement = _options.placement,
        placement =
          _options$placement === void 0 ? state.placement : _options$placement,
        _options$strategy = _options.strategy,
        strategy =
          _options$strategy === void 0 ? state.strategy : _options$strategy,
        _options$boundary = _options.boundary,
        boundary =
          _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary =
          _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext =
          _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary =
          _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
      var paddingObject = mergePaddingObject(
        typeof padding !== "number"
          ? padding
          : expandToHashMap(padding, basePlacements)
      );
      var altContext = elementContext === popper ? reference : popper;
      var popperRect = state.rects.popper;
      var element = state.elements[altBoundary ? altContext : elementContext];
      var clippingClientRect = getClippingRect(
        isElement(element)
          ? element
          : element.contextElement || getDocumentElement(state.elements.popper),
        boundary,
        rootBoundary,
        strategy
      );
      var referenceClientRect = getBoundingClientRect(state.elements.reference);
      var popperOffsets = computeOffsets({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement,
      });
      var popperClientRect = rectToClientRect(
        Object.assign({}, popperRect, popperOffsets)
      );
      var elementClientRect =
        elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
      // 0 or negative = within the clipping rect

      var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom:
          elementClientRect.bottom -
          clippingClientRect.bottom +
          paddingObject.bottom,
        left:
          clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right:
          elementClientRect.right -
          clippingClientRect.right +
          paddingObject.right,
      };
      var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

      if (elementContext === popper && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function (key) {
          var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
          var axis = [enums_top, bottom].indexOf(key) >= 0 ? "y" : "x";
          overflowOffsets[key] += offset[axis] * multiply;
        });
      }
      return overflowOffsets;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js
    function computeAutoPlacement(state, options) {
      if (options === void 0) {
        options = {};
      }
      var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements =
          _options$allowedAutoP === void 0
            ? enums_placements
            : _options$allowedAutoP;
      var variation = getVariation(placement);
      var placements = variation
        ? flipVariations
          ? variationPlacements
          : variationPlacements.filter(function (placement) {
            return getVariation(placement) === variation;
          })
        : basePlacements;
      var allowedPlacements = placements.filter(function (placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
      });
      if (allowedPlacements.length === 0) {
        allowedPlacements = placements;
      } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

      var overflows = allowedPlacements.reduce(function (acc, placement) {
        acc[placement] = detectOverflow(state, {
          placement: placement,
          boundary: boundary,
          rootBoundary: rootBoundary,
          padding: padding,
        })[getBasePlacement(placement)];
        return acc;
      }, {});
      return Object.keys(overflows).sort(function (a, b) {
        return overflows[a] - overflows[b];
      });
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js
    // eslint-disable-next-line import/no-unused-modules

    function getExpandedFallbackPlacements(placement) {
      if (getBasePlacement(placement) === auto) {
        return [];
      }
      var oppositePlacement = getOppositePlacement(placement);
      return [
        getOppositeVariationPlacement(placement),
        oppositePlacement,
        getOppositeVariationPlacement(oppositePlacement),
      ];
    }
    function flip(_ref) {
      var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
      if (state.modifiersData[name]._skip) {
        return;
      }
      var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations =
          _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
      var preferredPlacement = state.options.placement;
      var basePlacement = getBasePlacement(preferredPlacement);
      var isBasePlacement = basePlacement === preferredPlacement;
      var fallbackPlacements =
        specifiedFallbackPlacements ||
        (isBasePlacement || !flipVariations
          ? [getOppositePlacement(preferredPlacement)]
          : getExpandedFallbackPlacements(preferredPlacement));
      var placements = [preferredPlacement]
        .concat(fallbackPlacements)
        .reduce(function (acc, placement) {
          return acc.concat(
            getBasePlacement(placement) === auto
              ? computeAutoPlacement(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements,
              })
              : placement
          );
        }, []);
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var checksMap = new Map();
      var makeFallbackChecks = true;
      var firstFittingPlacement = placements[0];
      for (var i = 0; i < placements.length; i++) {
        var placement = placements[i];
        var _basePlacement = getBasePlacement(placement);
        var isStartVariation = getVariation(placement) === start;
        var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = detectOverflow(state, {
          placement: placement,
          boundary: boundary,
          rootBoundary: rootBoundary,
          altBoundary: altBoundary,
          padding: padding,
        });
        var mainVariationSide = isVertical
          ? isStartVariation
            ? right
            : left
          : isStartVariation
            ? bottom
            : enums_top;
        if (referenceRect[len] > popperRect[len]) {
          mainVariationSide = getOppositePlacement(mainVariationSide);
        }
        var altVariationSide = getOppositePlacement(mainVariationSide);
        var checks = [];
        if (checkMainAxis) {
          checks.push(overflow[_basePlacement] <= 0);
        }
        if (checkAltAxis) {
          checks.push(
            overflow[mainVariationSide] <= 0,
            overflow[altVariationSide] <= 0
          );
        }
        if (
          checks.every(function (check) {
            return check;
          })
        ) {
          firstFittingPlacement = placement;
          makeFallbackChecks = false;
          break;
        }
        checksMap.set(placement, checks);
      }
      if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
          var fittingPlacement = placements.find(function (placement) {
            var checks = checksMap.get(placement);
            if (checks) {
              return checks.slice(0, _i).every(function (check) {
                return check;
              });
            }
          });
          if (fittingPlacement) {
            firstFittingPlacement = fittingPlacement;
            return "break";
          }
        };
        for (var _i = numberOfChecks; _i > 0; _i--) {
          var _ret = _loop(_i);
          if (_ret === "break") break;
        }
      }
      if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
      }
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const modifiers_flip = {
      name: "flip",
      enabled: true,
      phase: "main",
      fn: flip,
      requiresIfExists: ["offset"],
      data: {
        _skip: false,
      },
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
    function getAltAxis(axis) {
      return axis === "x" ? "y" : "x";
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js
    function within(min, value, max) {
      return math_max(min, math_min(value, max));
    }
    function withinMaxClamp(min, value, max) {
      var v = within(min, value, max);
      return v > max ? max : v;
    } // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js
    function preventOverflow(_ref) {
      var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
      var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset =
          _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
      var overflow = detectOverflow(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary,
      });
      var basePlacement = getBasePlacement(state.placement);
      var variation = getVariation(state.placement);
      var isBasePlacement = !variation;
      var mainAxis = getMainAxisFromPlacement(basePlacement);
      var altAxis = getAltAxis(mainAxis);
      var popperOffsets = state.modifiersData.popperOffsets;
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var tetherOffsetValue =
        typeof tetherOffset === "function"
          ? tetherOffset(
            Object.assign({}, state.rects, {
              placement: state.placement,
            })
          )
          : tetherOffset;
      var normalizedTetherOffsetValue =
        typeof tetherOffsetValue === "number"
          ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue,
          }
          : Object.assign(
            {
              mainAxis: 0,
              altAxis: 0,
            },
            tetherOffsetValue
          );
      var offsetModifierState = state.modifiersData.offset
        ? state.modifiersData.offset[state.placement]
        : null;
      var data = {
        x: 0,
        y: 0,
      };
      if (!popperOffsets) {
        return;
      }
      if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? enums_top : left;
        var altSide = mainAxis === "y" ? bottom : right;
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === start ? referenceRect[len] : popperRect[len];
        var maxLen =
          variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds

        var arrowElement = state.elements.arrow;
        var arrowRect =
          tether && arrowElement
            ? getLayoutRect(arrowElement)
            : {
              width: 0,
              height: 0,
            };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"]
          ? state.modifiersData["arrow#persistent"].padding
          : getFreshSideObject();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)

        var arrowLen = within(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement
          ? referenceRect[len] / 2 -
          additive -
          arrowLen -
          arrowPaddingMin -
          normalizedTetherOffsetValue.mainAxis
          : minLen -
          arrowLen -
          arrowPaddingMin -
          normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement
          ? -referenceRect[len] / 2 +
          additive +
          arrowLen +
          arrowPaddingMax +
          normalizedTetherOffsetValue.mainAxis
          : maxLen +
          arrowLen +
          arrowPaddingMax +
          normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent =
          state.elements.arrow && getOffsetParent(state.elements.arrow);
        var clientOffset = arrowOffsetParent
          ? mainAxis === "y"
            ? arrowOffsetParent.clientTop || 0
            : arrowOffsetParent.clientLeft || 0
          : 0;
        var offsetModifierValue =
          (_offsetModifierState$ =
            offsetModifierState == null
              ? void 0
              : offsetModifierState[mainAxis]) != null
            ? _offsetModifierState$
            : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = within(
          tether ? math_min(min, tetherMin) : min,
          offset,
          tether ? math_max(max, tetherMax) : max
        );
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
      }
      if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? enums_top : left;
        var _altSide = mainAxis === "x" ? bottom : right;
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;
        var _offsetModifierValue =
          (_offsetModifierState$2 =
            offsetModifierState == null
              ? void 0
              : offsetModifierState[altAxis]) != null
            ? _offsetModifierState$2
            : 0;
        var _tetherMin = isOriginSide
          ? _min
          : _offset -
          referenceRect[_len] -
          popperRect[_len] -
          _offsetModifierValue +
          normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide
          ? _offset +
          referenceRect[_len] +
          popperRect[_len] -
          _offsetModifierValue -
          normalizedTetherOffsetValue.altAxis
          : _max;
        var _preventedOffset =
          tether && isOriginSide
            ? withinMaxClamp(_tetherMin, _offset, _tetherMax)
            : within(
              tether ? _tetherMin : _min,
              _offset,
              tether ? _tetherMax : _max
            );
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
      }
      state.modifiersData[name] = data;
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const modifiers_preventOverflow = {
      name: "preventOverflow",
      enabled: true,
      phase: "main",
      fn: preventOverflow,
      requiresIfExists: ["offset"],
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js
    // eslint-disable-next-line import/no-unused-modules

    var toPaddingObject = function toPaddingObject(padding, state) {
      padding =
        typeof padding === "function"
          ? padding(
            Object.assign({}, state.rects, {
              placement: state.placement,
            })
          )
          : padding;
      return mergePaddingObject(
        typeof padding !== "number"
          ? padding
          : expandToHashMap(padding, basePlacements)
      );
    };
    function arrow(_ref) {
      var _state$modifiersData$;
      var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
      var arrowElement = state.elements.arrow;
      var popperOffsets = state.modifiersData.popperOffsets;
      var basePlacement = getBasePlacement(state.placement);
      var axis = getMainAxisFromPlacement(basePlacement);
      var isVertical = [left, right].indexOf(basePlacement) >= 0;
      var len = isVertical ? "height" : "width";
      if (!arrowElement || !popperOffsets) {
        return;
      }
      var paddingObject = toPaddingObject(options.padding, state);
      var arrowRect = getLayoutRect(arrowElement);
      var minProp = axis === "y" ? enums_top : left;
      var maxProp = axis === "y" ? bottom : right;
      var endDiff =
        state.rects.reference[len] +
        state.rects.reference[axis] -
        popperOffsets[axis] -
        state.rects.popper[len];
      var startDiff = popperOffsets[axis] - state.rects.reference[axis];
      var arrowOffsetParent = getOffsetParent(arrowElement);
      var clientSize = arrowOffsetParent
        ? axis === "y"
          ? arrowOffsetParent.clientHeight || 0
          : arrowOffsetParent.clientWidth || 0
        : 0;
      var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
      // outside of the popper bounds

      var min = paddingObject[minProp];
      var max = clientSize - arrowRect[len] - paddingObject[maxProp];
      var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
      var offset = within(min, center, max); // Prevents breaking syntax highlighting...

      var axisProp = axis;
      state.modifiersData[name] =
        ((_state$modifiersData$ = {}),
          (_state$modifiersData$[axisProp] = offset),
          (_state$modifiersData$.centerOffset = offset - center),
          _state$modifiersData$);
    }
    function arrow_effect(_ref2) {
      var state = _ref2.state,
        options = _ref2.options;
      var _options$element = options.element,
        arrowElement =
          _options$element === void 0
            ? "[data-popper-arrow]"
            : _options$element;
      if (arrowElement == null) {
        return;
      } // CSS selector

      if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) {
          return;
        }
      }
      if (!contains(state.elements.popper, arrowElement)) {
        return;
      }
      state.elements.arrow = arrowElement;
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const modifiers_arrow = {
      name: "arrow",
      enabled: true,
      phase: "main",
      fn: arrow,
      effect: arrow_effect,
      requires: ["popperOffsets"],
      requiresIfExists: ["preventOverflow"],
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js
    function getSideOffsets(overflow, rect, preventedOffsets) {
      if (preventedOffsets === void 0) {
        preventedOffsets = {
          x: 0,
          y: 0,
        };
      }
      return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x,
      };
    }
    function isAnySideFullyClipped(overflow) {
      return [enums_top, right, bottom, left].some(function (side) {
        return overflow[side] >= 0;
      });
    }
    function hide_hide(_ref) {
      var state = _ref.state,
        name = _ref.name;
      var referenceRect = state.rects.reference;
      var popperRect = state.rects.popper;
      var preventedOffsets = state.modifiersData.preventOverflow;
      var referenceOverflow = detectOverflow(state, {
        elementContext: "reference",
      });
      var popperAltOverflow = detectOverflow(state, {
        altBoundary: true,
      });
      var referenceClippingOffsets = getSideOffsets(
        referenceOverflow,
        referenceRect
      );
      var popperEscapeOffsets = getSideOffsets(
        popperAltOverflow,
        popperRect,
        preventedOffsets
      );
      var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
      var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
      state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped,
      };
      state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped,
      });
    } // eslint-disable-next-line import/no-unused-modules

    /* harmony default export */ const modifiers_hide = {
      name: "hide",
      enabled: true,
      phase: "main",
      requiresIfExists: ["preventOverflow"],
      fn: hide_hide,
    }; // CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js
    var defaultModifiers = [
      eventListeners,
      modifiers_popperOffsets,
      modifiers_computeStyles,
      modifiers_applyStyles,
      modifiers_offset,
      modifiers_flip,
      modifiers_preventOverflow,
      modifiers_arrow,
      modifiers_hide,
    ];
    var popper_createPopper = /*#__PURE__*/ popperGenerator({
      defaultModifiers: defaultModifiers,
    }); // eslint-disable-next-line import/no-unused-modules // CONCATENATED MODULE: ./node_modules/tippy.js/dist/tippy.esm.js

    // eslint-disable-next-line import/no-unused-modules

    // eslint-disable-next-line import/no-unused-modules

    /**!
     * tippy.js v6.3.7
     * (c) 2017-2021 atomiks
     * MIT License
     */

    var ROUND_ARROW =
      '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
    var BOX_CLASS = "tippy-box";
    var CONTENT_CLASS = "tippy-content";
    var BACKDROP_CLASS = "tippy-backdrop";
    var ARROW_CLASS = "tippy-arrow";
    var SVG_ARROW_CLASS = "tippy-svg-arrow";
    var TOUCH_OPTIONS = {
      passive: true,
      capture: true,
    };
    var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
      return document.body;
    };
    function tippy_esm_hasOwnProperty(obj, key) {
      return {}.hasOwnProperty.call(obj, key);
    }
    function getValueAtIndexOrReturn(value, index, defaultValue) {
      if (Array.isArray(value)) {
        var v = value[index];
        return v == null
          ? Array.isArray(defaultValue)
            ? defaultValue[index]
            : defaultValue
          : v;
      }
      return value;
    }
    function isType(value, type) {
      var str = {}.toString.call(value);
      return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
    }
    function invokeWithArgsOrReturn(value, args) {
      return typeof value === "function" ? value.apply(void 0, args) : value;
    }
    function tippy_esm_debounce(fn, ms) {
      // Avoid wrapping in `setTimeout` if ms is 0 anyway
      if (ms === 0) {
        return fn;
      }
      var timeout;
      return function (arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          fn(arg);
        }, ms);
      };
    }
    function removeProperties(obj, keys) {
      var clone = Object.assign({}, obj);
      keys.forEach(function (key) {
        delete clone[key];
      });
      return clone;
    }
    function splitBySpaces(value) {
      return value.split(/\s+/).filter(Boolean);
    }
    function normalizeToArray(value) {
      return [].concat(value);
    }
    function pushIfUnique(arr, value) {
      if (arr.indexOf(value) === -1) {
        arr.push(value);
      }
    }
    function unique(arr) {
      return arr.filter(function (item, index) {
        return arr.indexOf(item) === index;
      });
    }
    function tippy_esm_getBasePlacement(placement) {
      return placement.split("-")[0];
    }
    function arrayFrom(value) {
      return [].slice.call(value);
    }
    function removeUndefinedProps(obj) {
      return Object.keys(obj).reduce(function (acc, key) {
        if (obj[key] !== undefined) {
          acc[key] = obj[key];
        }
        return acc;
      }, {});
    }
    function div() {
      return document.createElement("div");
    }
    function tippy_esm_isElement(value) {
      return ["Element", "Fragment"].some(function (type) {
        return isType(value, type);
      });
    }
    function isNodeList(value) {
      return isType(value, "NodeList");
    }
    function isMouseEvent(value) {
      return isType(value, "MouseEvent");
    }
    function isReferenceElement(value) {
      return !!(value && value._tippy && value._tippy.reference === value);
    }
    function getArrayOfElements(value) {
      if (tippy_esm_isElement(value)) {
        return [value];
      }
      if (isNodeList(value)) {
        return arrayFrom(value);
      }
      if (Array.isArray(value)) {
        return value;
      }
      return arrayFrom(document.querySelectorAll(value));
    }
    function setTransitionDuration(els, value) {
      els.forEach(function (el) {
        if (el) {
          el.style.transitionDuration = value + "ms";
        }
      });
    }
    function setVisibilityState(els, state) {
      els.forEach(function (el) {
        if (el) {
          el.setAttribute("data-state", state);
        }
      });
    }
    function getOwnerDocument(elementOrElements) {
      var _element$ownerDocumen;
      var _normalizeToArray = normalizeToArray(elementOrElements),
        element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body

      return element != null &&
        (_element$ownerDocumen = element.ownerDocument) != null &&
        _element$ownerDocumen.body
        ? element.ownerDocument
        : document;
    }
    function isCursorOutsideInteractiveBorder(popperTreeData, event) {
      var clientX = event.clientX,
        clientY = event.clientY;
      return popperTreeData.every(function (_ref) {
        var popperRect = _ref.popperRect,
          popperState = _ref.popperState,
          props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = tippy_esm_getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) {
          return true;
        }
        var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
        var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
        var exceedsTop =
          popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom =
          clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft =
          popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight =
          clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
      });
    }
    function updateTransitionEndListener(box, action, listener) {
      var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
      // `webkitTransitionEnd`...

      ["transitionend", "webkitTransitionEnd"].forEach(function (event) {
        box[method](event, listener);
      });
    }
    /**
     * Compared to xxx.contains, this function works for dom structures with shadow
     * dom
     */

    function actualContains(parent, child) {
      var target = child;
      while (target) {
        var _target$getRootNode;
        if (parent.contains(target)) {
          return true;
        }
        target =
          target.getRootNode == null
            ? void 0
            : (_target$getRootNode = target.getRootNode()) == null
              ? void 0
              : _target$getRootNode.host;
      }
      return false;
    }
    var currentInput = {
      isTouch: false,
    };
    var lastMouseMoveTime = 0;
    /**
     * When a `touchstart` event is fired, it's assumed the user is using touch
     * input. We'll bind a `mousemove` event listener to listen for mouse input in
     * the future. This way, the `isTouch` property is fully dynamic and will handle
     * hybrid devices that use a mix of touch + mouse input.
     */

    function onDocumentTouchStart() {
      if (currentInput.isTouch) {
        return;
      }
      currentInput.isTouch = true;
      if (window.performance) {
        document.addEventListener("mousemove", onDocumentMouseMove);
      }
    }
    /**
     * When two `mousemove` event are fired consecutively within 20ms, it's assumed
     * the user is using mouse input again. `mousemove` can fire on touch devices as
     * well, but very rarely that quickly.
     */

    function onDocumentMouseMove() {
      var now = performance.now();
      if (now - lastMouseMoveTime < 20) {
        currentInput.isTouch = false;
        document.removeEventListener("mousemove", onDocumentMouseMove);
      }
      lastMouseMoveTime = now;
    }
    /**
     * When an element is in focus and has a tippy, leaving the tab/window and
     * returning causes it to show again. For mouse users this is unexpected, but
     * for keyboard use it makes sense.
     * TODO: find a better technique to solve this problem
     */

    function onWindowBlur() {
      var activeElement = document.activeElement;
      if (isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) {
          activeElement.blur();
        }
      }
    }
    function bindGlobalEventListeners() {
      document.addEventListener(
        "touchstart",
        onDocumentTouchStart,
        TOUCH_OPTIONS
      );
      window.addEventListener("blur", onWindowBlur);
    }
    var isBrowser =
      typeof window !== "undefined" && typeof document !== "undefined";
    var isIE11 = isBrowser
      ? // @ts-ignore
      !!window.msCrypto
      : false;
    function createMemoryLeakWarning(method) {
      var txt = method === "destroy" ? "n already-" : " ";
      return [
        method +
        "() was called on a" +
        txt +
        "destroyed instance. This is a no-op but",
        "indicates a potential memory leak.",
      ].join(" ");
    }
    function clean(value) {
      var spacesAndTabs = /[ \t]{2,}/g;
      var lineStartWithSpaces = /^[ \t]*/gm;
      return value
        .replace(spacesAndTabs, " ")
        .replace(lineStartWithSpaces, "")
        .trim();
    }
    function getDevMessage(message) {
      return clean(
        "\n  %ctippy.js\n\n  %c" +
        clean(message) +
        "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  "
      );
    }
    function getFormattedMessage(message) {
      return [
        getDevMessage(message),
        // title
        "color: #00C584; font-size: 1.3em; font-weight: bold;",
        // message
        "line-height: 1.5",
        // footer
        "color: #a6a095;",
      ];
    } // Assume warnings and errors never have the same message

    var visitedMessages;
    if (false) {
    }
    function resetVisitedMessages() {
      visitedMessages = new Set();
    }
    function warnWhen(condition, message) {
      if (condition && !visitedMessages.has(message)) {
        var _console;
        visitedMessages.add(message);
        (_console = console).warn.apply(_console, getFormattedMessage(message));
      }
    }
    function errorWhen(condition, message) {
      if (condition && !visitedMessages.has(message)) {
        var _console2;
        visitedMessages.add(message);
        (_console2 = console).error.apply(
          _console2,
          getFormattedMessage(message)
        );
      }
    }
    function validateTargets(targets) {
      var didPassFalsyValue = !targets;
      var didPassPlainObject =
        Object.prototype.toString.call(targets) === "[object Object]" &&
        !targets.addEventListener;
      errorWhen(
        didPassFalsyValue,
        [
          "tippy() was passed",
          "`" + String(targets) + "`",
          "as its targets (first) argument. Valid types are: String, Element,",
          "Element[], or NodeList.",
        ].join(" ")
      );
      errorWhen(
        didPassPlainObject,
        [
          "tippy() was passed a plain object which is not supported as an argument",
          "for virtual positioning. Use props.getReferenceClientRect instead.",
        ].join(" ")
      );
    }
    var pluginProps = {
      animateFill: false,
      followCursor: false,
      inlinePositioning: false,
      sticky: false,
    };
    var renderProps = {
      allowHTML: false,
      animation: "fade",
      arrow: true,
      content: "",
      inertia: false,
      maxWidth: 350,
      role: "tooltip",
      theme: "",
      zIndex: 9999,
    };
    var defaultProps = Object.assign(
      {
        appendTo: TIPPY_DEFAULT_APPEND_TO,
        aria: {
          content: "auto",
          expanded: "auto",
        },
        delay: 0,
        duration: [300, 250],
        getReferenceClientRect: null,
        hideOnClick: true,
        ignoreAttributes: false,
        interactive: false,
        interactiveBorder: 2,
        interactiveDebounce: 0,
        moveTransition: "",
        offset: [0, 10],
        onAfterUpdate: function onAfterUpdate() { },
        onBeforeUpdate: function onBeforeUpdate() { },
        onCreate: function onCreate() { },
        onDestroy: function onDestroy() { },
        onHidden: function onHidden() { },
        onHide: function onHide() { },
        onMount: function onMount() { },
        onShow: function onShow() { },
        onShown: function onShown() { },
        onTrigger: function onTrigger() { },
        onUntrigger: function onUntrigger() { },
        onClickOutside: function onClickOutside() { },
        placement: "top",
        plugins: [],
        popperOptions: {},
        render: null,
        showOnCreate: false,
        touch: true,
        trigger: "mouseenter focus",
        triggerTarget: null,
      },
      pluginProps,
      renderProps
    );
    var defaultKeys = Object.keys(defaultProps);
    var setDefaultProps = function setDefaultProps(partialProps) {
      /* istanbul ignore else */
      if (false) {
      }
      var keys = Object.keys(partialProps);
      keys.forEach(function (key) {
        defaultProps[key] = partialProps[key];
      });
    };
    function getExtendedPassedProps(passedProps) {
      var plugins = passedProps.plugins || [];
      var pluginProps = plugins.reduce(function (acc, plugin) {
        var name = plugin.name,
          defaultValue = plugin.defaultValue;
        if (name) {
          var _name;
          acc[name] =
            passedProps[name] !== undefined
              ? passedProps[name]
              : (_name = defaultProps[name]) != null
                ? _name
                : defaultValue;
        }
        return acc;
      }, {});
      return Object.assign({}, passedProps, pluginProps);
    }
    function getDataAttributeProps(reference, plugins) {
      var propKeys = plugins
        ? Object.keys(
          getExtendedPassedProps(
            Object.assign({}, defaultProps, {
              plugins: plugins,
            })
          )
        )
        : defaultKeys;
      var props = propKeys.reduce(function (acc, key) {
        var valueAsString = (
          reference.getAttribute("data-tippy-" + key) || ""
        ).trim();
        if (!valueAsString) {
          return acc;
        }
        if (key === "content") {
          acc[key] = valueAsString;
        } else {
          try {
            acc[key] = JSON.parse(valueAsString);
          } catch (e) {
            acc[key] = valueAsString;
          }
        }
        return acc;
      }, {});
      return props;
    }
    function evaluateProps(reference, props) {
      var out = Object.assign(
        {},
        props,
        {
          content: invokeWithArgsOrReturn(props.content, [reference]),
        },
        props.ignoreAttributes
          ? {}
          : getDataAttributeProps(reference, props.plugins)
      );
      out.aria = Object.assign({}, defaultProps.aria, out.aria);
      out.aria = {
        expanded:
          out.aria.expanded === "auto" ? props.interactive : out.aria.expanded,
        content:
          out.aria.content === "auto"
            ? props.interactive
              ? null
              : "describedby"
            : out.aria.content,
      };
      return out;
    }
    function validateProps(partialProps, plugins) {
      if (partialProps === void 0) {
        partialProps = {};
      }
      if (plugins === void 0) {
        plugins = [];
      }
      var keys = Object.keys(partialProps);
      keys.forEach(function (prop) {
        var nonPluginProps = removeProperties(
          defaultProps,
          Object.keys(pluginProps)
        );
        var didPassUnknownProp = !tippy_esm_hasOwnProperty(
          nonPluginProps,
          prop
        ); // Check if the prop exists in `plugins`

        if (didPassUnknownProp) {
          didPassUnknownProp =
            plugins.filter(function (plugin) {
              return plugin.name === prop;
            }).length === 0;
        }
        warnWhen(
          didPassUnknownProp,
          [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            "a plugin, forgot to pass it in an array as props.plugins.",
            "\n\n",
            "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
            "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/",
          ].join(" ")
        );
      });
    }
    var innerHTML = function innerHTML() {
      return "innerHTML";
    };
    function dangerouslySetInnerHTML(element, html) {
      element[innerHTML()] = html;
    }
    function createArrowElement(value) {
      var arrow = div();
      if (value === true) {
        arrow.className = ARROW_CLASS;
      } else {
        arrow.className = SVG_ARROW_CLASS;
        if (tippy_esm_isElement(value)) {
          arrow.appendChild(value);
        } else {
          dangerouslySetInnerHTML(arrow, value);
        }
      }
      return arrow;
    }
    function setContent(content, props) {
      if (tippy_esm_isElement(props.content)) {
        dangerouslySetInnerHTML(content, "");
        content.appendChild(props.content);
      } else if (typeof props.content !== "function") {
        if (props.allowHTML) {
          dangerouslySetInnerHTML(content, props.content);
        } else {
          content.textContent = props.content;
        }
      }
    }
    function getChildren(popper) {
      var box = popper.firstElementChild;
      var boxChildren = arrayFrom(box.children);
      return {
        box: box,
        content: boxChildren.find(function (node) {
          return node.classList.contains(CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function (node) {
          return (
            node.classList.contains(ARROW_CLASS) ||
            node.classList.contains(SVG_ARROW_CLASS)
          );
        }),
        backdrop: boxChildren.find(function (node) {
          return node.classList.contains(BACKDROP_CLASS);
        }),
      };
    }
    function render(instance) {
      var popper = div();
      var box = div();
      box.className = BOX_CLASS;
      box.setAttribute("data-state", "hidden");
      box.setAttribute("tabindex", "-1");
      var content = div();
      content.className = CONTENT_CLASS;
      content.setAttribute("data-state", "hidden");
      setContent(content, instance.props);
      popper.appendChild(box);
      box.appendChild(content);
      onUpdate(instance.props, instance.props);
      function onUpdate(prevProps, nextProps) {
        var _getChildren = getChildren(popper),
          box = _getChildren.box,
          content = _getChildren.content,
          arrow = _getChildren.arrow;
        if (nextProps.theme) {
          box.setAttribute("data-theme", nextProps.theme);
        } else {
          box.removeAttribute("data-theme");
        }
        if (typeof nextProps.animation === "string") {
          box.setAttribute("data-animation", nextProps.animation);
        } else {
          box.removeAttribute("data-animation");
        }
        if (nextProps.inertia) {
          box.setAttribute("data-inertia", "");
        } else {
          box.removeAttribute("data-inertia");
        }
        box.style.maxWidth =
          typeof nextProps.maxWidth === "number"
            ? nextProps.maxWidth + "px"
            : nextProps.maxWidth;
        if (nextProps.role) {
          box.setAttribute("role", nextProps.role);
        } else {
          box.removeAttribute("role");
        }
        if (
          prevProps.content !== nextProps.content ||
          prevProps.allowHTML !== nextProps.allowHTML
        ) {
          setContent(content, instance.props);
        }
        if (nextProps.arrow) {
          if (!arrow) {
            box.appendChild(createArrowElement(nextProps.arrow));
          } else if (prevProps.arrow !== nextProps.arrow) {
            box.removeChild(arrow);
            box.appendChild(createArrowElement(nextProps.arrow));
          }
        } else if (arrow) {
          box.removeChild(arrow);
        }
      }
      return {
        popper: popper,
        onUpdate: onUpdate,
      };
    } // Runtime check to identify if the render function is the default one; this
    // way we can apply default CSS transitions logic and it can be tree-shaken away

    render.$$tippy = true;
    var idCounter = 1;
    var mouseMoveListeners = []; // Used by `hideAll()`

    var mountedInstances = [];
    function createTippy(reference, passedProps) {
      var props = evaluateProps(
        reference,
        Object.assign(
          {},
          defaultProps,
          getExtendedPassedProps(removeUndefinedProps(passedProps))
        )
      ); // ===========================================================================
      // 🔒 Private members
      // ===========================================================================

      var showTimeout;
      var hideTimeout;
      var scheduleHideAnimationFrame;
      var isVisibleFromClick = false;
      var didHideDueToDocumentMouseDown = false;
      var didTouchMove = false;
      var ignoreOnFirstUpdate = false;
      var lastTriggerEvent;
      var currentTransitionEndListener;
      var onFirstUpdate;
      var listeners = [];
      var debouncedOnMouseMove = tippy_esm_debounce(
        onMouseMove,
        props.interactiveDebounce
      );
      var currentTarget; // ===========================================================================
      // 🔑 Public members
      // ===========================================================================

      var id = idCounter++;
      var popperInstance = null;
      var plugins = unique(props.plugins);
      var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false,
      };
      var instance = {
        // properties
        id: id,
        reference: reference,
        popper: div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy,
      }; // TODO: Investigate why this early return causes a TDZ error in the tests —
      // it doesn't seem to happen in the browser

      /* istanbul ignore if */

      if (!props.render) {
        if (false) {
        }
        return instance;
      } // ===========================================================================
      // Initial mutations
      // ===========================================================================

      var _props$render = props.render(instance),
        popper = _props$render.popper,
        onUpdate = _props$render.onUpdate;
      popper.setAttribute("data-tippy-root", "");
      popper.id = "tippy-" + instance.id;
      instance.popper = popper;
      reference._tippy = instance;
      popper._tippy = instance;
      var pluginsHooks = plugins.map(function (plugin) {
        return plugin.fn(instance);
      });
      var hasAriaExpanded = reference.hasAttribute("aria-expanded");
      addListeners();
      handleAriaExpandedAttribute();
      handleStyles();
      invokeHook("onCreate", [instance]);
      if (props.showOnCreate) {
        scheduleShow();
      } // Prevent a tippy with a delay from hiding if the cursor left then returned
      // before it started hiding

      popper.addEventListener("mouseenter", function () {
        if (instance.props.interactive && instance.state.isVisible) {
          instance.clearDelayTimeouts();
        }
      });
      popper.addEventListener("mouseleave", function () {
        if (
          instance.props.interactive &&
          instance.props.trigger.indexOf("mouseenter") >= 0
        ) {
          getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        }
      });
      return instance; // ===========================================================================
      // 🔒 Private methods
      // ===========================================================================

      function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [touch, 0];
      }
      function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === "hold";
      }
      function getIsDefaultRenderFn() {
        var _instance$props$rende;

        // @ts-ignore
        return !!(
          (_instance$props$rende = instance.props.render) != null &&
          _instance$props$rende.$$tippy
        );
      }
      function getCurrentTarget() {
        return currentTarget || reference;
      }
      function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? getOwnerDocument(parent) : document;
      }
      function getDefaultTemplateChildren() {
        return getChildren(popper);
      }
      function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (
          (instance.state.isMounted && !instance.state.isVisible) ||
          currentInput.isTouch ||
          (lastTriggerEvent && lastTriggerEvent.type === "focus")
        ) {
          return 0;
        }
        return getValueAtIndexOrReturn(
          instance.props.delay,
          isShow ? 0 : 1,
          defaultProps.delay
        );
      }
      function handleStyles(fromHide) {
        if (fromHide === void 0) {
          fromHide = false;
        }
        popper.style.pointerEvents =
          instance.props.interactive && !fromHide ? "" : "none";
        popper.style.zIndex = "" + instance.props.zIndex;
      }
      function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) {
          shouldInvokePropsHook = true;
        }
        pluginsHooks.forEach(function (pluginHooks) {
          if (pluginHooks[hook]) {
            pluginHooks[hook].apply(pluginHooks, args);
          }
        });
        if (shouldInvokePropsHook) {
          var _instance$props;
          (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
      }
      function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) {
          return;
        }
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function (node) {
          var currentValue = node.getAttribute(attr);
          if (instance.state.isVisible) {
            node.setAttribute(
              attr,
              currentValue ? currentValue + " " + id : id
            );
          } else {
            var nextValue = currentValue && currentValue.replace(id, "").trim();
            if (nextValue) {
              node.setAttribute(attr, nextValue);
            } else {
              node.removeAttribute(attr);
            }
          }
        });
      }
      function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) {
          return;
        }
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function (node) {
          if (instance.props.interactive) {
            node.setAttribute(
              "aria-expanded",
              instance.state.isVisible && node === getCurrentTarget()
                ? "true"
                : "false"
            );
          } else {
            node.removeAttribute("aria-expanded");
          }
        });
      }
      function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
        mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
          return listener !== debouncedOnMouseMove;
        });
      }
      function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if (currentInput.isTouch) {
          if (didTouchMove || event.type === "mousedown") {
            return;
          }
        }
        var actualTarget =
          (event.composedPath && event.composedPath()[0]) || event.target; // Clicked on interactive popper

        if (
          instance.props.interactive &&
          actualContains(popper, actualTarget)
        ) {
          return;
        } // Clicked on the event listeners target

        if (
          normalizeToArray(instance.props.triggerTarget || reference).some(
            function (el) {
              return actualContains(el, actualTarget);
            }
          )
        ) {
          if (currentInput.isTouch) {
            return;
          }
          if (
            instance.state.isVisible &&
            instance.props.trigger.indexOf("click") >= 0
          ) {
            return;
          }
        } else {
          invokeHook("onClickOutside", [instance, event]);
        }
        if (instance.props.hideOnClick === true) {
          instance.clearDelayTimeouts();
          instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
          // currentTarget. This lets a tippy with `focus` trigger know that it
          // should not show

          didHideDueToDocumentMouseDown = true;
          setTimeout(function () {
            didHideDueToDocumentMouseDown = false;
          }); // The listener gets added in `scheduleShow()`, but this may be hiding it
          // before it shows, and hide()'s early bail-out behavior can prevent it
          // from being cleaned up

          if (!instance.state.isMounted) {
            removeDocumentPress();
          }
        }
      }
      function onTouchMove() {
        didTouchMove = true;
      }
      function onTouchStart() {
        didTouchMove = false;
      }
      function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener("mousedown", onDocumentPress, true);
        doc.addEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
        doc.addEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
        doc.addEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
      }
      function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener("mousedown", onDocumentPress, true);
        doc.removeEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
        doc.removeEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
        doc.removeEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
      }
      function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function () {
          if (
            !instance.state.isVisible &&
            popper.parentNode &&
            popper.parentNode.contains(popper)
          ) {
            callback();
          }
        });
      }
      function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
      }
      function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
          if (event.target === box) {
            updateTransitionEndListener(box, "remove", listener);
            callback();
          }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise

        if (duration === 0) {
          return callback();
        }
        updateTransitionEndListener(
          box,
          "remove",
          currentTransitionEndListener
        );
        updateTransitionEndListener(box, "add", listener);
        currentTransitionEndListener = listener;
      }
      function on(eventType, handler, options) {
        if (options === void 0) {
          options = false;
        }
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function (node) {
          node.addEventListener(eventType, handler, options);
          listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options,
          });
        });
      }
      function addListeners() {
        if (getIsCustomTouchBehavior()) {
          on("touchstart", onTrigger, {
            passive: true,
          });
          on("touchend", onMouseLeave, {
            passive: true,
          });
        }
        splitBySpaces(instance.props.trigger).forEach(function (eventType) {
          if (eventType === "manual") {
            return;
          }
          on(eventType, onTrigger);
          switch (eventType) {
            case "mouseenter":
              on("mouseleave", onMouseLeave);
              break;
            case "focus":
              on(isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
              break;
            case "focusin":
              on("focusout", onBlurOrFocusOut);
              break;
          }
        });
      }
      function removeListeners() {
        listeners.forEach(function (_ref) {
          var node = _ref.node,
            eventType = _ref.eventType,
            handler = _ref.handler,
            options = _ref.options;
          node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
      }
      function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (
          !instance.state.isEnabled ||
          isEventListenerStopped(event) ||
          didHideDueToDocumentMouseDown
        ) {
          return;
        }
        var wasFocused =
          ((_lastTriggerEvent = lastTriggerEvent) == null
            ? void 0
            : _lastTriggerEvent.type) === "focus";
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && isMouseEvent(event)) {
          // If scrolling, `mouseenter` events can be fired if the cursor lands
          // over a new target, but `mousemove` events don't get fired. This
          // causes interactive tooltips to get stuck open until the cursor is
          // moved
          mouseMoveListeners.forEach(function (listener) {
            return listener(event);
          });
        } // Toggle show/hide when clicking click-triggered tooltips

        if (
          event.type === "click" &&
          (instance.props.trigger.indexOf("mouseenter") < 0 ||
            isVisibleFromClick) &&
          instance.props.hideOnClick !== false &&
          instance.state.isVisible
        ) {
          shouldScheduleClickHide = true;
        } else {
          scheduleShow(event);
        }
        if (event.type === "click") {
          isVisibleFromClick = !shouldScheduleClickHide;
        }
        if (shouldScheduleClickHide && !wasFocused) {
          scheduleHide(event);
        }
      }
      function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper =
          getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === "mousemove" && isCursorOverReferenceOrPopper) {
          return;
        }
        var popperTreeData = getNestedPopperTree()
          .concat(popper)
          .map(function (popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state =
              (_instance$popperInsta = instance.popperInstance) == null
                ? void 0
                : _instance$popperInsta.state;
            if (state) {
              return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props,
              };
            }
            return null;
          })
          .filter(Boolean);
        if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
          cleanupInteractiveMouseListeners();
          scheduleHide(event);
        }
      }
      function onMouseLeave(event) {
        var shouldBail =
          isEventListenerStopped(event) ||
          (instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick);
        if (shouldBail) {
          return;
        }
        if (instance.props.interactive) {
          instance.hideWithInteractivity(event);
          return;
        }
        scheduleHide(event);
      }
      function onBlurOrFocusOut(event) {
        if (
          instance.props.trigger.indexOf("focusin") < 0 &&
          event.target !== getCurrentTarget()
        ) {
          return;
        } // If focus was moved to within the popper

        if (
          instance.props.interactive &&
          event.relatedTarget &&
          popper.contains(event.relatedTarget)
        ) {
          return;
        }
        scheduleHide(event);
      }
      function isEventListenerStopped(event) {
        return currentInput.isTouch
          ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0
          : false;
      }
      function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props,
          popperOptions = _instance$props2.popperOptions,
          placement = _instance$props2.placement,
          offset = _instance$props2.offset,
          getReferenceClientRect = _instance$props2.getReferenceClientRect,
          moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect
          ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement:
              getReferenceClientRect.contextElement || getCurrentTarget(),
          }
          : reference;
        var tippyModifier = {
          name: "$$tippy",
          enabled: true,
          phase: "beforeWrite",
          requires: ["computeStyles"],
          fn: function fn(_ref2) {
            var state = _ref2.state;
            if (getIsDefaultRenderFn()) {
              var _getDefaultTemplateCh = getDefaultTemplateChildren(),
                box = _getDefaultTemplateCh.box;
              ["placement", "reference-hidden", "escaped"].forEach(function (
                attr
              ) {
                if (attr === "placement") {
                  box.setAttribute("data-placement", state.placement);
                } else {
                  if (state.attributes.popper["data-popper-" + attr]) {
                    box.setAttribute("data-" + attr, "");
                  } else {
                    box.removeAttribute("data-" + attr);
                  }
                }
              });
              state.attributes.popper = {};
            }
          },
        };
        var modifiers = [
          {
            name: "offset",
            options: {
              offset: offset,
            },
          },
          {
            name: "preventOverflow",
            options: {
              padding: {
                top: 2,
                bottom: 2,
                left: 5,
                right: 5,
              },
            },
          },
          {
            name: "flip",
            options: {
              padding: 5,
            },
          },
          {
            name: "computeStyles",
            options: {
              adaptive: !moveTransition,
            },
          },
          tippyModifier,
        ];
        if (getIsDefaultRenderFn() && arrow) {
          modifiers.push({
            name: "arrow",
            options: {
              element: arrow,
              padding: 3,
            },
          });
        }
        modifiers.push.apply(
          modifiers,
          (popperOptions == null ? void 0 : popperOptions.modifiers) || []
        );
        instance.popperInstance = popper_createPopper(
          computedReference,
          popper,
          Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers,
          })
        );
      }
      function destroyPopperInstance() {
        if (instance.popperInstance) {
          instance.popperInstance.destroy();
          instance.popperInstance = null;
        }
      }
      function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually

        var node = getCurrentTarget();
        if (
          (instance.props.interactive &&
            appendTo === TIPPY_DEFAULT_APPEND_TO) ||
          appendTo === "parent"
        ) {
          parentNode = node.parentNode;
        } else {
          parentNode = invokeWithArgsOrReturn(appendTo, [node]);
        } // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions

        if (!parentNode.contains(popper)) {
          parentNode.appendChild(popper);
        }
        instance.state.isMounted = true;
        createPopperInstance();
        /* istanbul ignore else */

        if (false) {
        }
      }
      function getNestedPopperTree() {
        return arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
      }
      function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) {
          invokeHook("onTrigger", [instance, event]);
        }
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(),
          touchValue = _getNormalizedTouchSe[0],
          touchDelay = _getNormalizedTouchSe[1];
        if (currentInput.isTouch && touchValue === "hold" && touchDelay) {
          delay = touchDelay;
        }
        if (delay) {
          showTimeout = setTimeout(function () {
            instance.show();
          }, delay);
        } else {
          instance.show();
        }
      }
      function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook("onUntrigger", [instance, event]);
        if (!instance.state.isVisible) {
          removeDocumentPress();
          return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.

        if (
          instance.props.trigger.indexOf("mouseenter") >= 0 &&
          instance.props.trigger.indexOf("click") >= 0 &&
          ["mouseleave", "mousemove"].indexOf(event.type) >= 0 &&
          isVisibleFromClick
        ) {
          return;
        }
        var delay = getDelay(false);
        if (delay) {
          hideTimeout = setTimeout(function () {
            if (instance.state.isVisible) {
              instance.hide();
            }
          }, delay);
        } else {
          // Fixes a `transitionend` problem when it fires 1 frame too
          // late sometimes, we don't want hide() to be called.
          scheduleHideAnimationFrame = requestAnimationFrame(function () {
            instance.hide();
          });
        }
      } // ===========================================================================
      // 🔑 Public methods
      // ===========================================================================

      function enable() {
        instance.state.isEnabled = true;
      }
      function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
      }
      function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
      }
      function setProps(partialProps) {
        /* istanbul ignore else */
        if (false) {
        }
        if (instance.state.isDestroyed) {
          return;
        }
        invokeHook("onBeforeUpdate", [instance, partialProps]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = evaluateProps(
          reference,
          Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
            ignoreAttributes: true,
          })
        );
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
          cleanupInteractiveMouseListeners();
          debouncedOnMouseMove = tippy_esm_debounce(
            onMouseMove,
            nextProps.interactiveDebounce
          );
        } // Ensure stale aria-expanded attributes are removed

        if (prevProps.triggerTarget && !nextProps.triggerTarget) {
          normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
            node.removeAttribute("aria-expanded");
          });
        } else if (nextProps.triggerTarget) {
          reference.removeAttribute("aria-expanded");
        }
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) {
          onUpdate(prevProps, nextProps);
        }
        if (instance.popperInstance) {
          createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
          // and the nested ones get re-rendered first.
          // https://github.com/atomiks/tippyjs-react/issues/177
          // TODO: find a cleaner / more efficient solution(!)

          getNestedPopperTree().forEach(function (nestedPopper) {
            // React (and other UI libs likely) requires a rAF wrapper as it flushes
            // its work in one
            requestAnimationFrame(
              nestedPopper._tippy.popperInstance.forceUpdate
            );
          });
        }
        invokeHook("onAfterUpdate", [instance, partialProps]);
      }
      function setContent(content) {
        instance.setProps({
          content: content,
        });
      }
      function show() {
        /* istanbul ignore else */
        if (false) {
        } // Early bail-out

        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled =
          currentInput.isTouch && !instance.props.touch;
        var duration = getValueAtIndexOrReturn(
          instance.props.duration,
          0,
          defaultProps.duration
        );
        if (
          isAlreadyVisible ||
          isDestroyed ||
          isDisabled ||
          isTouchAndTouchDisabled
        ) {
          return;
        } // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.

        if (getCurrentTarget().hasAttribute("disabled")) {
          return;
        }
        invokeHook("onShow", [instance], false);
        if (instance.props.onShow(instance) === false) {
          return;
        }
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) {
          popper.style.visibility = "visible";
        }
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) {
          popper.style.transition = "none";
        } // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh2.box,
            content = _getDefaultTemplateCh2.content;
          setTransitionDuration([box, content], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
          var _instance$popperInsta2;
          if (!instance.state.isVisible || ignoreOnFirstUpdate) {
            return;
          }
          ignoreOnFirstUpdate = true; // reflow

          void popper.offsetHeight;
          popper.style.transition = instance.props.moveTransition;
          if (getIsDefaultRenderFn() && instance.props.animation) {
            var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
              _box = _getDefaultTemplateCh3.box,
              _content = _getDefaultTemplateCh3.content;
            setTransitionDuration([_box, _content], duration);
            setVisibilityState([_box, _content], "visible");
          }
          handleAriaContentAttribute();
          handleAriaExpandedAttribute();
          pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
          // popper has been positioned for the first time

          (_instance$popperInsta2 = instance.popperInstance) == null
            ? void 0
            : _instance$popperInsta2.forceUpdate();
          invokeHook("onMount", [instance]);
          if (instance.props.animation && getIsDefaultRenderFn()) {
            onTransitionedIn(duration, function () {
              instance.state.isShown = true;
              invokeHook("onShown", [instance]);
            });
          }
        };
        mount();
      }
      function hide() {
        /* istanbul ignore else */
        if (false) {
        } // Early bail-out

        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = getValueAtIndexOrReturn(
          instance.props.duration,
          1,
          defaultProps.duration
        );
        if (isAlreadyHidden || isDestroyed || isDisabled) {
          return;
        }
        invokeHook("onHide", [instance], false);
        if (instance.props.onHide(instance) === false) {
          return;
        }
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) {
          popper.style.visibility = "hidden";
        }
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh4.box,
            content = _getDefaultTemplateCh4.content;
          if (instance.props.animation) {
            setTransitionDuration([box, content], duration);
            setVisibilityState([box, content], "hidden");
          }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
          if (getIsDefaultRenderFn()) {
            onTransitionedOut(duration, instance.unmount);
          }
        } else {
          instance.unmount();
        }
      }
      function hideWithInteractivity(event) {
        /* istanbul ignore else */
        if (false) {
        }
        getDocument().addEventListener("mousemove", debouncedOnMouseMove);
        pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
      }
      function unmount() {
        /* istanbul ignore else */
        if (false) {
        }
        if (instance.state.isVisible) {
          instance.hide();
        }
        if (!instance.state.isMounted) {
          return;
        }
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible

        getNestedPopperTree().forEach(function (nestedPopper) {
          nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) {
          popper.parentNode.removeChild(popper);
        }
        mountedInstances = mountedInstances.filter(function (i) {
          return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook("onHidden", [instance]);
      }
      function destroy() {
        /* istanbul ignore else */
        if (false) {
        }
        if (instance.state.isDestroyed) {
          return;
        }
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook("onDestroy", [instance]);
      }
    }
    function tippy(targets, optionalProps) {
      if (optionalProps === void 0) {
        optionalProps = {};
      }
      var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
      /* istanbul ignore else */

      if (false) {
      }
      bindGlobalEventListeners();
      var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins,
      });
      var elements = getArrayOfElements(targets);
      /* istanbul ignore else */

      if (false) {
        var isMoreThanOneReferenceElement, isSingleContentElement;
      }
      var instances = elements.reduce(function (acc, reference) {
        var instance = reference && createTippy(reference, passedProps);
        if (instance) {
          acc.push(instance);
        }
        return acc;
      }, []);
      return tippy_esm_isElement(targets) ? instances[0] : instances;
    }
    tippy.defaultProps = defaultProps;
    tippy.setDefaultProps = setDefaultProps;
    tippy.currentInput = currentInput;
    var hideAll = function hideAll(_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
        excludedReferenceOrInstance = _ref.exclude,
        duration = _ref.duration;
      mountedInstances.forEach(function (instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) {
          isExcluded = isReferenceElement(excludedReferenceOrInstance)
            ? instance.reference === excludedReferenceOrInstance
            : instance.popper === excludedReferenceOrInstance.popper;
        }
        if (!isExcluded) {
          var originalDuration = instance.props.duration;
          instance.setProps({
            duration: duration,
          });
          instance.hide();
          if (!instance.state.isDestroyed) {
            instance.setProps({
              duration: originalDuration,
            });
          }
        }
      });
    };

    // every time the popper is destroyed (i.e. a new target), removing the styles
    // and causing transitions to break for singletons when the console is open, but
    // most notably for non-transform styles being used, `gpuAcceleration: false`.

    var applyStylesModifier = Object.assign({}, modifiers_applyStyles, {
      effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
          popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0",
          },
          arrow: {
            position: "absolute",
          },
          reference: {},
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) {
          Object.assign(state.elements.arrow.style, initialStyles.arrow);
        } // intentionally return no cleanup function
        // return () => { ... }
      },
    });

    var createSingleton = function createSingleton(
      tippyInstances,
      optionalProps
    ) {
      var _optionalProps$popper;
      if (optionalProps === void 0) {
        optionalProps = {};
      }

      /* istanbul ignore else */
      if (false) {
      }
      var individualInstances = tippyInstances;
      var references = [];
      var triggerTargets = [];
      var currentTarget;
      var overrides = optionalProps.overrides;
      var interceptSetPropsCleanups = [];
      var shownOnCreate = false;
      function setTriggerTargets() {
        triggerTargets = individualInstances
          .map(function (instance) {
            return normalizeToArray(
              instance.props.triggerTarget || instance.reference
            );
          })
          .reduce(function (acc, item) {
            return acc.concat(item);
          }, []);
      }
      function setReferences() {
        references = individualInstances.map(function (instance) {
          return instance.reference;
        });
      }
      function enableInstances(isEnabled) {
        individualInstances.forEach(function (instance) {
          if (isEnabled) {
            instance.enable();
          } else {
            instance.disable();
          }
        });
      }
      function interceptSetProps(singleton) {
        return individualInstances.map(function (instance) {
          var originalSetProps = instance.setProps;
          instance.setProps = function (props) {
            originalSetProps(props);
            if (instance.reference === currentTarget) {
              singleton.setProps(props);
            }
          };
          return function () {
            instance.setProps = originalSetProps;
          };
        });
      } // have to pass singleton, as it maybe undefined on first call

      function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out

        if (target === currentTarget) {
          return;
        }
        currentTarget = target;
        var overrideProps = (overrides || [])
          .concat("content")
          .reduce(function (acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
          }, {});
        singleton.setProps(
          Object.assign({}, overrideProps, {
            getReferenceClientRect:
              typeof overrideProps.getReferenceClientRect === "function"
                ? overrideProps.getReferenceClientRect
                : function () {
                  var _references$index;
                  return (_references$index = references[index]) == null
                    ? void 0
                    : _references$index.getBoundingClientRect();
                },
          })
        );
      }
      enableInstances(false);
      setReferences();
      setTriggerTargets();
      var plugin = {
        fn: function fn() {
          return {
            onDestroy: function onDestroy() {
              enableInstances(true);
            },
            onHidden: function onHidden() {
              currentTarget = null;
            },
            onClickOutside: function onClickOutside(instance) {
              if (instance.props.showOnCreate && !shownOnCreate) {
                shownOnCreate = true;
                currentTarget = null;
              }
            },
            onShow: function onShow(instance) {
              if (instance.props.showOnCreate && !shownOnCreate) {
                shownOnCreate = true;
                prepareInstance(instance, references[0]);
              }
            },
            onTrigger: function onTrigger(instance, event) {
              prepareInstance(instance, event.currentTarget);
            },
          };
        },
      };
      var singleton = tippy(
        div(),
        Object.assign({}, removeProperties(optionalProps, ["overrides"]), {
          plugins: [plugin].concat(optionalProps.plugins || []),
          triggerTarget: triggerTargets,
          popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(
              ((_optionalProps$popper = optionalProps.popperOptions) == null
                ? void 0
                : _optionalProps$popper.modifiers) || [],
              [applyStylesModifier]
            ),
          }),
        })
      );
      var originalShow = singleton.show;
      singleton.show = function (target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance

        if (!currentTarget && target == null) {
          return prepareInstance(singleton, references[0]);
        } // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)

        if (currentTarget && target == null) {
          return;
        } // target is index of instance

        if (typeof target === "number") {
          return (
            references[target] && prepareInstance(singleton, references[target])
          );
        } // target is a child tippy instance

        if (individualInstances.indexOf(target) >= 0) {
          var ref = target.reference;
          return prepareInstance(singleton, ref);
        } // target is a ReferenceElement

        if (references.indexOf(target) >= 0) {
          return prepareInstance(singleton, target);
        }
      };
      singleton.showNext = function () {
        var first = references[0];
        if (!currentTarget) {
          return singleton.show(0);
        }
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
      };
      singleton.showPrevious = function () {
        var last = references[references.length - 1];
        if (!currentTarget) {
          return singleton.show(last);
        }
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
      };
      var originalSetProps = singleton.setProps;
      singleton.setProps = function (props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
      };
      singleton.setInstances = function (nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function (fn) {
          return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
          triggerTarget: triggerTargets,
        });
      };
      interceptSetPropsCleanups = interceptSetProps(singleton);
      return singleton;
    };
    var BUBBLING_EVENTS_MAP = {
      mouseover: "mouseenter",
      focusin: "focus",
      click: "click",
    };
    /**
     * Creates a delegate instance that controls the creation of tippy instances
     * for child elements (`target` CSS selector).
     */

    function delegate(targets, props) {
      /* istanbul ignore else */
      if (false) {
      }
      var listeners = [];
      var childTippyInstances = [];
      var disabled = false;
      var target = props.target;
      var nativeProps = removeProperties(props, ["target"]);
      var parentProps = Object.assign({}, nativeProps, {
        trigger: "manual",
        touch: false,
      });
      var childProps = Object.assign(
        {
          touch: defaultProps.touch,
        },
        nativeProps,
        {
          showOnCreate: true,
        }
      );
      var returnValue = tippy(targets, parentProps);
      var normalizedReturnValue = normalizeToArray(returnValue);
      function onTrigger(event) {
        if (!event.target || disabled) {
          return;
        }
        var targetNode = event.target.closest(target);
        if (!targetNode) {
          return;
        } // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`

        var trigger =
          targetNode.getAttribute("data-tippy-trigger") ||
          props.trigger ||
          defaultProps.trigger; // @ts-ignore

        if (targetNode._tippy) {
          return;
        }
        if (
          event.type === "touchstart" &&
          typeof childProps.touch === "boolean"
        ) {
          return;
        }
        if (
          event.type !== "touchstart" &&
          trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0
        ) {
          return;
        }
        var instance = tippy(targetNode, childProps);
        if (instance) {
          childTippyInstances = childTippyInstances.concat(instance);
        }
      }
      function on(node, eventType, handler, options) {
        if (options === void 0) {
          options = false;
        }
        node.addEventListener(eventType, handler, options);
        listeners.push({
          node: node,
          eventType: eventType,
          handler: handler,
          options: options,
        });
      }
      function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, "touchstart", onTrigger, TOUCH_OPTIONS);
        on(reference, "mouseover", onTrigger);
        on(reference, "focusin", onTrigger);
        on(reference, "click", onTrigger);
      }
      function removeEventListeners() {
        listeners.forEach(function (_ref) {
          var node = _ref.node,
            eventType = _ref.eventType,
            handler = _ref.handler,
            options = _ref.options;
          node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
      }
      function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function (shouldDestroyChildInstances) {
          if (shouldDestroyChildInstances === void 0) {
            shouldDestroyChildInstances = true;
          }
          if (shouldDestroyChildInstances) {
            childTippyInstances.forEach(function (instance) {
              instance.destroy();
            });
          }
          childTippyInstances = [];
          removeEventListeners();
          originalDestroy();
        };
        instance.enable = function () {
          originalEnable();
          childTippyInstances.forEach(function (instance) {
            return instance.enable();
          });
          disabled = false;
        };
        instance.disable = function () {
          originalDisable();
          childTippyInstances.forEach(function (instance) {
            return instance.disable();
          });
          disabled = true;
        };
        addEventListeners(instance);
      }
      normalizedReturnValue.forEach(applyMutations);
      return returnValue;
    }
    var animateFill = {
      name: "animateFill",
      defaultValue: false,
      fn: function fn(instance) {
        var _instance$props$rende;

        // @ts-ignore
        if (
          !(
            (_instance$props$rende = instance.props.render) != null &&
            _instance$props$rende.$$tippy
          )
        ) {
          if (false) {
          }
          return {};
        }
        var _getChildren = getChildren(instance.popper),
          box = _getChildren.box,
          content = _getChildren.content;
        var backdrop = instance.props.animateFill
          ? createBackdropElement()
          : null;
        return {
          onCreate: function onCreate() {
            if (backdrop) {
              box.insertBefore(backdrop, box.firstElementChild);
              box.setAttribute("data-animatefill", "");
              box.style.overflow = "hidden";
              instance.setProps({
                arrow: false,
                animation: "shift-away",
              });
            }
          },
          onMount: function onMount() {
            if (backdrop) {
              var transitionDuration = box.style.transitionDuration;
              var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
              // tooltip element. `clip-path` is the other alternative but is not
              // well-supported and is buggy on some devices.

              content.style.transitionDelay = Math.round(duration / 10) + "ms";
              backdrop.style.transitionDuration = transitionDuration;
              setVisibilityState([backdrop], "visible");
            }
          },
          onShow: function onShow() {
            if (backdrop) {
              backdrop.style.transitionDuration = "0ms";
            }
          },
          onHide: function onHide() {
            if (backdrop) {
              setVisibilityState([backdrop], "hidden");
            }
          },
        };
      },
    };
    function createBackdropElement() {
      var backdrop = div();
      backdrop.className = BACKDROP_CLASS;
      setVisibilityState([backdrop], "hidden");
      return backdrop;
    }
    var mouseCoords = {
      clientX: 0,
      clientY: 0,
    };
    var activeInstances = [];
    function storeMouseCoords(_ref) {
      var clientX = _ref.clientX,
        clientY = _ref.clientY;
      mouseCoords = {
        clientX: clientX,
        clientY: clientY,
      };
    }
    function addMouseCoordsListener(doc) {
      doc.addEventListener("mousemove", storeMouseCoords);
    }
    function removeMouseCoordsListener(doc) {
      doc.removeEventListener("mousemove", storeMouseCoords);
    }
    var followCursor = {
      name: "followCursor",
      defaultValue: false,
      fn: function fn(instance) {
        var reference = instance.reference;
        var doc = getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
          return (
            instance.props.followCursor === "initial" &&
            instance.state.isVisible
          );
        }
        function addListener() {
          doc.addEventListener("mousemove", onMouseMove);
        }
        function removeListener() {
          doc.removeEventListener("mousemove", onMouseMove);
        }
        function unsetGetReferenceClientRect() {
          isInternalUpdate = true;
          instance.setProps({
            getReferenceClientRect: null,
          });
          isInternalUpdate = false;
        }
        function onMouseMove(event) {
          // If the instance is interactive, avoid updating the position unless it's
          // over the reference element
          var isCursorOverReference = event.target
            ? reference.contains(event.target)
            : true;
          var followCursor = instance.props.followCursor;
          var clientX = event.clientX,
            clientY = event.clientY;
          var rect = reference.getBoundingClientRect();
          var relativeX = clientX - rect.left;
          var relativeY = clientY - rect.top;
          if (isCursorOverReference || !instance.props.interactive) {
            instance.setProps({
              // @ts-ignore - unneeded DOMRect properties
              getReferenceClientRect: function getReferenceClientRect() {
                var rect = reference.getBoundingClientRect();
                var x = clientX;
                var y = clientY;
                if (followCursor === "initial") {
                  x = rect.left + relativeX;
                  y = rect.top + relativeY;
                }
                var top = followCursor === "horizontal" ? rect.top : y;
                var right = followCursor === "vertical" ? rect.right : x;
                var bottom = followCursor === "horizontal" ? rect.bottom : y;
                var left = followCursor === "vertical" ? rect.left : x;
                return {
                  width: right - left,
                  height: bottom - top,
                  top: top,
                  right: right,
                  bottom: bottom,
                  left: left,
                };
              },
            });
          }
        }
        function create() {
          if (instance.props.followCursor) {
            activeInstances.push({
              instance: instance,
              doc: doc,
            });
            addMouseCoordsListener(doc);
          }
        }
        function destroy() {
          activeInstances = activeInstances.filter(function (data) {
            return data.instance !== instance;
          });
          if (
            activeInstances.filter(function (data) {
              return data.doc === doc;
            }).length === 0
          ) {
            removeMouseCoordsListener(doc);
          }
        }
        return {
          onCreate: create,
          onDestroy: destroy,
          onBeforeUpdate: function onBeforeUpdate() {
            prevProps = instance.props;
          },
          onAfterUpdate: function onAfterUpdate(_, _ref2) {
            var followCursor = _ref2.followCursor;
            if (isInternalUpdate) {
              return;
            }
            if (
              followCursor !== undefined &&
              prevProps.followCursor !== followCursor
            ) {
              destroy();
              if (followCursor) {
                create();
                if (
                  instance.state.isMounted &&
                  !wasFocusEvent &&
                  !getIsInitialBehavior()
                ) {
                  addListener();
                }
              } else {
                removeListener();
                unsetGetReferenceClientRect();
              }
            }
          },
          onMount: function onMount() {
            if (instance.props.followCursor && !wasFocusEvent) {
              if (isUnmounted) {
                onMouseMove(mouseCoords);
                isUnmounted = false;
              }
              if (!getIsInitialBehavior()) {
                addListener();
              }
            }
          },
          onTrigger: function onTrigger(_, event) {
            if (isMouseEvent(event)) {
              mouseCoords = {
                clientX: event.clientX,
                clientY: event.clientY,
              };
            }
            wasFocusEvent = event.type === "focus";
          },
          onHidden: function onHidden() {
            if (instance.props.followCursor) {
              unsetGetReferenceClientRect();
              removeListener();
              isUnmounted = true;
            }
          },
        };
      },
    };
    function getProps(props, modifier) {
      var _props$popperOptions;
      return {
        popperOptions: Object.assign({}, props.popperOptions, {
          modifiers: [].concat(
            (
              ((_props$popperOptions = props.popperOptions) == null
                ? void 0
                : _props$popperOptions.modifiers) || []
            ).filter(function (_ref) {
              var name = _ref.name;
              return name !== modifier.name;
            }),
            [modifier]
          ),
        }),
      };
    }
    var inlinePositioning = {
      name: "inlinePositioning",
      defaultValue: false,
      fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
          return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
          name: "tippyInlinePositioning",
          enabled: true,
          phase: "afterWrite",
          fn: function fn(_ref2) {
            var state = _ref2.state;
            if (isEnabled()) {
              if (triedPlacements.indexOf(state.placement) !== -1) {
                triedPlacements = [];
              }
              if (
                placement !== state.placement &&
                triedPlacements.indexOf(state.placement) === -1
              ) {
                triedPlacements.push(state.placement);
                instance.setProps({
                  // @ts-ignore - unneeded DOMRect properties
                  getReferenceClientRect: function getReferenceClientRect() {
                    return _getReferenceClientRect(state.placement);
                  },
                });
              }
              placement = state.placement;
            }
          },
        };
        function _getReferenceClientRect(placement) {
          return getInlineBoundingClientRect(
            tippy_esm_getBasePlacement(placement),
            reference.getBoundingClientRect(),
            arrayFrom(reference.getClientRects()),
            cursorRectIndex
          );
        }
        function setInternalProps(partialProps) {
          isInternalUpdate = true;
          instance.setProps(partialProps);
          isInternalUpdate = false;
        }
        function addModifier() {
          if (!isInternalUpdate) {
            setInternalProps(getProps(instance.props, modifier));
          }
        }
        return {
          onCreate: addModifier,
          onAfterUpdate: addModifier,
          onTrigger: function onTrigger(_, event) {
            if (isMouseEvent(event)) {
              var rects = arrayFrom(instance.reference.getClientRects());
              var cursorRect = rects.find(function (rect) {
                return (
                  rect.left - 2 <= event.clientX &&
                  rect.right + 2 >= event.clientX &&
                  rect.top - 2 <= event.clientY &&
                  rect.bottom + 2 >= event.clientY
                );
              });
              var index = rects.indexOf(cursorRect);
              cursorRectIndex = index > -1 ? index : cursorRectIndex;
            }
          },
          onHidden: function onHidden() {
            cursorRectIndex = -1;
          },
        };
      },
    };
    function getInlineBoundingClientRect(
      currentBasePlacement,
      boundingRect,
      clientRects,
      cursorRectIndex
    ) {
      // Not an inline element, or placement is not yet known
      if (clientRects.length < 2 || currentBasePlacement === null) {
        return boundingRect;
      } // There are two rects and they are disjoined

      if (
        clientRects.length === 2 &&
        cursorRectIndex >= 0 &&
        clientRects[0].left > clientRects[1].right
      ) {
        return clientRects[cursorRectIndex] || boundingRect;
      }
      switch (currentBasePlacement) {
        case "top":
        case "bottom": {
          var firstRect = clientRects[0];
          var lastRect = clientRects[clientRects.length - 1];
          var isTop = currentBasePlacement === "top";
          var top = firstRect.top;
          var bottom = lastRect.bottom;
          var left = isTop ? firstRect.left : lastRect.left;
          var right = isTop ? firstRect.right : lastRect.right;
          var width = right - left;
          var height = bottom - top;
          return {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            width: width,
            height: height,
          };
        }
        case "left":
        case "right": {
          var minLeft = Math.min.apply(
            Math,
            clientRects.map(function (rects) {
              return rects.left;
            })
          );
          var maxRight = Math.max.apply(
            Math,
            clientRects.map(function (rects) {
              return rects.right;
            })
          );
          var measureRects = clientRects.filter(function (rect) {
            return currentBasePlacement === "left"
              ? rect.left === minLeft
              : rect.right === maxRight;
          });
          var _top = measureRects[0].top;
          var _bottom = measureRects[measureRects.length - 1].bottom;
          var _left = minLeft;
          var _right = maxRight;
          var _width = _right - _left;
          var _height = _bottom - _top;
          return {
            top: _top,
            bottom: _bottom,
            left: _left,
            right: _right,
            width: _width,
            height: _height,
          };
        }
        default: {
          return boundingRect;
        }
      }
    }
    var sticky = {
      name: "sticky",
      defaultValue: false,
      fn: function fn(instance) {
        var reference = instance.reference,
          popper = instance.popper;
        function getReference() {
          return instance.popperInstance
            ? instance.popperInstance.state.elements.reference
            : reference;
        }
        function shouldCheck(value) {
          return (
            instance.props.sticky === true || instance.props.sticky === value
          );
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
          var currentRefRect = shouldCheck("reference")
            ? getReference().getBoundingClientRect()
            : null;
          var currentPopRect = shouldCheck("popper")
            ? popper.getBoundingClientRect()
            : null;
          if (
            (currentRefRect &&
              areRectsDifferent(prevRefRect, currentRefRect)) ||
            (currentPopRect && areRectsDifferent(prevPopRect, currentPopRect))
          ) {
            if (instance.popperInstance) {
              instance.popperInstance.update();
            }
          }
          prevRefRect = currentRefRect;
          prevPopRect = currentPopRect;
          if (instance.state.isMounted) {
            requestAnimationFrame(updatePosition);
          }
        }
        return {
          onMount: function onMount() {
            if (instance.props.sticky) {
              updatePosition();
            }
          },
        };
      },
    };
    function areRectsDifferent(rectA, rectB) {
      if (rectA && rectB) {
        return (
          rectA.top !== rectB.top ||
          rectA.right !== rectB.right ||
          rectA.bottom !== rectB.bottom ||
          rectA.left !== rectB.left
        );
      }
      return true;
    }
    tippy.setDefaultProps({
      render: render,
    });
    /* harmony default export */ const tippy_esm = tippy; // CONCATENATED MODULE: ./node_modules/tippy.js/animations/shift-toward.css // CONCATENATED MODULE: ./node_modules/tippy.js/dist/tippy.css // CONCATENATED MODULE: ./src/js/vendor.js

    // extracted by mini-css-extract-plugin

    // extracted by mini-css-extract-plugin

    /* provided dependency */ var MinimogLibs = __webpack_require__(272)["gM"];
    /* provided dependency */ var MinimogTheme = __webpack_require__(272)["LE"];
    /* eslint-disable no-undef */
    // Import styles by module
    // Core API + modules:

    MinimogLibs.Swiper = core;
    MinimogLibs.Swiper.Thumbs = Thumb;
    MinimogLibs.Swiper.Navigation = Navigation;
    MinimogLibs.Swiper.Pagination = Pagination;
    MinimogLibs.Swiper.Manipulation = Manipulation;
    MinimogLibs.Swiper.Grid = Grid;
    MinimogLibs.Swiper.Autoplay = Autoplay;
    MinimogLibs.Swiper.EffectFade = EffectFade;
    MinimogLibs.AnimateLoading = main_default();
    MinimogLibs.Accordion = Accordion;
    MinimogLibs.Tooltip = tippy_esm;
    MinimogTheme.Modal = modal;
    MinimogTheme.scrollIntoView = scrollIntoView_default();
    MinimogTheme.Notification = new Notification();
  })();

  /******/
})();
